const transactions = [
  {
    id: '063097bf-2946-4eda-964e-db7f4e7b7376',
    currency: 'ICS',
    amount: 7976.018164,
    user: '4',
    date: '2024-09-08T10:21:15Z',
    status: 'completed',
  },
  {
    id: '1b539612-5c96-49cf-80cb-9fb76fc625bc',
    currency: 'GCS',
    amount: -8909.436319,
    user: '80',
    date: '2024-10-13T19:39:13Z',
    status: 'inProgress',
  },
  {
    id: '1c3328ab-53c3-4f8e-a16a-a81c5e2a9819',
    currency: 'GCS',
    amount: 4679.620218,
    user: '16',
    date: '2024-11-27T10:18:55Z',
    status: 'blocked',
  },
  {
    id: '9b2f5578-e6cc-4bb4-b8b7-7571ba6a3a0d',
    currency: 'GCS',
    amount: 2728.512701,
    user: '14',
    date: '2024-07-03T19:17:44Z',
    status: 'inProgress',
  },
  {
    id: '83c4109e-375c-419f-b083-f86e9bd1bce5',
    currency: 'ICS',
    amount: 1864.219787,
    user: '15',
    date: '2024-10-07T16:37:04Z',
    status: 'inProgress',
  },
  {
    id: '3db37986-6e93-47f0-bda9-a855095c17d0',
    currency: 'GCS',
    amount: 836.22047,
    user: '16',
    date: '2024-03-27T19:30:41Z',
    status: 'blocked',
  },
  {
    id: 'e00840fd-38c4-462a-8599-9d628829a506',
    currency: 'GCS',
    amount: 6486.768202,
    user: '78',
    date: '2024-09-25T08:43:33Z',
    status: 'completed',
  },
  {
    id: '18e3cf33-8cd7-470b-be75-c36dba69aaaf',
    currency: 'GCS',
    amount: -3172.634529,
    user: '37',
    date: '2024-04-05T09:41:25Z',
    status: 'blocked',
  },
  {
    id: '192e1481-acaf-418e-9b58-405e2b7b9162',
    currency: 'ICS',
    amount: 2937.277614,
    user: '60',
    date: '2024-01-08T00:12:37Z',
    status: 'inProgress',
  },
  {
    id: '0b750216-9eb8-4b00-ab1d-90a341028c42',
    currency: 'GCS',
    amount: 5453.621439,
    user: '35',
    date: '2024-05-08T04:45:42Z',
    status: 'completed',
  },
  {
    id: 'cb6ba5bb-8fef-4013-a900-fad70c81a27d',
    currency: 'GCS',
    amount: -2485.279144,
    user: '57',
    date: '2024-05-01T23:03:47Z',
    status: 'blocked',
  },
  {
    id: 'a4374600-2ce6-4cf8-8029-86a218b3b344',
    currency: 'GCS',
    amount: -295.129426,
    user: '75',
    date: '2024-08-22T14:05:20Z',
    status: 'completed',
  },
  {
    id: 'fac89aca-3802-4894-adb7-ceeb1d5c7e2d',
    currency: 'GCS',
    amount: 9490.671511,
    user: '12',
    date: '2024-11-20T04:32:32Z',
    status: 'inProgress',
  },
  {
    id: '14206cc7-3e07-40c4-8d60-34242652e8e9',
    currency: 'ICS',
    amount: 5878.766524,
    user: '36',
    date: '2024-09-02T01:52:40Z',
    status: 'inProgress',
  },
  {
    id: '42bab7b8-4eb5-4493-ab16-33b7b9321011',
    currency: 'ICS',
    amount: 6624.023628,
    user: '52',
    date: '2024-08-27T08:53:44Z',
    status: 'completed',
  },
  {
    id: 'a06ad1e3-a743-4a1d-8aef-0b8c95f4f8ef',
    currency: 'GCS',
    amount: -3005.594205,
    user: '62',
    date: '2024-05-28T12:18:22Z',
    status: 'completed',
  },
  {
    id: 'b3abe3c6-49ff-4fc2-b7ce-27bb96e18d29',
    currency: 'GCS',
    amount: 869.357798,
    user: '62',
    date: '2024-03-05T12:12:48Z',
    status: 'blocked',
  },
  {
    id: 'c0ebae0f-50ad-4d82-98b6-9a186ec12944',
    currency: 'ICS',
    amount: 4671.933351,
    user: '53',
    date: '2024-08-19T06:16:11Z',
    status: 'blocked',
  },
  {
    id: '98e1878f-3f8c-4478-9b36-d64fa3b9248a',
    currency: 'ICS',
    amount: -5525.968791,
    user: '70',
    date: '2024-09-02T15:32:03Z',
    status: 'completed',
  },
  {
    id: '63d2376c-45bc-4f31-8650-aa55b8c92020',
    currency: 'ICS',
    amount: 2471.951532,
    user: '31',
    date: '2024-07-19T22:44:23Z',
    status: 'completed',
  },
  {
    id: 'e226013d-4006-4c35-8b48-9fb4a7e368a7',
    currency: 'ICS',
    amount: -6658.663269,
    user: '41',
    date: '2024-02-16T16:57:15Z',
    status: 'blocked',
  },
  {
    id: 'edeaeb52-f4f3-4277-aae0-95fed5a81157',
    currency: 'ICS',
    amount: 6571.210694,
    user: '66',
    date: '2024-02-16T04:55:57Z',
    status: 'completed',
  },
  {
    id: '33bc1e58-1c96-4c37-a2b7-d8afb97bb014',
    currency: 'GCS',
    amount: -9885.533125,
    user: '33',
    date: '2024-10-05T16:48:23Z',
    status: 'inProgress',
  },
  {
    id: 'ff48d916-ea9e-436b-a634-88ecb418e315',
    currency: 'ICS',
    amount: -8015.500202,
    user: '25',
    date: '2024-11-10T19:51:46Z',
    status: 'blocked',
  },
  {
    id: '17d7a399-86d9-4d1c-802b-3c64a1ad6b22',
    currency: 'ICS',
    amount: -586.75038,
    user: '15',
    date: '2024-12-29T22:56:45Z',
    status: 'inProgress',
  },
  {
    id: '6dfa6782-11f0-4a5b-81cc-7b7c985d59c6',
    currency: 'ICS',
    amount: -7766.376219,
    user: '63',
    date: '2024-10-11T16:48:46Z',
    status: 'inProgress',
  },
  {
    id: 'c0bb068a-6bff-464c-b5c6-6fcecc749da0',
    currency: 'GCS',
    amount: 836.53799,
    user: '51',
    date: '2024-02-28T14:51:23Z',
    status: 'inProgress',
  },
  {
    id: '74e687eb-0425-4859-b60b-123ddf7f9684',
    currency: 'GCS',
    amount: 1625.081725,
    user: '2',
    date: '2024-03-11T16:32:20Z',
    status: 'blocked',
  },
  {
    id: 'f7768793-05db-49d7-b4c9-e3a0abfa2c8b',
    currency: 'ICS',
    amount: 8281.406141,
    user: '2',
    date: '2024-09-07T12:31:45Z',
    status: 'blocked',
  },
  {
    id: 'ee17f687-2cb7-436f-816f-c86e9e0256a3',
    currency: 'ICS',
    amount: -3630.195319,
    user: '21',
    date: '2024-10-26T13:27:15Z',
    status: 'blocked',
  },
  {
    id: '97f59fa5-6a22-4a50-96da-7326984a58a4',
    currency: 'ICS',
    amount: 2645.513058,
    user: '72',
    date: '2024-03-09T06:55:32Z',
    status: 'inProgress',
  },
  {
    id: 'cecbfc62-0fe7-410a-ad82-613c044e2aae',
    currency: 'GCS',
    amount: -4361.006861,
    user: '41',
    date: '2024-09-18T15:41:31Z',
    status: 'blocked',
  },
  {
    id: '52d407ad-ef55-46b1-b890-17f59f6ceb93',
    currency: 'ICS',
    amount: 6304.370349,
    user: '79',
    date: '2024-02-19T21:21:44Z',
    status: 'blocked',
  },
  {
    id: 'a5905927-9c39-46e4-aeac-99b08bb02547',
    currency: 'GCS',
    amount: -4600.374996,
    user: '12',
    date: '2024-02-25T15:24:37Z',
    status: 'completed',
  },
  {
    id: '0bc44d29-ce66-43a9-8eb9-ed276f712a73',
    currency: 'GCS',
    amount: -1683.885956,
    user: '7',
    date: '2024-12-21T10:17:41Z',
    status: 'completed',
  },
  {
    id: 'd1b1b8be-60a4-46b0-9359-eb82dca535a8',
    currency: 'ICS',
    amount: 4004.133963,
    user: '46',
    date: '2024-08-07T17:35:43Z',
    status: 'completed',
  },
  {
    id: '301009f7-15e8-4985-92d5-0a61dfda44c4',
    currency: 'GCS',
    amount: -1203.348021,
    user: '52',
    date: '2024-08-18T16:43:21Z',
    status: 'blocked',
  },
  {
    id: '71de4440-c405-4a3e-a98c-57fe55108a7f',
    currency: 'ICS',
    amount: -3901.810401,
    user: '26',
    date: '2024-06-26T20:57:25Z',
    status: 'completed',
  },
  {
    id: 'd5a13d5f-63bf-4ad2-be48-0deaff12e1ab',
    currency: 'GCS',
    amount: 5113.404893,
    user: '66',
    date: '2024-04-30T17:43:00Z',
    status: 'inProgress',
  },
  {
    id: '3c012400-9886-4a80-b39d-7a3271bdeaa5',
    currency: 'GCS',
    amount: 669.040514,
    user: '21',
    date: '2024-09-19T22:05:07Z',
    status: 'inProgress',
  },
  {
    id: 'eb00af55-dc5b-4640-9a49-19675fd4ef64',
    currency: 'GCS',
    amount: 2034.198835,
    user: '7',
    date: '2024-04-15T20:09:15Z',
    status: 'inProgress',
  },
  {
    id: '19f0bb0c-8091-457d-8759-6b5483be33f3',
    currency: 'GCS',
    amount: 3410.280809,
    user: '16',
    date: '2024-04-09T02:08:34Z',
    status: 'blocked',
  },
  {
    id: 'a35884f9-4ebe-4d6b-8e79-95056db83729',
    currency: 'GCS',
    amount: -9043.441222,
    user: '5',
    date: '2024-02-01T09:06:26Z',
    status: 'completed',
  },
  {
    id: '0e2daa39-61c0-46ba-a623-0b1db4740cf6',
    currency: 'ICS',
    amount: -7391.472799,
    user: '29',
    date: '2024-05-29T12:30:53Z',
    status: 'blocked',
  },
  {
    id: '78d3fd4b-72ff-4a34-98c0-a4516d7f903b',
    currency: 'ICS',
    amount: 5667.203726,
    user: '3',
    date: '2024-10-25T02:42:04Z',
    status: 'blocked',
  },
  {
    id: '36d66086-5f2a-4cbf-8a2e-d6e4ef5c35f2',
    currency: 'GCS',
    amount: -6404.428755,
    user: '51',
    date: '2024-03-17T03:25:12Z',
    status: 'inProgress',
  },
  {
    id: '2416bb11-eb03-4dc0-a247-c527b5a39881',
    currency: 'GCS',
    amount: 5236.820407,
    user: '46',
    date: '2024-03-01T00:00:05Z',
    status: 'completed',
  },
  {
    id: '7c18283d-ac73-4aaa-863d-b0a8395eb3e8',
    currency: 'GCS',
    amount: 1739.009065,
    user: '57',
    date: '2024-12-25T20:31:16Z',
    status: 'blocked',
  },
  {
    id: 'e2950a85-8e40-413a-8d89-19d817942eb9',
    currency: 'GCS',
    amount: 5986.957415,
    user: '69',
    date: '2024-07-29T05:52:47Z',
    status: 'inProgress',
  },
  {
    id: 'c3751afb-55f5-425f-b143-ea105e234aa9',
    currency: 'ICS',
    amount: -7096.067245,
    user: '29',
    date: '2024-03-15T18:48:17Z',
    status: 'blocked',
  },
  {
    id: 'c6634908-abb9-411f-8bcb-5df72efaf4a8',
    currency: 'ICS',
    amount: -9370.350092,
    user: '77',
    date: '2024-05-15T22:17:49Z',
    status: 'blocked',
  },
  {
    id: 'fdbd1aa2-9b7a-4c5d-a952-8f334de5e7f4',
    currency: 'ICS',
    amount: 813.998828,
    user: '73',
    date: '2024-02-02T23:07:52Z',
    status: 'blocked',
  },
  {
    id: '65c62dc3-59d3-43f1-afcf-1772da3aa965',
    currency: 'ICS',
    amount: 1008.312727,
    user: '27',
    date: '2024-02-23T23:29:43Z',
    status: 'inProgress',
  },
  {
    id: '45381e0e-0150-4cf6-9929-b62834fc4d34',
    currency: 'ICS',
    amount: 4317.125047,
    user: '23',
    date: '2024-11-30T09:59:20Z',
    status: 'completed',
  },
  {
    id: '51e1e558-75a4-42fd-a753-c10112f6b5f0',
    currency: 'ICS',
    amount: 8721.337966,
    user: '9',
    date: '2024-06-24T10:34:07Z',
    status: 'inProgress',
  },
  {
    id: 'ccee83f0-d332-404f-a99b-ac202dd82f83',
    currency: 'GCS',
    amount: -4532.836707,
    user: '79',
    date: '2024-08-26T06:33:08Z',
    status: 'completed',
  },
  {
    id: 'f0966259-013f-4c48-9712-433e9e9814ff',
    currency: 'ICS',
    amount: -6200.721803,
    user: '78',
    date: '2024-08-13T12:56:47Z',
    status: 'inProgress',
  },
  {
    id: '12665aff-70db-49e1-bbe2-8e23ea731262',
    currency: 'GCS',
    amount: -2737.487152,
    user: '24',
    date: '2024-08-29T20:40:55Z',
    status: 'inProgress',
  },
  {
    id: '8e73d823-b2a4-4e4a-acd6-cfbb656fc795',
    currency: 'GCS',
    amount: -7229.88335,
    user: '17',
    date: '2024-02-11T10:44:17Z',
    status: 'inProgress',
  },
  {
    id: 'df92b08b-9268-4c9c-8c08-8f65961eff98',
    currency: 'ICS',
    amount: -3810.534591,
    user: '49',
    date: '2024-06-04T14:49:36Z',
    status: 'blocked',
  },
  {
    id: 'e00876f9-073b-4bb7-b52e-f5a1a70802b2',
    currency: 'GCS',
    amount: -5319.447269,
    user: '56',
    date: '2024-01-03T21:18:25Z',
    status: 'inProgress',
  },
  {
    id: 'a080d8f5-04fe-4f20-8823-98f65b91ea57',
    currency: 'GCS',
    amount: 1862.221183,
    user: '48',
    date: '2024-10-03T05:15:38Z',
    status: 'completed',
  },
  {
    id: '65c2dd14-239d-493e-ba85-1f918ded53de',
    currency: 'GCS',
    amount: -4978.343776,
    user: '47',
    date: '2024-09-30T01:09:36Z',
    status: 'completed',
  },
  {
    id: '58a7fcc6-d944-4007-99f1-b8e8e5674a35',
    currency: 'ICS',
    amount: -8978.726051,
    user: '21',
    date: '2024-10-25T08:35:34Z',
    status: 'inProgress',
  },
  {
    id: 'e2352c73-78fa-4d00-8a8c-f1ecb9ced951',
    currency: 'GCS',
    amount: -7915.1977,
    user: '28',
    date: '2024-07-11T23:55:58Z',
    status: 'blocked',
  },
  {
    id: '049415fd-ecec-410b-915b-13e089af1365',
    currency: 'ICS',
    amount: -9283.540434,
    user: '33',
    date: '2024-10-28T03:58:53Z',
    status: 'blocked',
  },
  {
    id: '2c3ab76e-3841-48ab-9eab-2cbdac4272c2',
    currency: 'ICS',
    amount: 1943.89453,
    user: '44',
    date: '2024-11-25T22:05:43Z',
    status: 'blocked',
  },
  {
    id: '24b7844c-88a3-41fb-ba5a-f9ca8b4d5e55',
    currency: 'ICS',
    amount: 4351.591975,
    user: '18',
    date: '2024-07-25T00:27:19Z',
    status: 'inProgress',
  },
  {
    id: 'f06f6b7d-8838-431e-bd02-3254dc4de446',
    currency: 'GCS',
    amount: -509.071679,
    user: '81',
    date: '2024-03-14T22:51:38Z',
    status: 'completed',
  },
  {
    id: '80812c9a-bf81-43d5-bce5-28ab92971567',
    currency: 'ICS',
    amount: 1305.139215,
    user: '74',
    date: '2024-03-12T11:01:33Z',
    status: 'completed',
  },
  {
    id: 'ee5d62cb-f004-4be4-b67e-a3fc4056c13f',
    currency: 'ICS',
    amount: 7398.277598,
    user: '48',
    date: '2024-05-25T22:28:35Z',
    status: 'blocked',
  },
  {
    id: 'cad8d2e7-ac69-4ac9-9525-9166a6dbd517',
    currency: 'GCS',
    amount: -8686.264541,
    user: '63',
    date: '2024-02-13T23:41:55Z',
    status: 'completed',
  },
  {
    id: 'c88dac33-455e-4caf-88a1-9c553086fda1',
    currency: 'ICS',
    amount: -2164.445672,
    user: '24',
    date: '2024-12-27T19:29:31Z',
    status: 'inProgress',
  },
  {
    id: '9a267ba4-1ba1-4063-a641-d546ac6336e2',
    currency: 'ICS',
    amount: -2163.971204,
    user: '83',
    date: '2024-06-29T10:46:36Z',
    status: 'inProgress',
  },
  {
    id: '756ce678-2cbc-4ee0-be92-ed9710c2657c',
    currency: 'GCS',
    amount: -9394.470816,
    user: '68',
    date: '2024-04-06T17:11:23Z',
    status: 'completed',
  },
  {
    id: 'a7eff4d5-d1c7-42a0-8b5a-4df20a08ace0',
    currency: 'ICS',
    amount: -463.092149,
    user: '36',
    date: '2024-10-03T21:36:26Z',
    status: 'inProgress',
  },
  {
    id: '8460b081-e18e-4ba5-ac89-cbdfa77414eb',
    currency: 'GCS',
    amount: -6094.93762,
    user: '69',
    date: '2024-09-14T13:39:30Z',
    status: 'inProgress',
  },
  {
    id: '3706739b-e6cd-40fe-9261-b5c9d39181a4',
    currency: 'GCS',
    amount: 5524.702262,
    user: '19',
    date: '2024-06-17T20:06:57Z',
    status: 'blocked',
  },
  {
    id: '4d692c57-825b-4db5-ad54-5fcd1bae8f3c',
    currency: 'GCS',
    amount: -2615.852485,
    user: '44',
    date: '2024-01-03T01:55:21Z',
    status: 'blocked',
  },
  {
    id: '09aead01-3e65-4ac2-880f-04b2aab907d3',
    currency: 'ICS',
    amount: 7543.970473,
    user: '63',
    date: '2024-01-22T02:47:58Z',
    status: 'inProgress',
  },
  {
    id: 'ae71a82e-adce-4728-9c5c-3b9068236127',
    currency: 'ICS',
    amount: -6747.83905,
    user: '54',
    date: '2024-09-06T14:50:21Z',
    status: 'completed',
  },
  {
    id: '88ccf570-51f5-4c1a-a16f-c10fb4c7e523',
    currency: 'GCS',
    amount: -6217.288602,
    user: '24',
    date: '2024-10-03T10:42:32Z',
    status: 'completed',
  },
  {
    id: 'be4e4971-bde3-4a77-b306-812796e77fff',
    currency: 'ICS',
    amount: 813.778988,
    user: '18',
    date: '2024-04-15T11:15:17Z',
    status: 'inProgress',
  },
  {
    id: '88ec3df7-df4b-4f7b-9377-ab8213ca2704',
    currency: 'GCS',
    amount: 7400.354642,
    user: '68',
    date: '2024-10-14T06:39:14Z',
    status: 'inProgress',
  },
  {
    id: '7eda3de5-aafe-4bec-9560-f3a4c693f0f3',
    currency: 'GCS',
    amount: -7995.791215,
    user: '69',
    date: '2024-07-02T18:11:37Z',
    status: 'inProgress',
  },
  {
    id: 'e8e5e57d-1486-41b2-9db9-fc5e1ffac15d',
    currency: 'GCS',
    amount: -9005.947615,
    user: '21',
    date: '2024-08-31T15:29:42Z',
    status: 'completed',
  },
  {
    id: 'a7a4f662-b6cf-48c8-8444-58f823d50273',
    currency: 'GCS',
    amount: -3392.453626,
    user: '61',
    date: '2024-06-21T14:49:38Z',
    status: 'inProgress',
  },
  {
    id: '0891bd0f-725b-473e-a380-f1fa7858fcab',
    currency: 'GCS',
    amount: 4158.017797,
    user: '27',
    date: '2024-01-10T18:31:12Z',
    status: 'blocked',
  },
  {
    id: '671dba76-9f46-4ea5-a0ad-a945684d7d9c',
    currency: 'ICS',
    amount: -8533.165883,
    user: '65',
    date: '2024-10-21T17:17:14Z',
    status: 'blocked',
  },
  {
    id: '8c0fce7d-e4f6-41f2-8698-402b431faecd',
    currency: 'GCS',
    amount: -4792.581565,
    user: '18',
    date: '2024-11-06T17:25:50Z',
    status: 'inProgress',
  },
  {
    id: 'bffef486-2702-483f-baae-4d8632d94084',
    currency: 'ICS',
    amount: -8502.830691,
    user: '20',
    date: '2024-04-02T04:12:11Z',
    status: 'completed',
  },
  {
    id: '30f59329-aa0b-4d44-b871-8162225a741d',
    currency: 'GCS',
    amount: -2852.887904,
    user: '49',
    date: '2024-11-19T00:32:29Z',
    status: 'completed',
  },
  {
    id: 'f4bb7397-cd7b-438a-9d67-43ddde9526d6',
    currency: 'GCS',
    amount: 9376.969463,
    user: '27',
    date: '2024-11-05T15:16:01Z',
    status: 'completed',
  },
  {
    id: '4d281d39-fe72-4501-b038-8c4f3bda9f48',
    currency: 'GCS',
    amount: 9248.869599,
    user: '11',
    date: '2024-06-02T22:58:15Z',
    status: 'blocked',
  },
  {
    id: 'c1b52260-b957-4070-8e9e-b4cc6dd8e86e',
    currency: 'GCS',
    amount: -6541.568951,
    user: '81',
    date: '2024-04-10T23:05:59Z',
    status: 'completed',
  },
  {
    id: '14538091-4eaf-4ffb-a545-af53fa64054a',
    currency: 'ICS',
    amount: 4184.608985,
    user: '50',
    date: '2024-03-17T15:39:47Z',
    status: 'inProgress',
  },
  {
    id: 'd73a7bdb-9bd2-465e-acd3-bd57c8f7ddc1',
    currency: 'ICS',
    amount: -8325.23625,
    user: '35',
    date: '2024-07-24T00:30:51Z',
    status: 'completed',
  },
  {
    id: 'd82c1194-b040-42c5-8f73-434f86c1a010',
    currency: 'ICS',
    amount: -2699.671003,
    user: '26',
    date: '2024-06-18T10:52:25Z',
    status: 'completed',
  },
  {
    id: 'a356405d-7705-4bc8-8fe0-bf6c3623c36d',
    currency: 'ICS',
    amount: -2282.046339,
    user: '12',
    date: '2024-12-30T01:03:12Z',
    status: 'completed',
  },
  {
    id: '910b194b-3e01-4b6f-87e0-9b00483c7164',
    currency: 'ICS',
    amount: 3002.868,
    user: '35',
    date: '2024-06-17T21:52:33Z',
    status: 'completed',
  },
  {
    id: 'c1fbdac7-eb53-4e66-b8bc-a06322f1a6d3',
    currency: 'ICS',
    amount: 9437.463558,
    user: '15',
    date: '2024-02-27T02:30:41Z',
    status: 'completed',
  },
  {
    id: '0c526c6a-bfda-4e9c-92eb-1d19a1db2749',
    currency: 'ICS',
    amount: -1491.338379,
    user: '39',
    date: '2024-04-11T08:10:15Z',
    status: 'completed',
  },
  {
    id: 'a4128d0f-68a7-4389-84b4-a017c5cb741a',
    currency: 'ICS',
    amount: -5986.11848,
    user: '26',
    date: '2024-07-13T16:20:03Z',
    status: 'blocked',
  },
  {
    id: '75aa48b9-113a-48ca-9ef9-b6ab7a5b0b0c',
    currency: 'GCS',
    amount: -8580.587461,
    user: '82',
    date: '2024-01-01T03:45:32Z',
    status: 'completed',
  },
  {
    id: 'c9837575-5dc2-4f20-a665-f71a59a51080',
    currency: 'ICS',
    amount: -1200.766364,
    user: '41',
    date: '2024-11-03T21:43:21Z',
    status: 'inProgress',
  },
  {
    id: '6f5f2e8c-f768-4a01-9df7-e5db0bd3aed2',
    currency: 'ICS',
    amount: 7237.44312,
    user: '80',
    date: '2024-05-10T10:56:26Z',
    status: 'blocked',
  },
  {
    id: '7e4834af-e7ce-47a4-8503-f867be05048b',
    currency: 'ICS',
    amount: -1342.519246,
    user: '78',
    date: '2024-10-20T00:03:30Z',
    status: 'completed',
  },
  {
    id: '1e5274b9-cf33-40dc-a464-e858a755b893',
    currency: 'ICS',
    amount: -3755.70065,
    user: '37',
    date: '2024-06-27T12:24:00Z',
    status: 'blocked',
  },
  {
    id: '3c1ae0ea-3711-4bea-8f7a-021391ca29c2',
    currency: 'ICS',
    amount: -2282.900638,
    user: '48',
    date: '2024-05-05T22:07:51Z',
    status: 'completed',
  },
  {
    id: '3abfcb98-78a4-4383-b84f-9c0d03190d18',
    currency: 'ICS',
    amount: -5461.28083,
    user: '30',
    date: '2024-11-11T23:06:14Z',
    status: 'completed',
  },
  {
    id: 'dbfee2ac-88ae-4c86-a275-c45c000d0769',
    currency: 'GCS',
    amount: 5161.710247,
    user: '75',
    date: '2024-05-05T14:01:48Z',
    status: 'blocked',
  },
  {
    id: '9e621c76-51f9-44fe-a7fa-16e0095f1dda',
    currency: 'GCS',
    amount: 1375.491701,
    user: '19',
    date: '2024-11-24T09:06:59Z',
    status: 'completed',
  },
  {
    id: '44d7ba61-d5b6-4492-97ba-bfdece432283',
    currency: 'ICS',
    amount: -137.528746,
    user: '52',
    date: '2024-05-16T04:38:58Z',
    status: 'inProgress',
  },
  {
    id: '0e047906-be80-4024-b693-19609b8f0a2e',
    currency: 'GCS',
    amount: 6945.065099,
    user: '47',
    date: '2024-07-08T07:34:28Z',
    status: 'completed',
  },
  {
    id: '594149f2-76a6-4039-87eb-ed3406822e41',
    currency: 'ICS',
    amount: 3541.139938,
    user: '56',
    date: '2024-09-16T16:53:37Z',
    status: 'completed',
  },
  {
    id: '75707513-c3f8-4ae9-b1c7-5ead71c71caf',
    currency: 'GCS',
    amount: 5965.834962,
    user: '2',
    date: '2024-05-07T07:17:38Z',
    status: 'blocked',
  },
  {
    id: '9be6ab35-089f-4f1e-943c-b70e8f37c2e5',
    currency: 'GCS',
    amount: 9664.368434,
    user: '60',
    date: '2024-09-23T09:16:37Z',
    status: 'inProgress',
  },
  {
    id: '8fee6c68-0e7a-4297-ad7d-dbd8358b76da',
    currency: 'ICS',
    amount: -9266.320711,
    user: '4',
    date: '2024-04-24T16:28:24Z',
    status: 'inProgress',
  },
  {
    id: 'a8fccd9e-ed64-48c0-937e-af45fafec004',
    currency: 'GCS',
    amount: 3300.6582,
    user: '57',
    date: '2024-06-18T01:04:20Z',
    status: 'blocked',
  },
  {
    id: '740b601b-f8f7-400e-a72f-45d3534c65e9',
    currency: 'GCS',
    amount: 5375.458368,
    user: '14',
    date: '2024-03-19T04:24:14Z',
    status: 'completed',
  },
  {
    id: '1542991d-9d58-4066-8086-fdc997cce9bd',
    currency: 'GCS',
    amount: 6752.424639,
    user: '79',
    date: '2024-10-03T21:15:10Z',
    status: 'inProgress',
  },
  {
    id: 'dd9eb733-9174-4dc4-bca0-0d1dd4b49379',
    currency: 'ICS',
    amount: -4148.05516,
    user: '74',
    date: '2024-10-08T11:45:38Z',
    status: 'inProgress',
  },
  {
    id: '2f78522c-5d4b-45f1-8e23-bab5a039c69a',
    currency: 'GCS',
    amount: -3885.248363,
    user: '22',
    date: '2024-09-01T13:09:05Z',
    status: 'completed',
  },
  {
    id: 'c8f28d8f-0700-4f29-ba79-6cc3bba0a33e',
    currency: 'ICS',
    amount: -7634.697293,
    user: '82',
    date: '2024-10-27T10:51:11Z',
    status: 'completed',
  },
  {
    id: '7856a610-2e61-40ad-8825-17c32aeac56f',
    currency: 'ICS',
    amount: -7850.080075,
    user: '30',
    date: '2024-06-25T22:55:36Z',
    status: 'blocked',
  },
  {
    id: '69e9fe7b-c128-4586-821b-105cd2cf92e7',
    currency: 'ICS',
    amount: -4437.325267,
    user: '71',
    date: '2024-01-05T15:32:36Z',
    status: 'blocked',
  },
  {
    id: '830db1c6-bfea-42d9-aea8-e1a10fb8c35e',
    currency: 'GCS',
    amount: -2478.997058,
    user: '63',
    date: '2024-10-03T19:44:20Z',
    status: 'completed',
  },
  {
    id: '8959b06c-f443-4975-b5ee-03957e15a4b9',
    currency: 'GCS',
    amount: 3669.79426,
    user: '50',
    date: '2024-08-02T13:13:40Z',
    status: 'blocked',
  },
  {
    id: '7a7b6f69-c013-45a3-a2ca-37b5a84198a5',
    currency: 'ICS',
    amount: 876.049698,
    user: '21',
    date: '2024-02-20T15:47:34Z',
    status: 'completed',
  },
  {
    id: '6868b21c-27f8-437e-8657-30fd1f1da0e9',
    currency: 'GCS',
    amount: -6978.82598,
    user: '76',
    date: '2024-09-14T12:08:06Z',
    status: 'completed',
  },
  {
    id: '7483fd61-4ef1-424d-ae37-53ee02c0bbc1',
    currency: 'GCS',
    amount: -6099.099736,
    user: '50',
    date: '2024-08-04T16:45:17Z',
    status: 'blocked',
  },
  {
    id: 'a117e1fa-70d6-4b7d-839d-502006983af1',
    currency: 'GCS',
    amount: -7595.882039,
    user: '56',
    date: '2024-01-14T19:04:59Z',
    status: 'blocked',
  },
  {
    id: 'e459b2de-4dbf-49b4-b5f0-42a56a61d701',
    currency: 'ICS',
    amount: -7498.587967,
    user: '65',
    date: '2024-06-15T18:26:37Z',
    status: 'inProgress',
  },
  {
    id: 'b7bad4c4-cc25-4b5a-b316-9ec4722d1c63',
    currency: 'ICS',
    amount: 2581.323859,
    user: '21',
    date: '2024-01-19T12:45:58Z',
    status: 'inProgress',
  },
  {
    id: '1f3d1924-5b56-4ee1-ba06-924641b56e46',
    currency: 'GCS',
    amount: -5703.582738,
    user: '23',
    date: '2024-12-12T08:47:47Z',
    status: 'completed',
  },
  {
    id: 'bb4c6e4b-5927-4e72-b384-d333183e61f9',
    currency: 'GCS',
    amount: -515.6412,
    user: '12',
    date: '2024-05-13T07:44:46Z',
    status: 'inProgress',
  },
  {
    id: '705ba78b-e31c-4aa1-843d-7eb68ce7ae1e',
    currency: 'GCS',
    amount: 1658.874829,
    user: '15',
    date: '2024-08-15T12:33:58Z',
    status: 'blocked',
  },
  {
    id: 'b47aa1c4-6f14-428e-897e-b39f154df13f',
    currency: 'GCS',
    amount: -2462.013026,
    user: '6',
    date: '2024-11-22T21:40:01Z',
    status: 'inProgress',
  },
  {
    id: 'fcdbb48d-ee1e-438b-ad50-e8f3f8be0e01',
    currency: 'GCS',
    amount: -4657.271395,
    user: '2',
    date: '2024-03-26T23:40:27Z',
    status: 'inProgress',
  },
  {
    id: 'ded32620-6de6-43b3-925e-932782127614',
    currency: 'ICS',
    amount: -5912.133625,
    user: '21',
    date: '2024-12-02T09:24:11Z',
    status: 'inProgress',
  },
  {
    id: '17e02033-dd6a-4e59-9062-cc89ab5752b8',
    currency: 'GCS',
    amount: -6946.899203,
    user: '51',
    date: '2024-06-04T02:00:11Z',
    status: 'blocked',
  },
  {
    id: '0f6c0868-ee87-43a9-86df-7bd9257c35ec',
    currency: 'GCS',
    amount: 7883.362463,
    user: '33',
    date: '2024-12-29T20:17:15Z',
    status: 'inProgress',
  },
  {
    id: 'e505aa66-ce0c-4498-88ca-04f8f0c5de80',
    currency: 'GCS',
    amount: -4588.486662,
    user: '69',
    date: '2024-10-30T13:32:51Z',
    status: 'blocked',
  },
  {
    id: '76accf2d-95fa-4b5e-8d28-e5840c771282',
    currency: 'ICS',
    amount: -4306.914331,
    user: '34',
    date: '2024-02-18T15:36:21Z',
    status: 'blocked',
  },
  {
    id: '0250a427-8218-4ab9-9ed3-96dfd1b48926',
    currency: 'GCS',
    amount: 8333.295815,
    user: '32',
    date: '2024-04-06T00:14:56Z',
    status: 'completed',
  },
  {
    id: 'd2e05da8-7f5c-4a79-9b00-77303b6049fa',
    currency: 'ICS',
    amount: 2871.567255,
    user: '54',
    date: '2024-08-25T17:36:00Z',
    status: 'completed',
  },
  {
    id: '507c3899-fe12-46cb-a8aa-93d49f547510',
    currency: 'ICS',
    amount: -515.991132,
    user: '46',
    date: '2024-10-16T18:32:33Z',
    status: 'inProgress',
  },
  {
    id: 'daad7330-801b-4ba8-abaf-dd1f76cb0f19',
    currency: 'GCS',
    amount: -2988.881012,
    user: '1',
    date: '2024-01-07T07:20:01Z',
    status: 'completed',
  },
  {
    id: '4451e0a3-69d9-44d4-8e38-b9f46f4206b3',
    currency: 'GCS',
    amount: -5227.489973,
    user: '18',
    date: '2024-04-15T11:18:59Z',
    status: 'blocked',
  },
  {
    id: '5329b490-f19c-4693-8b9b-f1c61eeeb92f',
    currency: 'GCS',
    amount: 6839.661661,
    user: '79',
    date: '2024-05-01T17:29:50Z',
    status: 'blocked',
  },
  {
    id: 'fa9ae7ec-5671-4446-bd31-76e16ee82afc',
    currency: 'GCS',
    amount: -2878.460848,
    user: '4',
    date: '2024-12-08T23:13:30Z',
    status: 'inProgress',
  },
  {
    id: '591cd648-b550-4a30-9bcc-0f22e04c58f1',
    currency: 'ICS',
    amount: -2667.00211,
    user: '34',
    date: '2024-08-09T16:47:52Z',
    status: 'blocked',
  },
  {
    id: '873b76bb-2f9e-45bc-a46a-8866237d4db0',
    currency: 'ICS',
    amount: -7541.512637,
    user: '58',
    date: '2024-01-06T16:58:12Z',
    status: 'blocked',
  },
  {
    id: 'da0a6776-8bb4-4a96-a313-4bd431b3d03e',
    currency: 'ICS',
    amount: -2818.685387,
    user: '23',
    date: '2024-07-16T06:18:22Z',
    status: 'blocked',
  },
  {
    id: '7c83ecbd-4e0d-404c-ab92-ef58ddaafe3f',
    currency: 'ICS',
    amount: 1373.185698,
    user: '22',
    date: '2024-01-02T09:17:21Z',
    status: 'inProgress',
  },
  {
    id: 'd1eaece4-8ec4-45eb-ba62-bc11512bdd3f',
    currency: 'GCS',
    amount: 7463.442386,
    user: '22',
    date: '2024-10-22T06:27:17Z',
    status: 'blocked',
  },
  {
    id: 'df217faf-be40-4680-9dd1-f1ef295fa2a9',
    currency: 'GCS',
    amount: 944.525985,
    user: '41',
    date: '2024-12-10T07:53:38Z',
    status: 'completed',
  },
  {
    id: '4110b2ee-7eb3-4984-af8e-dc3b8f69624d',
    currency: 'ICS',
    amount: -7539.920741,
    user: '28',
    date: '2024-07-21T11:36:23Z',
    status: 'blocked',
  },
  {
    id: 'd0847d05-847b-4c7b-88c1-8e3d03c8cfb4',
    currency: 'ICS',
    amount: -6019.672788,
    user: '47',
    date: '2024-06-20T10:10:43Z',
    status: 'blocked',
  },
  {
    id: 'e0e54600-ef8b-417a-abfd-9410aa460f89',
    currency: 'GCS',
    amount: -3452.805343,
    user: '80',
    date: '2024-11-23T02:09:31Z',
    status: 'inProgress',
  },
  {
    id: '12a899f7-f973-40dc-af83-f9622b934a6f',
    currency: 'GCS',
    amount: -7999.714364,
    user: '63',
    date: '2024-11-20T04:47:45Z',
    status: 'inProgress',
  },
  {
    id: 'f5673c61-ae35-4714-a226-0d87cc4756b3',
    currency: 'ICS',
    amount: 9891.687361,
    user: '31',
    date: '2024-10-24T20:36:00Z',
    status: 'blocked',
  },
  {
    id: '97384fd5-39de-4d1b-8c10-f6bc5ad27303',
    currency: 'ICS',
    amount: -4806.018966,
    user: '64',
    date: '2024-01-23T21:26:07Z',
    status: 'blocked',
  },
  {
    id: '3d2321bd-3e6d-4642-aa3a-4d86e7fa5da7',
    currency: 'GCS',
    amount: 3322.824035,
    user: '19',
    date: '2024-02-27T17:38:35Z',
    status: 'inProgress',
  },
  {
    id: '8460d838-2d2a-4353-8a5f-4f5761579bb5',
    currency: 'GCS',
    amount: 3601.991839,
    user: '50',
    date: '2024-07-26T17:48:32Z',
    status: 'inProgress',
  },
  {
    id: '021a1960-8238-4051-bb28-fb08217dfcaf',
    currency: 'ICS',
    amount: 6718.635661,
    user: '58',
    date: '2024-10-02T20:45:16Z',
    status: 'blocked',
  },
  {
    id: '7be26cef-e9a3-44c2-acf3-c4a555e4866e',
    currency: 'ICS',
    amount: 8202.437365,
    user: '37',
    date: '2024-07-02T15:08:05Z',
    status: 'completed',
  },
  {
    id: 'ea753d12-9875-4ed1-83a6-3afb6f4738c7',
    currency: 'GCS',
    amount: -4471.91262,
    user: '23',
    date: '2024-09-20T15:28:36Z',
    status: 'blocked',
  },
  {
    id: 'bcaf0a5b-ff60-46d7-a286-e1a9ccc62603',
    currency: 'GCS',
    amount: -3397.169262,
    user: '81',
    date: '2024-10-25T09:05:32Z',
    status: 'inProgress',
  },
  {
    id: '8c00cea6-c27e-4480-9f9b-324b75b38382',
    currency: 'ICS',
    amount: -9609.458537,
    user: '21',
    date: '2024-07-13T13:40:57Z',
    status: 'inProgress',
  },
  {
    id: '89459d70-af05-40bd-a33a-9276ef168926',
    currency: 'GCS',
    amount: -9392.168593,
    user: '38',
    date: '2024-11-13T19:00:11Z',
    status: 'completed',
  },
  {
    id: '9ae33505-1dd4-409d-be2d-03dea9e52773',
    currency: 'ICS',
    amount: 2689.346251,
    user: '56',
    date: '2024-08-09T08:31:47Z',
    status: 'blocked',
  },
  {
    id: '81eb8fc5-e7f1-4eff-93bb-77a27913364b',
    currency: 'GCS',
    amount: -5993.279192,
    user: '48',
    date: '2024-12-24T13:34:55Z',
    status: 'completed',
  },
  {
    id: '5fa2a7ee-dc64-448c-9642-f3fda419bf39',
    currency: 'ICS',
    amount: 3061.156575,
    user: '64',
    date: '2024-07-05T20:19:32Z',
    status: 'completed',
  },
  {
    id: 'c95ecbc1-58d6-4e8c-86ca-4f4efc0b8d74',
    currency: 'GCS',
    amount: -5680.841173,
    user: '48',
    date: '2024-08-13T08:11:30Z',
    status: 'blocked',
  },
  {
    id: '35df1633-dca4-4317-913f-164d4ab11119',
    currency: 'ICS',
    amount: -7000.31563,
    user: '26',
    date: '2024-01-22T06:26:39Z',
    status: 'completed',
  },
  {
    id: '9982611f-707a-4c43-913f-bb85849d62f1',
    currency: 'GCS',
    amount: -7733.334361,
    user: '62',
    date: '2024-11-06T06:48:49Z',
    status: 'blocked',
  },
  {
    id: '23bc832f-cc10-4df7-bd5f-c0035787500a',
    currency: 'ICS',
    amount: -6069.782773,
    user: '71',
    date: '2024-06-18T23:16:40Z',
    status: 'inProgress',
  },
  {
    id: 'adae176b-fb35-4bce-be0a-fdc495fb498c',
    currency: 'GCS',
    amount: 9164.783777,
    user: '45',
    date: '2024-03-23T06:16:16Z',
    status: 'completed',
  },
  {
    id: 'b9f51934-b046-4018-8c6c-8cfcdab019a7',
    currency: 'GCS',
    amount: -1125.390369,
    user: '28',
    date: '2024-06-10T04:39:06Z',
    status: 'inProgress',
  },
  {
    id: 'dd778f23-b0da-4747-aa4d-72ece243be13',
    currency: 'ICS',
    amount: -2257.865053,
    user: '61',
    date: '2024-02-12T13:46:18Z',
    status: 'blocked',
  },
  {
    id: 'eb025cab-3da4-46ae-8158-4bebc68660b4',
    currency: 'GCS',
    amount: 9383.899649,
    user: '6',
    date: '2024-05-16T18:25:51Z',
    status: 'blocked',
  },
  {
    id: 'aa4d6b72-f5b2-4e33-8cb4-7b367ad7cfcf',
    currency: 'ICS',
    amount: 6111.642589,
    user: '49',
    date: '2024-03-14T09:36:44Z',
    status: 'completed',
  },
  {
    id: '0df018d3-c67f-4b60-9521-c65009d3334c',
    currency: 'ICS',
    amount: 3611.198946,
    user: '47',
    date: '2024-03-11T02:02:28Z',
    status: 'blocked',
  },
  {
    id: '48952cfc-34bf-4507-8c9c-ca9a62144373',
    currency: 'GCS',
    amount: 7434.362721,
    user: '48',
    date: '2024-03-04T03:07:55Z',
    status: 'completed',
  },
  {
    id: 'aefd1276-6f6a-4ee1-86ec-534ccb6ff590',
    currency: 'ICS',
    amount: 4761.953197,
    user: '44',
    date: '2024-02-27T16:01:38Z',
    status: 'inProgress',
  },
  {
    id: '113d15ad-9069-422a-81ad-f06c4fd31aa4',
    currency: 'ICS',
    amount: -3073.745939,
    user: '67',
    date: '2024-03-11T03:53:28Z',
    status: 'inProgress',
  },
  {
    id: 'ed2f726b-fd71-4018-8e51-e6233336d2d2',
    currency: 'GCS',
    amount: -7655.892499,
    user: '72',
    date: '2024-07-05T23:07:22Z',
    status: 'completed',
  },
  {
    id: '87f645e6-8eec-4207-a65f-42051c4d96e1',
    currency: 'ICS',
    amount: -5264.954415,
    user: '9',
    date: '2024-05-03T02:08:42Z',
    status: 'completed',
  },
  {
    id: '3a226f2f-f520-474d-bc94-be4650cbfffa',
    currency: 'ICS',
    amount: -3093.556743,
    user: '15',
    date: '2024-08-25T17:13:41Z',
    status: 'blocked',
  },
  {
    id: '6af3b441-66d5-41c0-bac7-8051142e3746',
    currency: 'ICS',
    amount: -5160.671777,
    user: '72',
    date: '2024-04-09T08:47:41Z',
    status: 'completed',
  },
  {
    id: '13894f2c-9677-4413-899f-29062af24149',
    currency: 'GCS',
    amount: 8277.682598,
    user: '20',
    date: '2024-04-19T08:04:00Z',
    status: 'inProgress',
  },
  {
    id: '41fd16a9-9e07-461f-84d5-b5c1de911bbf',
    currency: 'ICS',
    amount: 4369.909483,
    user: '37',
    date: '2024-11-21T23:39:15Z',
    status: 'blocked',
  },
  {
    id: '07822b86-3377-40c4-8488-58f7a683b233',
    currency: 'ICS',
    amount: -5241.185812,
    user: '32',
    date: '2024-09-14T03:04:13Z',
    status: 'completed',
  },
  {
    id: '3a84632e-2f5f-4bc9-859e-6d53f8fa1fe4',
    currency: 'GCS',
    amount: 9692.061067,
    user: '79',
    date: '2024-07-25T15:17:09Z',
    status: 'blocked',
  },
  {
    id: 'b3c24dda-a8b5-408d-a70b-1d6095036a5f',
    currency: 'GCS',
    amount: 8491.830186,
    user: '30',
    date: '2024-03-21T22:09:21Z',
    status: 'completed',
  },
  {
    id: '4d80595b-7a25-4354-9423-29695efbcdc7',
    currency: 'ICS',
    amount: -2750.867288,
    user: '25',
    date: '2024-05-01T21:53:48Z',
    status: 'inProgress',
  },
  {
    id: '7c176f4e-51b1-4820-b076-2771183e0397',
    currency: 'ICS',
    amount: -7389.111158,
    user: '79',
    date: '2024-12-24T09:55:19Z',
    status: 'blocked',
  },
  {
    id: '695fd889-3653-4066-b979-72e1b560d083',
    currency: 'ICS',
    amount: -9238.838941,
    user: '3',
    date: '2024-05-10T11:21:54Z',
    status: 'blocked',
  },
  {
    id: '8dcd76bc-b6bd-4313-aa9f-a3faa3017653',
    currency: 'GCS',
    amount: 6157.435934,
    user: '57',
    date: '2024-09-07T07:38:29Z',
    status: 'completed',
  },
  {
    id: 'd37fb6fc-fdc8-43a0-a387-b74edf0c9d57',
    currency: 'ICS',
    amount: -4406.577139,
    user: '34',
    date: '2024-06-20T06:22:20Z',
    status: 'blocked',
  },
  {
    id: 'debe724e-aa1f-49b3-ba86-94ce65d46b4a',
    currency: 'ICS',
    amount: 8407.110302,
    user: '16',
    date: '2024-03-07T13:33:02Z',
    status: 'completed',
  },
  {
    id: '62562ba6-7384-4598-b70e-d38f3a949199',
    currency: 'ICS',
    amount: 9922.84846,
    user: '53',
    date: '2024-02-10T05:33:48Z',
    status: 'blocked',
  },
  {
    id: '4b801dc2-6a2e-43a6-9187-1a1047909169',
    currency: 'GCS',
    amount: -2358.856505,
    user: '65',
    date: '2024-03-21T20:45:30Z',
    status: 'inProgress',
  },
  {
    id: '29c9b797-016c-433e-8b9c-a027e253df71',
    currency: 'GCS',
    amount: -1908.315652,
    user: '66',
    date: '2024-12-04T20:09:18Z',
    status: 'completed',
  },
  {
    id: '444698b9-3c7a-4288-89bf-2da8c1258dce',
    currency: 'GCS',
    amount: -2265.976302,
    user: '9',
    date: '2024-05-10T01:02:06Z',
    status: 'completed',
  },
  {
    id: '79d9d446-de41-4f55-b3b1-fb2a147490fc',
    currency: 'ICS',
    amount: 7246.555657,
    user: '69',
    date: '2024-04-12T10:31:09Z',
    status: 'inProgress',
  },
  {
    id: 'a751d184-13a6-4271-b992-e2aeb682ac01',
    currency: 'ICS',
    amount: -2473.073754,
    user: '21',
    date: '2024-06-30T15:44:23Z',
    status: 'inProgress',
  },
  {
    id: '67a14d3c-e200-4441-b051-61e64dddbe3d',
    currency: 'GCS',
    amount: 4060.250339,
    user: '78',
    date: '2024-12-21T06:34:27Z',
    status: 'blocked',
  },
  {
    id: 'd8443ea4-73ac-4f91-aa20-f7a243dcee33',
    currency: 'ICS',
    amount: -8022.397817,
    user: '72',
    date: '2024-10-31T04:23:20Z',
    status: 'inProgress',
  },
  {
    id: '5a8284c7-3353-4651-aed7-5ef9530b04f2',
    currency: 'GCS',
    amount: 3665.17701,
    user: '69',
    date: '2024-09-22T14:49:17Z',
    status: 'blocked',
  },
  {
    id: 'c22e7b8d-fa27-4f25-b040-89d0f8b070e5',
    currency: 'ICS',
    amount: 8263.25883,
    user: '44',
    date: '2024-04-19T15:49:47Z',
    status: 'blocked',
  },
  {
    id: 'a2095d3e-111e-42bd-8a36-ca3ce3ced4a6',
    currency: 'GCS',
    amount: -4810.848598,
    user: '6',
    date: '2024-07-25T14:53:01Z',
    status: 'blocked',
  },
  {
    id: '6ee65f35-7180-4ecc-b6af-74d21b979292',
    currency: 'ICS',
    amount: -3785.436567,
    user: '32',
    date: '2024-02-22T20:52:25Z',
    status: 'inProgress',
  },
  {
    id: 'fdafe470-28eb-4964-8df4-078d4e2a6bf4',
    currency: 'GCS',
    amount: -7986.739054,
    user: '36',
    date: '2024-10-14T17:17:31Z',
    status: 'blocked',
  },
  {
    id: '9ffc9d8b-1e51-49e5-ac92-f9cb52cd9208',
    currency: 'ICS',
    amount: 5366.114632,
    user: '45',
    date: '2024-12-18T12:40:30Z',
    status: 'inProgress',
  },
  {
    id: 'fce59937-a1b6-419f-b08d-b7fa2bc83c88',
    currency: 'GCS',
    amount: 2725.981384,
    user: '62',
    date: '2024-11-18T15:37:08Z',
    status: 'blocked',
  },
  {
    id: '05936930-a31a-4406-8631-873323dbec47',
    currency: 'GCS',
    amount: 1637.910571,
    user: '69',
    date: '2024-04-30T23:31:15Z',
    status: 'inProgress',
  },
  {
    id: '459d82e6-ee2f-4431-a575-220de7afaff7',
    currency: 'GCS',
    amount: -9025.947564,
    user: '32',
    date: '2024-07-27T19:04:57Z',
    status: 'blocked',
  },
  {
    id: '3b48d539-e203-42c6-a619-0ee2b01e6100',
    currency: 'ICS',
    amount: -2793.556887,
    user: '38',
    date: '2024-01-29T03:27:42Z',
    status: 'inProgress',
  },
  {
    id: 'df9c2de6-ff10-4faa-84b4-0d4f55674227',
    currency: 'GCS',
    amount: -817.315801,
    user: '13',
    date: '2024-05-23T03:38:24Z',
    status: 'blocked',
  },
  {
    id: '937de419-aad8-4f7a-b357-24bad187a0c3',
    currency: 'ICS',
    amount: -3096.429762,
    user: '64',
    date: '2024-05-29T05:04:30Z',
    status: 'inProgress',
  },
  {
    id: '7baea076-9207-49d9-87d9-59ffc45160e5',
    currency: 'GCS',
    amount: 306.188682,
    user: '83',
    date: '2024-12-18T22:21:40Z',
    status: 'completed',
  },
  {
    id: 'f98e0f0f-fcde-48c3-84d8-fac04f8649e3',
    currency: 'ICS',
    amount: 4150.971056,
    user: '63',
    date: '2024-02-02T16:07:41Z',
    status: 'inProgress',
  },
  {
    id: 'ea71350a-2239-450c-b8dc-0970d16ec923',
    currency: 'GCS',
    amount: 6100.599246,
    user: '48',
    date: '2024-02-26T07:00:22Z',
    status: 'completed',
  },
  {
    id: '868f1059-761d-4b0c-b5b9-5044b4fef781',
    currency: 'GCS',
    amount: -3871.102441,
    user: '40',
    date: '2024-11-28T13:05:41Z',
    status: 'blocked',
  },
  {
    id: '7e5a2538-10a0-407d-abe4-02db9c97871a',
    currency: 'ICS',
    amount: -2856.124224,
    user: '62',
    date: '2024-02-17T17:51:07Z',
    status: 'completed',
  },
  {
    id: 'cbd6ee1b-e272-4826-9d26-adbab47fa44f',
    currency: 'GCS',
    amount: 5207.06755,
    user: '33',
    date: '2024-03-12T03:19:19Z',
    status: 'completed',
  },
  {
    id: '20509aad-bb7b-44c5-b11b-cac69b795a06',
    currency: 'ICS',
    amount: 6171.917839,
    user: '36',
    date: '2024-03-14T14:43:24Z',
    status: 'inProgress',
  },
  {
    id: 'edb6e6b5-b4db-4e99-b636-bb1a54d79b42',
    currency: 'ICS',
    amount: -80.609019,
    user: '9',
    date: '2024-05-03T01:26:18Z',
    status: 'inProgress',
  },
  {
    id: 'eb444c60-5a8f-43b5-8f5e-b37507962bf9',
    currency: 'GCS',
    amount: 775.826907,
    user: '49',
    date: '2024-08-16T04:48:12Z',
    status: 'completed',
  },
  {
    id: '3fc3c9c8-b243-4a14-8367-a4e284069d11',
    currency: 'ICS',
    amount: 1833.733624,
    user: '26',
    date: '2024-11-14T13:37:35Z',
    status: 'completed',
  },
  {
    id: 'cb7e67c2-c2b3-465e-b283-600e4f61a705',
    currency: 'GCS',
    amount: -9621.347189,
    user: '10',
    date: '2024-06-15T11:15:59Z',
    status: 'inProgress',
  },
  {
    id: '22f86d5a-2bf8-4bf5-8da2-0dbd280a1d8c',
    currency: 'ICS',
    amount: 3465.037099,
    user: '3',
    date: '2024-06-21T08:58:30Z',
    status: 'completed',
  },
  {
    id: '8455f901-bbbb-48ea-a1fc-a58fce313544',
    currency: 'ICS',
    amount: -9830.113907,
    user: '52',
    date: '2024-04-14T16:53:48Z',
    status: 'inProgress',
  },
  {
    id: '42697b6e-82fb-43d4-ac7b-9ddcb0de7293',
    currency: 'GCS',
    amount: -3961.120618,
    user: '44',
    date: '2024-05-09T05:24:25Z',
    status: 'blocked',
  },
  {
    id: 'f974485c-2f96-432f-b82d-e8b4d73b22c0',
    currency: 'GCS',
    amount: -5880.650801,
    user: '54',
    date: '2024-05-31T20:22:11Z',
    status: 'completed',
  },
  {
    id: '973d8190-408b-4fff-93af-4ce7ca5cb62e',
    currency: 'ICS',
    amount: 9343.622531,
    user: '10',
    date: '2024-11-08T02:46:46Z',
    status: 'completed',
  },
  {
    id: 'f01a3972-0ff5-496e-af9d-333feba2756f',
    currency: 'ICS',
    amount: -9390.358953,
    user: '75',
    date: '2024-09-16T15:47:34Z',
    status: 'completed',
  },
  {
    id: '03d44416-6545-4669-bc03-0eb3f97539d6',
    currency: 'ICS',
    amount: -3395.459653,
    user: '26',
    date: '2024-05-23T02:14:25Z',
    status: 'inProgress',
  },
  {
    id: 'ac49ce76-8ad8-4b40-bef5-3f6c57d7bb90',
    currency: 'GCS',
    amount: -5363.292558,
    user: '43',
    date: '2024-10-04T23:29:24Z',
    status: 'blocked',
  },
  {
    id: '97f46976-2c04-4c00-9743-4137e97c61e0',
    currency: 'ICS',
    amount: 5262.077885,
    user: '74',
    date: '2024-01-16T07:22:59Z',
    status: 'inProgress',
  },
  {
    id: '756f0890-be38-4e74-afa9-a15981c3f3e0',
    currency: 'ICS',
    amount: -98.326391,
    user: '26',
    date: '2024-10-15T10:38:23Z',
    status: 'completed',
  },
  {
    id: '583f05c2-86df-4668-b3cd-4db319c556d5',
    currency: 'ICS',
    amount: -7744.017598,
    user: '17',
    date: '2024-04-15T08:15:56Z',
    status: 'inProgress',
  },
  {
    id: '6b7cdc02-f3d6-4beb-babb-21337f9ee913',
    currency: 'GCS',
    amount: 257.389912,
    user: '15',
    date: '2024-09-22T04:42:59Z',
    status: 'completed',
  },
  {
    id: '95dd9c5e-afa4-42d1-a966-397077e95f13',
    currency: 'GCS',
    amount: -7431.72598,
    user: '68',
    date: '2024-10-15T22:25:45Z',
    status: 'completed',
  },
  {
    id: '7da16bca-643b-413c-8895-c76ba5067e3f',
    currency: 'GCS',
    amount: 6259.864613,
    user: '63',
    date: '2024-05-01T02:48:13Z',
    status: 'completed',
  },
  {
    id: '10bfa7ec-921f-4dab-96d7-e1d4afec8997',
    currency: 'GCS',
    amount: 5240.83624,
    user: '79',
    date: '2024-07-15T15:35:11Z',
    status: 'inProgress',
  },
  {
    id: '7d2cec88-02ed-4132-a2c2-0f7ac49990e0',
    currency: 'ICS',
    amount: 5661.251329,
    user: '23',
    date: '2024-07-20T23:53:53Z',
    status: 'blocked',
  },
  {
    id: '0d2baf52-64f2-4ef0-bb67-558b4ba08652',
    currency: 'GCS',
    amount: -7498.557176,
    user: '64',
    date: '2024-04-21T00:20:12Z',
    status: 'inProgress',
  },
  {
    id: '239ab033-82e6-4d4e-b591-f946312705bd',
    currency: 'GCS',
    amount: -8311.197443,
    user: '59',
    date: '2024-03-03T00:54:46Z',
    status: 'completed',
  },
  {
    id: '0199c64c-44ef-4d00-94cb-89a0b7290c41',
    currency: 'GCS',
    amount: 8291.38855,
    user: '65',
    date: '2024-02-24T04:47:51Z',
    status: 'inProgress',
  },
  {
    id: '4334e759-e176-4d1a-8bf1-8d5d1778acfe',
    currency: 'GCS',
    amount: -9149.769236,
    user: '14',
    date: '2024-08-18T20:15:11Z',
    status: 'blocked',
  },
  {
    id: '1ff0d545-7c68-4fbc-8883-c0004aa80e07',
    currency: 'ICS',
    amount: -1168.092783,
    user: '18',
    date: '2024-10-09T09:57:07Z',
    status: 'blocked',
  },
  {
    id: 'cb406db3-7b86-4e0e-aa59-486dbfe7c02d',
    currency: 'GCS',
    amount: -9452.94931,
    user: '7',
    date: '2024-03-22T13:50:17Z',
    status: 'blocked',
  },
  {
    id: '126b1d89-a91c-48d2-9173-ff7b05a7ccf6',
    currency: 'ICS',
    amount: -5455.523334,
    user: '25',
    date: '2024-02-07T04:44:35Z',
    status: 'completed',
  },
  {
    id: '3d1cf5cd-23e1-42ce-9710-85e0cab3c137',
    currency: 'ICS',
    amount: 353.598126,
    user: '37',
    date: '2024-06-29T04:07:04Z',
    status: 'blocked',
  },
  {
    id: '01eb16cb-dfeb-405e-93e0-e0fe15876e51',
    currency: 'ICS',
    amount: -4256.484348,
    user: '6',
    date: '2024-10-31T07:12:51Z',
    status: 'blocked',
  },
  {
    id: 'f6cc6bd1-13f0-491d-90c0-e3092cd38e85',
    currency: 'ICS',
    amount: -7436.319328,
    user: '47',
    date: '2024-10-29T18:33:41Z',
    status: 'blocked',
  },
  {
    id: '69d9480c-b40d-4e3b-8363-4b06b4294497',
    currency: 'ICS',
    amount: 7233.055104,
    user: '68',
    date: '2024-12-27T10:49:41Z',
    status: 'blocked',
  },
  {
    id: '1ea068aa-a767-4d21-bf39-511829b6ed9e',
    currency: 'GCS',
    amount: -320.740963,
    user: '5',
    date: '2024-02-25T08:22:00Z',
    status: 'completed',
  },
  {
    id: 'fef89d1e-cd57-43c7-b1e1-bc87122edd21',
    currency: 'ICS',
    amount: -3966.155534,
    user: '77',
    date: '2024-07-14T19:28:09Z',
    status: 'blocked',
  },
  {
    id: '5c919b0c-e740-45b5-893b-9666b2062bb8',
    currency: 'ICS',
    amount: 7920.355633,
    user: '24',
    date: '2024-04-19T11:11:34Z',
    status: 'inProgress',
  },
  {
    id: 'e81a0adb-aaa7-46bb-9dbe-e9377f5c3f71',
    currency: 'GCS',
    amount: -3583.983429,
    user: '61',
    date: '2024-04-24T04:47:40Z',
    status: 'blocked',
  },
  {
    id: '5966e927-c89c-4d73-aecb-d6332410bf36',
    currency: 'ICS',
    amount: 5297.605332,
    user: '18',
    date: '2024-07-02T02:35:58Z',
    status: 'inProgress',
  },
  {
    id: '8caa4f9a-8035-4b7f-bc42-437bee5df407',
    currency: 'ICS',
    amount: -9476.052869,
    user: '17',
    date: '2024-10-08T10:03:20Z',
    status: 'blocked',
  },
  {
    id: 'c9d63907-16f8-4311-a5b2-9cd47a195dd9',
    currency: 'ICS',
    amount: 4679.206002,
    user: '2',
    date: '2024-11-25T21:46:49Z',
    status: 'inProgress',
  },
  {
    id: '7ee10cc3-56a7-44a1-8776-e24d07b0bfa1',
    currency: 'ICS',
    amount: 2346.137978,
    user: '25',
    date: '2024-08-21T04:44:10Z',
    status: 'blocked',
  },
  {
    id: '25207ae8-f7ea-483d-b836-4e3010e0fdfd',
    currency: 'ICS',
    amount: 7168.423869,
    user: '17',
    date: '2024-05-12T10:56:35Z',
    status: 'completed',
  },
  {
    id: 'ad71df0b-3be3-4331-bc97-6693bf4ab916',
    currency: 'GCS',
    amount: 8569.995516,
    user: '81',
    date: '2024-10-25T07:47:17Z',
    status: 'inProgress',
  },
  {
    id: 'b3b87ac9-f912-41c9-9db7-39850e249165',
    currency: 'ICS',
    amount: 4463.596071,
    user: '61',
    date: '2024-08-31T16:13:33Z',
    status: 'blocked',
  },
  {
    id: 'b59b351c-57ec-4c2c-a0a2-f0a1f3fada83',
    currency: 'GCS',
    amount: -1061.363967,
    user: '21',
    date: '2024-03-27T19:03:43Z',
    status: 'blocked',
  },
  {
    id: 'ffb29dea-3eb1-47ba-b382-083a8309ef1f',
    currency: 'GCS',
    amount: -3524.46657,
    user: '32',
    date: '2024-09-16T22:07:18Z',
    status: 'completed',
  },
  {
    id: '467dde89-e346-4f80-a094-1721bef1af08',
    currency: 'GCS',
    amount: -6024.430981,
    user: '16',
    date: '2024-03-23T14:05:47Z',
    status: 'completed',
  },
  {
    id: '94ee19ed-fee5-4ced-9c23-24193cb0b509',
    currency: 'GCS',
    amount: 888.239076,
    user: '80',
    date: '2024-11-01T09:31:05Z',
    status: 'completed',
  },
  {
    id: '35d44fed-0614-41f4-8397-db9a181d9cdf',
    currency: 'GCS',
    amount: -7957.503767,
    user: '39',
    date: '2024-02-23T16:15:09Z',
    status: 'completed',
  },
  {
    id: 'adb03f96-7a33-4679-9e15-132bd73348c5',
    currency: 'ICS',
    amount: -786.392331,
    user: '48',
    date: '2024-04-23T04:43:43Z',
    status: 'blocked',
  },
  {
    id: 'fd7da014-ea2e-475e-a831-fea2c1e536c0',
    currency: 'GCS',
    amount: -8594.965059,
    user: '69',
    date: '2024-07-25T22:52:07Z',
    status: 'inProgress',
  },
  {
    id: 'c8a97e55-a86c-4ad2-babe-441c52d7d028',
    currency: 'ICS',
    amount: 8732.439652,
    user: '23',
    date: '2024-01-26T10:54:17Z',
    status: 'blocked',
  },
  {
    id: 'e0fc2668-30c7-44a4-9d27-19d4a84db74a',
    currency: 'GCS',
    amount: 9358.035782,
    user: '40',
    date: '2024-12-28T21:42:51Z',
    status: 'inProgress',
  },
  {
    id: 'f795daba-dea8-4ef7-aa3c-33af48cbdbef',
    currency: 'ICS',
    amount: -7567.076338,
    user: '75',
    date: '2024-02-03T05:19:04Z',
    status: 'completed',
  },
  {
    id: '4a30fbd2-d7d4-475c-b555-14b572892c63',
    currency: 'GCS',
    amount: 8032.447727,
    user: '40',
    date: '2024-02-18T12:31:19Z',
    status: 'blocked',
  },
  {
    id: 'b45beda5-d398-41b3-bef1-e7cf46e408c7',
    currency: 'GCS',
    amount: -5312.541985,
    user: '68',
    date: '2024-09-02T16:55:12Z',
    status: 'blocked',
  },
  {
    id: 'fcbd03c8-bcdd-4a27-8eaa-d77b1f25d8ea',
    currency: 'GCS',
    amount: -5534.858992,
    user: '77',
    date: '2024-04-15T08:25:23Z',
    status: 'inProgress',
  },
  {
    id: 'ab2db4f0-1770-45af-bb12-573665de1129',
    currency: 'GCS',
    amount: 6384.013021,
    user: '78',
    date: '2024-06-17T08:41:39Z',
    status: 'blocked',
  },
  {
    id: '8d7a0dff-cf7e-4913-a472-8b58cfe16b8b',
    currency: 'ICS',
    amount: -1955.962048,
    user: '67',
    date: '2024-07-07T20:01:21Z',
    status: 'inProgress',
  },
  {
    id: 'f8871e10-dfae-4866-be5f-7209bc9b0c1b',
    currency: 'ICS',
    amount: -6360.758338,
    user: '17',
    date: '2024-04-02T14:47:46Z',
    status: 'inProgress',
  },
  {
    id: 'ab134444-d662-4d8e-8717-b233e081d164',
    currency: 'ICS',
    amount: -7622.124895,
    user: '65',
    date: '2024-01-14T17:28:45Z',
    status: 'blocked',
  },
  {
    id: '5dd2607a-f332-4ffd-acb9-97da6e9d061b',
    currency: 'GCS',
    amount: -2690.051895,
    user: '51',
    date: '2024-07-17T00:33:36Z',
    status: 'completed',
  },
  {
    id: '1312f4f5-9762-4a6b-a7a6-0b6c5b74bddc',
    currency: 'ICS',
    amount: -6873.199144,
    user: '76',
    date: '2024-07-30T04:29:00Z',
    status: 'inProgress',
  },
  {
    id: 'bff6b839-587e-44ce-a0da-a98e97d07128',
    currency: 'ICS',
    amount: -5272.041476,
    user: '40',
    date: '2024-02-11T04:55:53Z',
    status: 'blocked',
  },
  {
    id: '44b475bb-6f24-46af-8633-f18aebaa80f9',
    currency: 'ICS',
    amount: 7047.583891,
    user: '14',
    date: '2024-09-12T17:05:46Z',
    status: 'completed',
  },
  {
    id: '678bc554-87e5-4da5-a676-3c543d5b53ad',
    currency: 'GCS',
    amount: 7879.396186,
    user: '8',
    date: '2024-04-27T15:20:06Z',
    status: 'blocked',
  },
  {
    id: 'f01f3846-e297-4f3a-bc16-494741060da5',
    currency: 'GCS',
    amount: -1241.038756,
    user: '45',
    date: '2024-08-08T04:40:45Z',
    status: 'inProgress',
  },
  {
    id: '822fbcde-8c7e-4df2-b33b-da2054cc97cf',
    currency: 'ICS',
    amount: -6091.915158,
    user: '47',
    date: '2024-03-25T12:47:36Z',
    status: 'inProgress',
  },
  {
    id: '9080d943-513e-4bd1-b74e-ce244650331b',
    currency: 'ICS',
    amount: -8336.579761,
    user: '56',
    date: '2024-06-01T03:34:51Z',
    status: 'inProgress',
  },
  {
    id: 'f7515788-c8a6-477a-a73d-b788001cf75a',
    currency: 'ICS',
    amount: 1793.701206,
    user: '52',
    date: '2024-11-14T03:36:03Z',
    status: 'inProgress',
  },
  {
    id: 'e04af6a1-65ea-42a3-9e89-35d25d6500c7',
    currency: 'ICS',
    amount: -8717.603696,
    user: '58',
    date: '2024-12-08T20:24:21Z',
    status: 'inProgress',
  },
  {
    id: '8b20e3f3-f308-4899-8f9a-385a9960d45b',
    currency: 'GCS',
    amount: 4639.071524,
    user: '81',
    date: '2024-12-23T23:12:25Z',
    status: 'blocked',
  },
  {
    id: '7169fc20-dd0f-4f7c-9a58-e943934fadb0',
    currency: 'ICS',
    amount: -6486.337503,
    user: '80',
    date: '2024-10-25T06:35:22Z',
    status: 'inProgress',
  },
  {
    id: '914f4cce-5134-4142-885a-87d32c910b4e',
    currency: 'ICS',
    amount: 936.777226,
    user: '13',
    date: '2024-11-25T04:58:29Z',
    status: 'inProgress',
  },
  {
    id: 'd28d57cd-84ab-44db-aa97-cd426970a55c',
    currency: 'GCS',
    amount: 988.07073,
    user: '26',
    date: '2024-08-05T13:54:13Z',
    status: 'blocked',
  },
  {
    id: '3ffdf418-1de0-4547-9492-e46558986266',
    currency: 'GCS',
    amount: 5260.724999,
    user: '49',
    date: '2024-04-03T12:45:25Z',
    status: 'inProgress',
  },
  {
    id: '0c3bca3c-6c29-4689-a010-116a4fb2be66',
    currency: 'GCS',
    amount: -6389.976779,
    user: '21',
    date: '2024-06-26T21:43:33Z',
    status: 'inProgress',
  },
  {
    id: '9920716e-1b3d-4159-83e9-ad228238356d',
    currency: 'GCS',
    amount: 1136.234329,
    user: '82',
    date: '2024-11-25T05:32:29Z',
    status: 'inProgress',
  },
  {
    id: '85910e15-befe-4bb8-bcf5-38e2565f09f5',
    currency: 'ICS',
    amount: -4951.886705,
    user: '28',
    date: '2024-03-17T10:28:11Z',
    status: 'inProgress',
  },
  {
    id: '27cc45f0-a2be-4a30-a0c8-d363bc8f9fba',
    currency: 'GCS',
    amount: 336.463061,
    user: '45',
    date: '2024-12-24T12:22:48Z',
    status: 'blocked',
  },
  {
    id: 'f8e5aa53-3b9e-430b-af7d-c8071cda5c0a',
    currency: 'ICS',
    amount: 2858.804539,
    user: '72',
    date: '2024-07-29T11:14:40Z',
    status: 'inProgress',
  },
  {
    id: '2f4e5d28-72df-469e-9c15-82631496ef4c',
    currency: 'GCS',
    amount: -7033.77636,
    user: '51',
    date: '2024-02-12T14:54:19Z',
    status: 'inProgress',
  },
  {
    id: '5085f5f2-17e8-4f91-ad07-0e0b9e4cff14',
    currency: 'ICS',
    amount: 3522.4409,
    user: '41',
    date: '2024-11-14T13:51:18Z',
    status: 'inProgress',
  },
  {
    id: 'b853bdd4-a510-417a-95e7-85cf537d2648',
    currency: 'ICS',
    amount: 1378.625448,
    user: '42',
    date: '2024-04-13T14:41:37Z',
    status: 'blocked',
  },
  {
    id: 'ab889753-c361-436f-9bd3-d5cf042234ca',
    currency: 'ICS',
    amount: -1248.729094,
    user: '18',
    date: '2024-12-02T23:00:05Z',
    status: 'completed',
  },
  {
    id: '705e997c-8bc3-4bdc-af22-1d085c933b29',
    currency: 'GCS',
    amount: -3254.170264,
    user: '26',
    date: '2024-06-15T20:55:41Z',
    status: 'completed',
  },
  {
    id: 'ce1152d7-544c-4f66-84ca-7532f219e5c1',
    currency: 'ICS',
    amount: 1665.13603,
    user: '46',
    date: '2024-03-27T07:11:52Z',
    status: 'completed',
  },
  {
    id: 'cb006f69-06d6-42c2-8d65-c7d6ce1992b8',
    currency: 'GCS',
    amount: 9360.283981,
    user: '50',
    date: '2024-01-12T06:30:30Z',
    status: 'completed',
  },
  {
    id: 'f50ff940-c8dd-4869-a4de-37e848c760c2',
    currency: 'ICS',
    amount: -8486.765734,
    user: '44',
    date: '2024-03-03T03:31:12Z',
    status: 'inProgress',
  },
  {
    id: '1172162d-dd6c-4ba5-97f8-4126dd3449c6',
    currency: 'GCS',
    amount: 6925.624085,
    user: '34',
    date: '2024-01-18T04:03:51Z',
    status: 'completed',
  },
  {
    id: 'b73fcde6-79c6-4bb9-9c8a-b649a06e4361',
    currency: 'ICS',
    amount: -468.428915,
    user: '67',
    date: '2024-06-23T02:11:21Z',
    status: 'blocked',
  },
  {
    id: '9021539a-1028-483f-9171-dbd4828271e4',
    currency: 'ICS',
    amount: 3227.705479,
    user: '28',
    date: '2024-01-31T11:33:06Z',
    status: 'inProgress',
  },
  {
    id: '6184da93-01cd-4c1f-9b40-5e4ab2024ca3',
    currency: 'ICS',
    amount: 7549.522706,
    user: '15',
    date: '2024-01-27T05:59:39Z',
    status: 'completed',
  },
  {
    id: '3960c4ad-5ce0-4c52-a377-d02b113af1ef',
    currency: 'GCS',
    amount: -3543.480499,
    user: '2',
    date: '2024-02-03T05:18:07Z',
    status: 'inProgress',
  },
  {
    id: '140e2729-1f08-4977-bf6c-5a0f94299bfb',
    currency: 'GCS',
    amount: -7453.494212,
    user: '22',
    date: '2024-11-23T21:03:25Z',
    status: 'completed',
  },
  {
    id: '7449d55f-de89-4374-b592-9785ccdce1e5',
    currency: 'ICS',
    amount: -6634.181642,
    user: '16',
    date: '2024-07-25T16:58:00Z',
    status: 'completed',
  },
  {
    id: 'be5c12f1-284d-460f-952a-3c291d85319c',
    currency: 'ICS',
    amount: 9335.970266,
    user: '8',
    date: '2024-11-03T14:53:39Z',
    status: 'blocked',
  },
  {
    id: '3b87dfa7-f410-45b3-96a4-5f652f7de215',
    currency: 'GCS',
    amount: 2393.674842,
    user: '65',
    date: '2024-03-14T02:10:33Z',
    status: 'inProgress',
  },
  {
    id: '6beb995f-07fa-4b96-b23c-eec2846ccadd',
    currency: 'GCS',
    amount: 2862.058354,
    user: '11',
    date: '2024-01-24T07:07:12Z',
    status: 'blocked',
  },
  {
    id: 'f59afdae-2368-4dec-b4fc-4a42900e6cb6',
    currency: 'GCS',
    amount: 2162.521256,
    user: '76',
    date: '2024-02-10T02:30:02Z',
    status: 'blocked',
  },
  {
    id: 'd5033262-47fb-4da6-9897-ecee8ac1648f',
    currency: 'ICS',
    amount: -9723.314858,
    user: '40',
    date: '2024-11-16T04:59:49Z',
    status: 'blocked',
  },
  {
    id: '7aede5c9-b0dc-47d0-9f4c-6a74f05fd16e',
    currency: 'ICS',
    amount: -9475.852297,
    user: '17',
    date: '2024-12-09T18:18:26Z',
    status: 'completed',
  },
  {
    id: 'cc1b685d-0259-4c2c-b182-81ca41fbec45',
    currency: 'ICS',
    amount: -3804.223906,
    user: '38',
    date: '2024-09-23T23:34:35Z',
    status: 'completed',
  },
  {
    id: 'd7e5bbcd-a960-407c-a71e-0761e8037d05',
    currency: 'ICS',
    amount: -5486.252325,
    user: '58',
    date: '2024-05-31T03:52:21Z',
    status: 'completed',
  },
  {
    id: '9838be8c-7381-4e2a-a23c-808dac7ab1a4',
    currency: 'ICS',
    amount: -4251.945445,
    user: '15',
    date: '2024-12-05T07:26:38Z',
    status: 'blocked',
  },
  {
    id: '4c3fccaa-30ad-4e44-a52e-b03c84702cc0',
    currency: 'GCS',
    amount: -596.701752,
    user: '1',
    date: '2024-12-18T11:16:50Z',
    status: 'inProgress',
  },
  {
    id: '0ccb4f02-6f49-4a98-aa53-36176fe849d9',
    currency: 'ICS',
    amount: -8739.91233,
    user: '65',
    date: '2024-01-23T14:31:43Z',
    status: 'completed',
  },
  {
    id: 'fbbf45e4-90be-4903-9277-5823f1400dfd',
    currency: 'ICS',
    amount: 7605.93229,
    user: '22',
    date: '2024-10-09T23:20:47Z',
    status: 'inProgress',
  },
  {
    id: 'a0668baa-09a5-40e3-8f35-e40c41e9896f',
    currency: 'GCS',
    amount: -1946.435741,
    user: '22',
    date: '2024-01-07T01:43:48Z',
    status: 'inProgress',
  },
  {
    id: 'ce468058-aeba-4bde-8c39-46e74f524e0c',
    currency: 'ICS',
    amount: -1192.981886,
    user: '43',
    date: '2024-01-02T14:24:58Z',
    status: 'blocked',
  },
  {
    id: 'f6bd37b2-1887-4c6d-8d26-45309c240469',
    currency: 'ICS',
    amount: -976.584769,
    user: '70',
    date: '2024-11-14T20:29:45Z',
    status: 'blocked',
  },
  {
    id: '1426b6ff-0898-40f5-96e6-34f4c97f9d19',
    currency: 'GCS',
    amount: 2340.144951,
    user: '82',
    date: '2024-03-31T20:55:18Z',
    status: 'completed',
  },
  {
    id: '502c3342-e21d-413a-9362-63e9e43ed94a',
    currency: 'ICS',
    amount: -5080.505399,
    user: '46',
    date: '2024-05-15T04:31:04Z',
    status: 'blocked',
  },
  {
    id: 'db8fa70a-de1e-4c44-823b-b412979eb4d0',
    currency: 'ICS',
    amount: -8660.244673,
    user: '52',
    date: '2024-05-20T09:41:36Z',
    status: 'blocked',
  },
  {
    id: 'ddaa585f-ff81-4c2e-b1f6-19c656866eba',
    currency: 'GCS',
    amount: 5891.765082,
    user: '24',
    date: '2024-06-12T14:36:45Z',
    status: 'completed',
  },
  {
    id: '820e810e-ab03-41e1-b379-bbd46c7e34fe',
    currency: 'ICS',
    amount: -49.270013,
    user: '63',
    date: '2024-12-10T05:32:33Z',
    status: 'blocked',
  },
  {
    id: 'd6d48b3f-3d11-4d6c-8bdd-be32b7924239',
    currency: 'GCS',
    amount: 8773.383327,
    user: '16',
    date: '2024-03-15T20:07:24Z',
    status: 'completed',
  },
  {
    id: '5f59159d-08ce-478f-9556-14999c7ee84b',
    currency: 'ICS',
    amount: 8574.76348,
    user: '40',
    date: '2024-08-24T20:45:57Z',
    status: 'inProgress',
  },
  {
    id: 'ff1ca968-42ac-4e9e-bafd-1099b4a4a356',
    currency: 'ICS',
    amount: -4171.136872,
    user: '68',
    date: '2024-08-06T17:05:39Z',
    status: 'inProgress',
  },
  {
    id: '4cf84c57-066f-4147-918b-0673524029b4',
    currency: 'GCS',
    amount: 617.286305,
    user: '10',
    date: '2024-11-18T15:01:52Z',
    status: 'inProgress',
  },
  {
    id: 'ad10587b-f96b-4085-8ca5-3205abc01782',
    currency: 'ICS',
    amount: 6732.485714,
    user: '49',
    date: '2024-02-12T09:26:03Z',
    status: 'inProgress',
  },
  {
    id: '476c1d33-555a-4e4b-8eec-05c7f668ae05',
    currency: 'GCS',
    amount: 6092.222095,
    user: '61',
    date: '2024-01-08T15:18:02Z',
    status: 'inProgress',
  },
  {
    id: '7e7165f6-94d7-41d1-aa29-153da4f8eec1',
    currency: 'GCS',
    amount: -6600.032505,
    user: '24',
    date: '2024-11-09T14:14:42Z',
    status: 'completed',
  },
  {
    id: '82ed6fbf-32de-4d45-8c1d-e4d4b9b9d7bf',
    currency: 'ICS',
    amount: 8264.942776,
    user: '16',
    date: '2024-04-21T01:50:53Z',
    status: 'blocked',
  },
  {
    id: '01af199d-53db-4bc5-aaca-3d3379ed472a',
    currency: 'GCS',
    amount: 3633.770412,
    user: '42',
    date: '2024-10-08T02:59:58Z',
    status: 'completed',
  },
  {
    id: '2a6212aa-444c-4544-b9d8-e0aeb6671ca8',
    currency: 'GCS',
    amount: 6807.704424,
    user: '71',
    date: '2024-10-31T17:00:46Z',
    status: 'completed',
  },
  {
    id: '7f2098eb-3fc4-4e5f-b143-4fa859216438',
    currency: 'ICS',
    amount: -5629.436087,
    user: '31',
    date: '2024-09-26T13:32:24Z',
    status: 'completed',
  },
  {
    id: '43248cb8-a379-4cd1-9838-3b1efa679d1c',
    currency: 'GCS',
    amount: 9050.855952,
    user: '68',
    date: '2024-11-09T17:37:07Z',
    status: 'blocked',
  },
  {
    id: '5365a00b-cf60-4125-ad42-96a1e54b8efb',
    currency: 'GCS',
    amount: -844.110527,
    user: '49',
    date: '2024-04-29T23:11:36Z',
    status: 'blocked',
  },
  {
    id: '86bc1c9c-6457-44dc-83e6-7146199a9533',
    currency: 'GCS',
    amount: -3318.946192,
    user: '56',
    date: '2024-05-10T19:57:51Z',
    status: 'inProgress',
  },
  {
    id: '8778c932-94a2-4582-a1cf-653d32f003f2',
    currency: 'ICS',
    amount: -4661.821056,
    user: '47',
    date: '2024-02-22T20:48:10Z',
    status: 'completed',
  },
  {
    id: '7cf1781a-7242-4b93-b599-5e89432956bd',
    currency: 'ICS',
    amount: -4315.940305,
    user: '42',
    date: '2024-08-02T17:42:47Z',
    status: 'blocked',
  },
  {
    id: '6b1e1f45-edbf-4777-9797-98d6caea3fce',
    currency: 'GCS',
    amount: -4943.409323,
    user: '8',
    date: '2024-04-19T13:40:02Z',
    status: 'inProgress',
  },
  {
    id: 'c17c3a7e-e203-4bc2-9178-2862d65a51b8',
    currency: 'ICS',
    amount: -2357.198663,
    user: '30',
    date: '2024-02-04T02:18:20Z',
    status: 'inProgress',
  },
  {
    id: '1ec64fd9-b91d-4216-9677-98b4d88fcaff',
    currency: 'GCS',
    amount: -5278.854199,
    user: '57',
    date: '2024-06-27T09:17:42Z',
    status: 'inProgress',
  },
  {
    id: 'fd220ad5-6a49-4704-a554-f97d7eed2a8f',
    currency: 'GCS',
    amount: 1398.771473,
    user: '19',
    date: '2024-04-27T16:00:50Z',
    status: 'blocked',
  },
  {
    id: 'c204b808-a6fd-4c9a-b43c-dae10370eac4',
    currency: 'GCS',
    amount: 5663.845027,
    user: '16',
    date: '2024-12-18T23:21:28Z',
    status: 'blocked',
  },
  {
    id: '2accad02-a2ad-4e2b-8c9e-00868e017880',
    currency: 'ICS',
    amount: 4892.967916,
    user: '25',
    date: '2024-04-12T05:22:51Z',
    status: 'completed',
  },
  {
    id: '127a2bfd-02ef-4c02-828d-88909fe84f32',
    currency: 'GCS',
    amount: -4824.823632,
    user: '16',
    date: '2024-08-12T01:27:18Z',
    status: 'completed',
  },
  {
    id: 'ee4113d0-8466-4569-a4d5-4a21f68bca2d',
    currency: 'ICS',
    amount: -6728.574134,
    user: '65',
    date: '2024-08-02T15:57:15Z',
    status: 'completed',
  },
  {
    id: '925d824e-3fe9-44e8-b1c6-cb1c988dd043',
    currency: 'GCS',
    amount: 418.768623,
    user: '22',
    date: '2024-03-19T22:22:30Z',
    status: 'inProgress',
  },
  {
    id: '94127dbc-155b-4aaf-a8e9-e208c8681fed',
    currency: 'ICS',
    amount: 3460.50232,
    user: '9',
    date: '2024-05-20T10:39:33Z',
    status: 'inProgress',
  },
  {
    id: '89a588f9-e2dd-44c3-a768-d9daeea31801',
    currency: 'GCS',
    amount: -2485.37754,
    user: '57',
    date: '2024-02-21T23:21:58Z',
    status: 'blocked',
  },
  {
    id: 'feee62cf-035b-456e-86f0-da289def3be4',
    currency: 'ICS',
    amount: 179.745096,
    user: '8',
    date: '2024-02-07T02:33:17Z',
    status: 'completed',
  },
  {
    id: '11585604-2b93-47d9-9e4b-9bc54121d6bd',
    currency: 'GCS',
    amount: 2001.994207,
    user: '66',
    date: '2024-07-19T20:41:00Z',
    status: 'inProgress',
  },
  {
    id: '921efff6-11a1-4e71-aa8b-632b452b5b04',
    currency: 'GCS',
    amount: -7483.824808,
    user: '34',
    date: '2024-06-13T17:47:47Z',
    status: 'blocked',
  },
  {
    id: 'd229ef77-01fa-4b34-8d5a-9b25bc4d0665',
    currency: 'ICS',
    amount: 8955.844848,
    user: '41',
    date: '2024-08-03T02:44:56Z',
    status: 'blocked',
  },
  {
    id: 'e6c787c3-05c3-45f0-b606-8e980c633097',
    currency: 'ICS',
    amount: -8463.537202,
    user: '25',
    date: '2024-09-25T23:54:46Z',
    status: 'completed',
  },
  {
    id: 'f10bea41-eccb-4141-b88a-b56d5ab9ef73',
    currency: 'ICS',
    amount: -1088.4097,
    user: '2',
    date: '2024-09-17T04:35:51Z',
    status: 'completed',
  },
  {
    id: '6ee79838-9eca-44fd-bb74-a1a9e1958981',
    currency: 'GCS',
    amount: -8230.226615,
    user: '14',
    date: '2024-04-30T08:28:02Z',
    status: 'inProgress',
  },
  {
    id: '7f9abf1a-4399-4b27-b486-c0c591e1ca1b',
    currency: 'GCS',
    amount: 9308.035971,
    user: '66',
    date: '2024-08-08T20:48:03Z',
    status: 'completed',
  },
  {
    id: 'd9674c04-c5ea-4245-aaa9-b41d04be1bbe',
    currency: 'GCS',
    amount: -9726.397418,
    user: '63',
    date: '2024-07-05T15:05:11Z',
    status: 'completed',
  },
  {
    id: '24446fbb-ca0e-4f54-86e8-47056814cd4e',
    currency: 'GCS',
    amount: -6726.756439,
    user: '14',
    date: '2024-04-15T06:06:38Z',
    status: 'completed',
  },
  {
    id: '2f97ee8a-096a-4a89-98de-9395aa5bddce',
    currency: 'GCS',
    amount: -1996.119065,
    user: '20',
    date: '2024-07-08T09:29:23Z',
    status: 'inProgress',
  },
  {
    id: 'e3c6495b-1cfe-41a4-8aab-27deb94dd6aa',
    currency: 'ICS',
    amount: 6888.093724,
    user: '79',
    date: '2024-06-22T23:13:11Z',
    status: 'inProgress',
  },
  {
    id: '1b9a5038-f8bb-425b-9c77-7f2c3c74f346',
    currency: 'ICS',
    amount: 8535.293121,
    user: '29',
    date: '2024-05-10T22:46:26Z',
    status: 'completed',
  },
  {
    id: '10e46aee-61b5-4f91-9370-1f8742d06fd2',
    currency: 'ICS',
    amount: 6224.553864,
    user: '4',
    date: '2024-04-30T11:16:34Z',
    status: 'completed',
  },
  {
    id: '377a86e3-f0d6-47d8-bf84-8d47cd819a6c',
    currency: 'ICS',
    amount: 3426.599686,
    user: '50',
    date: '2024-03-08T20:44:41Z',
    status: 'completed',
  },
  {
    id: 'e3cd83da-8880-4a3f-a0dd-e52d238a27b7',
    currency: 'ICS',
    amount: -233.345517,
    user: '71',
    date: '2024-11-22T01:23:21Z',
    status: 'completed',
  },
  {
    id: 'd9afe8a7-dcd8-4851-ac5f-46fc4a238153',
    currency: 'GCS',
    amount: 7369.848024,
    user: '81',
    date: '2024-07-01T23:37:40Z',
    status: 'blocked',
  },
  {
    id: '75677590-6812-4d5c-8984-2c70dcbb4014',
    currency: 'GCS',
    amount: -8907.984579,
    user: '31',
    date: '2024-02-21T15:15:40Z',
    status: 'blocked',
  },
  {
    id: '170883bb-84dd-48df-b172-e099335289e8',
    currency: 'ICS',
    amount: -3957.47825,
    user: '17',
    date: '2024-04-13T02:30:35Z',
    status: 'inProgress',
  },
  {
    id: 'ed90a238-5593-42ad-b4d5-b2ba931035fa',
    currency: 'GCS',
    amount: -7685.961766,
    user: '42',
    date: '2024-01-10T22:05:05Z',
    status: 'inProgress',
  },
  {
    id: '97cbbd67-fbf8-4f2a-8f21-912c26ed03cf',
    currency: 'GCS',
    amount: 9029.357922,
    user: '78',
    date: '2024-07-18T08:23:19Z',
    status: 'inProgress',
  },
  {
    id: 'df87b53b-0b15-4f1c-a4f3-591d53409b05',
    currency: 'GCS',
    amount: -8079.596223,
    user: '83',
    date: '2024-10-23T10:27:38Z',
    status: 'inProgress',
  },
  {
    id: '61eee55f-74a3-491e-a5c1-70f8a0bdb179',
    currency: 'ICS',
    amount: -9881.141875,
    user: '63',
    date: '2024-11-29T14:24:24Z',
    status: 'inProgress',
  },
  {
    id: 'c1195e45-9e62-4920-af5a-7e6c781c97bc',
    currency: 'GCS',
    amount: 1484.875776,
    user: '50',
    date: '2024-10-22T01:40:51Z',
    status: 'blocked',
  },
  {
    id: '72fda0eb-37cc-4e81-94c7-690b554d92ec',
    currency: 'GCS',
    amount: -5445.735147,
    user: '79',
    date: '2024-06-10T01:48:20Z',
    status: 'completed',
  },
  {
    id: '60da3edc-8892-4cd2-8b9c-a828ba6c115a',
    currency: 'GCS',
    amount: 8768.470753,
    user: '26',
    date: '2024-06-06T10:31:33Z',
    status: 'inProgress',
  },
  {
    id: '5209385f-7e2b-40a8-9e39-a1fd94c367d6',
    currency: 'ICS',
    amount: -6724.170711,
    user: '29',
    date: '2024-11-11T11:15:34Z',
    status: 'inProgress',
  },
  {
    id: 'd6ad56f5-9d7c-42ad-98d2-9a304170a584',
    currency: 'GCS',
    amount: 1100.613942,
    user: '28',
    date: '2024-07-17T04:32:37Z',
    status: 'completed',
  },
  {
    id: 'd6151c03-13c8-45a5-94a4-80bc0886cb55',
    currency: 'GCS',
    amount: 459.488383,
    user: '40',
    date: '2024-10-26T02:12:41Z',
    status: 'blocked',
  },
  {
    id: '22b5f5e4-4a3b-4e8c-b43a-788846931b45',
    currency: 'GCS',
    amount: -3202.908629,
    user: '12',
    date: '2024-04-23T01:55:51Z',
    status: 'inProgress',
  },
  {
    id: 'beabb8a5-620b-413f-977d-3988c9434237',
    currency: 'ICS',
    amount: -5104.275018,
    user: '21',
    date: '2024-06-11T13:54:35Z',
    status: 'blocked',
  },
  {
    id: 'af8fbba5-9640-4382-aed0-cfc420e99908',
    currency: 'ICS',
    amount: -8183.077439,
    user: '59',
    date: '2024-04-11T10:57:46Z',
    status: 'completed',
  },
  {
    id: '66310c7e-c5d4-41ed-8259-bf7deae27a0e',
    currency: 'GCS',
    amount: 4604.84653,
    user: '16',
    date: '2024-05-08T21:48:37Z',
    status: 'inProgress',
  },
  {
    id: 'f29f6d15-0d27-42e4-aa4b-9e82777ba57d',
    currency: 'ICS',
    amount: -3419.613407,
    user: '25',
    date: '2024-11-15T08:33:41Z',
    status: 'blocked',
  },
  {
    id: '30876a81-af8c-43a5-b137-1d898c36bff4',
    currency: 'ICS',
    amount: 2829.957234,
    user: '19',
    date: '2024-05-02T15:37:36Z',
    status: 'blocked',
  },
  {
    id: '74e7b3cb-24f3-4233-aae1-6b07f3896027',
    currency: 'GCS',
    amount: 2612.546372,
    user: '10',
    date: '2024-06-24T02:55:07Z',
    status: 'inProgress',
  },
  {
    id: '1732dc67-889f-4f0c-9928-50e8bd485167',
    currency: 'ICS',
    amount: -313.166372,
    user: '28',
    date: '2024-12-05T10:19:15Z',
    status: 'inProgress',
  },
  {
    id: '4eb81d6e-cb4a-49ab-91e8-2b014495655f',
    currency: 'ICS',
    amount: -6764.389151,
    user: '10',
    date: '2024-12-28T21:25:56Z',
    status: 'blocked',
  },
  {
    id: '39bdea3d-5abe-4dc5-9215-b0e491917ffe',
    currency: 'GCS',
    amount: -8707.119227,
    user: '27',
    date: '2024-09-03T07:36:21Z',
    status: 'blocked',
  },
  {
    id: 'b4436cba-5d1a-486f-ae44-292bcd6bbcd8',
    currency: 'ICS',
    amount: -1985.948669,
    user: '79',
    date: '2024-06-02T00:25:49Z',
    status: 'blocked',
  },
  {
    id: '9b0c431f-700f-442c-a19a-a0058f826a88',
    currency: 'ICS',
    amount: -3847.415976,
    user: '28',
    date: '2024-01-18T15:31:30Z',
    status: 'blocked',
  },
  {
    id: 'ad309b07-4444-4cc8-a57b-89b0d79a7aff',
    currency: 'GCS',
    amount: -6360.456342,
    user: '19',
    date: '2024-06-12T06:44:46Z',
    status: 'inProgress',
  },
  {
    id: '138dd3ae-d59c-4d11-852f-2761dbfef86c',
    currency: 'GCS',
    amount: 4502.780692,
    user: '29',
    date: '2024-11-24T06:41:40Z',
    status: 'completed',
  },
  {
    id: 'ff05964c-6394-40e5-905e-efb21df4e14a',
    currency: 'ICS',
    amount: 1336.499654,
    user: '20',
    date: '2024-06-30T01:51:43Z',
    status: 'inProgress',
  },
  {
    id: '996bb6e4-1720-477d-8ec7-78501fff4d28',
    currency: 'ICS',
    amount: -1031.473539,
    user: '69',
    date: '2024-01-27T10:38:51Z',
    status: 'completed',
  },
  {
    id: 'c6a8f8d7-235f-4984-9979-01e2589be081',
    currency: 'ICS',
    amount: 2038.816024,
    user: '6',
    date: '2024-08-07T12:06:01Z',
    status: 'blocked',
  },
  {
    id: 'd2143051-94ab-4443-be90-7df758694747',
    currency: 'ICS',
    amount: -995.371718,
    user: '5',
    date: '2024-04-09T15:48:24Z',
    status: 'blocked',
  },
  {
    id: '64a07afa-3900-46f2-a120-d4d0e77b2458',
    currency: 'GCS',
    amount: 2723.681384,
    user: '71',
    date: '2024-02-20T11:54:38Z',
    status: 'blocked',
  },
  {
    id: '8892549b-0a86-47d6-8383-4988e915389e',
    currency: 'GCS',
    amount: 5732.219807,
    user: '74',
    date: '2024-01-13T16:55:11Z',
    status: 'inProgress',
  },
  {
    id: '6451b9c6-517a-4bf7-8c17-23f45b206cab',
    currency: 'ICS',
    amount: -9583.457982,
    user: '5',
    date: '2024-05-19T08:15:34Z',
    status: 'completed',
  },
  {
    id: '09abff98-cbae-410d-ba77-df373c695b3a',
    currency: 'ICS',
    amount: -3320.313683,
    user: '63',
    date: '2024-12-27T23:52:36Z',
    status: 'completed',
  },
  {
    id: 'fbb96cc1-48ac-4f52-90f8-f3a532bdeb4c',
    currency: 'GCS',
    amount: -6466.519264,
    user: '1',
    date: '2024-02-13T11:34:47Z',
    status: 'completed',
  },
  {
    id: 'c9bb03e9-6aa8-4cd2-b0a1-a1b0604e17ff',
    currency: 'ICS',
    amount: 7619.241215,
    user: '2',
    date: '2024-11-17T10:30:30Z',
    status: 'completed',
  },
  {
    id: 'de05e9e0-3e29-4cb5-9f6e-3410416a6446',
    currency: 'GCS',
    amount: -1763.977758,
    user: '1',
    date: '2024-09-07T07:32:22Z',
    status: 'blocked',
  },
  {
    id: '4a9fdaa9-e04a-4fa1-b00b-89e654105134',
    currency: 'GCS',
    amount: 6752.896985,
    user: '57',
    date: '2024-09-03T18:03:55Z',
    status: 'inProgress',
  },
  {
    id: 'b54c8550-5f92-42eb-93fd-0f71ce821a6e',
    currency: 'ICS',
    amount: -1413.195295,
    user: '25',
    date: '2024-11-27T08:06:58Z',
    status: 'blocked',
  },
  {
    id: '4b89ba82-be9c-454c-8547-c8bdfad02b95',
    currency: 'GCS',
    amount: -687.232464,
    user: '34',
    date: '2024-11-01T08:55:08Z',
    status: 'blocked',
  },
  {
    id: 'a49712f6-631c-4cb4-a38b-0eb3abf6163f',
    currency: 'ICS',
    amount: -6675.035711,
    user: '64',
    date: '2024-05-18T04:33:59Z',
    status: 'completed',
  },
  {
    id: 'b82cd79e-562c-476a-8504-742023dba9bf',
    currency: 'ICS',
    amount: -9373.056293,
    user: '18',
    date: '2024-05-27T11:47:41Z',
    status: 'inProgress',
  },
  {
    id: '18844373-8d49-4c6d-9fc4-981f80282782',
    currency: 'GCS',
    amount: 8325.708147,
    user: '33',
    date: '2024-12-06T06:51:49Z',
    status: 'inProgress',
  },
  {
    id: 'e9cb4fb0-e080-40e7-ad0c-15c764f31679',
    currency: 'ICS',
    amount: -7297.207813,
    user: '11',
    date: '2024-07-16T01:52:28Z',
    status: 'blocked',
  },
  {
    id: '33865697-058b-488a-828e-a35d93a3abf8',
    currency: 'ICS',
    amount: 1628.744852,
    user: '60',
    date: '2024-02-24T13:15:21Z',
    status: 'inProgress',
  },
  {
    id: '581c241e-6f2b-4c48-a460-a8ed53652355',
    currency: 'GCS',
    amount: -2055.191412,
    user: '33',
    date: '2024-07-21T14:04:12Z',
    status: 'blocked',
  },
  {
    id: '1e265942-7e64-425d-b014-5c047c32ec08',
    currency: 'ICS',
    amount: 9932.394912,
    user: '21',
    date: '2024-03-14T12:45:50Z',
    status: 'completed',
  },
  {
    id: '9460c1dd-8a12-4de4-bab8-7aa075f5b81c',
    currency: 'ICS',
    amount: -6631.864234,
    user: '7',
    date: '2024-02-26T05:44:39Z',
    status: 'completed',
  },
  {
    id: '2a58617c-885e-4e35-ba44-6efea1e3ef97',
    currency: 'GCS',
    amount: 8112.555701,
    user: '49',
    date: '2024-05-11T22:01:19Z',
    status: 'blocked',
  },
  {
    id: 'eefc0cf4-bf30-43c9-b54f-85b45fb71f84',
    currency: 'ICS',
    amount: -1455.6351,
    user: '75',
    date: '2024-05-12T01:59:14Z',
    status: 'blocked',
  },
  {
    id: 'f7bb3751-a5fb-4191-8a27-42b7156e921f',
    currency: 'ICS',
    amount: -6237.019345,
    user: '27',
    date: '2024-04-26T17:28:52Z',
    status: 'inProgress',
  },
  {
    id: 'cd6ca838-04d8-4453-aa3f-f04639064bd9',
    currency: 'GCS',
    amount: 2349.864284,
    user: '59',
    date: '2024-04-26T18:56:22Z',
    status: 'completed',
  },
  {
    id: '34273102-7da3-4834-89ec-3a97ff56ee46',
    currency: 'ICS',
    amount: 2153.594021,
    user: '6',
    date: '2024-07-12T21:15:10Z',
    status: 'inProgress',
  },
  {
    id: '8278c5f5-72ab-472d-923d-9d1f5fff5b81',
    currency: 'ICS',
    amount: 8249.696473,
    user: '65',
    date: '2024-04-10T10:35:16Z',
    status: 'blocked',
  },
  {
    id: 'ea23bac0-fa1a-4f29-a893-ab3dc6248ca2',
    currency: 'GCS',
    amount: 741.382473,
    user: '2',
    date: '2024-11-25T03:30:23Z',
    status: 'blocked',
  },
  {
    id: '7491c2f8-072d-4a4d-925f-13f7e91c92dd',
    currency: 'ICS',
    amount: 6538.286604,
    user: '15',
    date: '2024-04-21T11:13:41Z',
    status: 'blocked',
  },
  {
    id: '301a97c8-75ba-403d-bfe6-7be005101504',
    currency: 'GCS',
    amount: -7167.154677,
    user: '48',
    date: '2024-01-03T17:12:02Z',
    status: 'inProgress',
  },
  {
    id: '06168c42-19b9-4c67-b547-658c3fd3cade',
    currency: 'GCS',
    amount: -6352.109643,
    user: '19',
    date: '2024-12-18T19:26:01Z',
    status: 'inProgress',
  },
  {
    id: '5bd75033-a962-4a63-8651-1c5a5893ec09',
    currency: 'GCS',
    amount: 6872.027226,
    user: '31',
    date: '2024-04-05T15:29:36Z',
    status: 'completed',
  },
  {
    id: '2ba1ae91-3eb9-4d92-a11f-80460eae9747',
    currency: 'GCS',
    amount: -7294.212118,
    user: '13',
    date: '2024-07-21T02:57:34Z',
    status: 'inProgress',
  },
  {
    id: '7a52c947-e16b-49c0-b5fe-835493a8bec6',
    currency: 'GCS',
    amount: 6775.898321,
    user: '48',
    date: '2024-03-06T19:31:38Z',
    status: 'completed',
  },
  {
    id: 'fb73d2a7-6c86-4539-b545-6985b7da0f7a',
    currency: 'GCS',
    amount: 5882.661343,
    user: '48',
    date: '2024-10-15T09:01:42Z',
    status: 'completed',
  },
  {
    id: '22f7ecee-15dc-4ec9-982e-d8b65c495e45',
    currency: 'ICS',
    amount: 6879.499393,
    user: '22',
    date: '2024-08-16T09:13:03Z',
    status: 'blocked',
  },
  {
    id: '1861bd9e-4166-4d25-bbd7-17e6505140f5',
    currency: 'ICS',
    amount: -3648.972806,
    user: '69',
    date: '2024-09-02T16:00:31Z',
    status: 'inProgress',
  },
  {
    id: '5b214c5e-6f51-4059-815c-0ee6fb3e067f',
    currency: 'ICS',
    amount: 8296.940915,
    user: '70',
    date: '2024-10-05T20:48:19Z',
    status: 'completed',
  },
  {
    id: 'e2b7c348-a58d-4e21-9238-acadfa05c0c4',
    currency: 'ICS',
    amount: 6475.109346,
    user: '19',
    date: '2024-01-10T11:52:22Z',
    status: 'inProgress',
  },
  {
    id: '5310bd1d-16bf-4ce0-9ee3-29d5d0754d27',
    currency: 'GCS',
    amount: -2911.570755,
    user: '46',
    date: '2024-10-10T15:24:22Z',
    status: 'inProgress',
  },
  {
    id: '7e02ea21-5ff4-4b53-bfdd-b9b1885ee3f0',
    currency: 'GCS',
    amount: -956.798388,
    user: '45',
    date: '2024-10-21T18:43:02Z',
    status: 'completed',
  },
  {
    id: '7f6cd8d0-46ad-419d-b81e-084d45b17ce0',
    currency: 'GCS',
    amount: -2284.361178,
    user: '70',
    date: '2024-12-11T12:10:36Z',
    status: 'blocked',
  },
  {
    id: '70545a91-3fda-48b6-8fdd-1b85b2717ffe',
    currency: 'GCS',
    amount: -6339.80528,
    user: '33',
    date: '2024-05-12T02:43:48Z',
    status: 'blocked',
  },
  {
    id: '0b172915-ad3c-4b15-b23d-81fafa52b0d6',
    currency: 'ICS',
    amount: 8218.210215,
    user: '48',
    date: '2024-10-24T16:11:47Z',
    status: 'completed',
  },
  {
    id: '8f708178-c4a4-4ec9-9d9a-73821c1167d4',
    currency: 'GCS',
    amount: -1125.790267,
    user: '59',
    date: '2024-01-17T12:34:34Z',
    status: 'completed',
  },
  {
    id: 'db580a7c-2c62-4d00-aa41-9075a1c7162b',
    currency: 'GCS',
    amount: 2354.272085,
    user: '34',
    date: '2024-02-18T20:31:40Z',
    status: 'blocked',
  },
  {
    id: '2a6ef508-24b8-4657-aadb-578a1c90e8ad',
    currency: 'GCS',
    amount: 6423.1067,
    user: '71',
    date: '2024-05-08T18:24:30Z',
    status: 'blocked',
  },
  {
    id: '68040be1-b882-4036-9eda-9e2200a91fa4',
    currency: 'ICS',
    amount: 596.543695,
    user: '78',
    date: '2024-10-14T00:04:40Z',
    status: 'completed',
  },
  {
    id: '535ce435-71ff-4b7b-acab-2f0b0bb4e968',
    currency: 'GCS',
    amount: -789.764433,
    user: '37',
    date: '2024-05-07T01:59:55Z',
    status: 'inProgress',
  },
  {
    id: '155a06c0-ed52-41a0-9095-13e4e86c2559',
    currency: 'GCS',
    amount: 6020.237187,
    user: '82',
    date: '2024-09-10T08:46:04Z',
    status: 'completed',
  },
  {
    id: '44c949e5-89fa-4ef3-a15e-51197e558b83',
    currency: 'GCS',
    amount: 7719.527998,
    user: '61',
    date: '2024-05-19T11:01:24Z',
    status: 'completed',
  },
  {
    id: '0db8726e-1e6d-4594-b321-31d6df95d8e2',
    currency: 'GCS',
    amount: -7253.866362,
    user: '25',
    date: '2024-03-06T12:17:08Z',
    status: 'inProgress',
  },
  {
    id: '1c73fedc-dfdf-4dd7-98f1-721acaaaa500',
    currency: 'GCS',
    amount: 5333.88063,
    user: '5',
    date: '2024-03-27T07:17:56Z',
    status: 'completed',
  },
  {
    id: 'a42da7f2-0136-438a-baaf-0df844d334b3',
    currency: 'ICS',
    amount: -590.93269,
    user: '52',
    date: '2024-08-15T13:00:46Z',
    status: 'completed',
  },
  {
    id: '5668a812-c5a6-4dfd-9762-2b6ec6d984ec',
    currency: 'GCS',
    amount: 9911.923557,
    user: '73',
    date: '2024-04-19T23:49:22Z',
    status: 'completed',
  },
  {
    id: '631b7a37-5e1d-4985-b140-107c9aa1ea9a',
    currency: 'ICS',
    amount: 4511.310406,
    user: '8',
    date: '2024-08-04T12:12:43Z',
    status: 'blocked',
  },
  {
    id: '52d64a4d-8f77-4e7f-aec2-2d5bd985d0d0',
    currency: 'GCS',
    amount: 640.012208,
    user: '65',
    date: '2024-06-20T01:28:26Z',
    status: 'inProgress',
  },
  {
    id: '013e559a-0b4e-4ad3-9ec2-570983302212',
    currency: 'ICS',
    amount: 4721.222443,
    user: '46',
    date: '2024-09-02T11:08:07Z',
    status: 'completed',
  },
  {
    id: 'a715e65e-f93d-4036-8bb8-79ee6e24b58f',
    currency: 'GCS',
    amount: 1897.506418,
    user: '11',
    date: '2024-09-10T15:52:51Z',
    status: 'blocked',
  },
  {
    id: 'f482780f-f419-48be-ac85-1bb517139013',
    currency: 'GCS',
    amount: 9731.450842,
    user: '55',
    date: '2024-11-24T08:46:30Z',
    status: 'completed',
  },
  {
    id: '2a2e1a3b-577f-4eb8-a461-b78a28853fc9',
    currency: 'GCS',
    amount: 6967.360179,
    user: '62',
    date: '2024-06-01T18:02:01Z',
    status: 'completed',
  },
  {
    id: 'cec0778a-5b19-4eb4-94a4-53ac90d08b1f',
    currency: 'ICS',
    amount: 2873.488761,
    user: '52',
    date: '2024-01-16T18:07:12Z',
    status: 'completed',
  },
  {
    id: 'a7709b5e-72ca-4622-9db4-a2bcfdb5f68e',
    currency: 'ICS',
    amount: 5480.888268,
    user: '7',
    date: '2024-09-14T06:26:38Z',
    status: 'inProgress',
  },
  {
    id: '3e58d363-4889-4fcb-a129-8c49de7f2a43',
    currency: 'GCS',
    amount: 7197.424702,
    user: '45',
    date: '2024-11-03T03:45:07Z',
    status: 'inProgress',
  },
  {
    id: '7b2ef96f-0b2e-41cf-bc8d-d03f50025de5',
    currency: 'GCS',
    amount: -2225.922804,
    user: '37',
    date: '2024-07-16T01:34:46Z',
    status: 'blocked',
  },
  {
    id: 'eea84c76-48fc-4aa6-a6bf-d860831559cc',
    currency: 'ICS',
    amount: 7784.187246,
    user: '79',
    date: '2024-01-15T07:11:58Z',
    status: 'blocked',
  },
  {
    id: 'c73d047a-af47-435b-9e21-46969c56c1d1',
    currency: 'ICS',
    amount: -1576.662814,
    user: '73',
    date: '2024-05-03T21:17:21Z',
    status: 'inProgress',
  },
  {
    id: 'cd832e1c-3618-49e4-93d5-7786be804714',
    currency: 'ICS',
    amount: -8812.522899,
    user: '66',
    date: '2024-07-26T11:16:18Z',
    status: 'blocked',
  },
  {
    id: '131870e5-98c5-4b16-b50c-5ee0121f884d',
    currency: 'GCS',
    amount: 9706.948593,
    user: '1',
    date: '2024-08-05T11:24:20Z',
    status: 'blocked',
  },
  {
    id: '674eed13-2478-49dc-a9b0-68c558308d42',
    currency: 'ICS',
    amount: 6668.917787,
    user: '32',
    date: '2024-09-27T16:00:08Z',
    status: 'inProgress',
  },
  {
    id: 'cdbb99b0-8a7c-423d-8b6f-d66576e72eda',
    currency: 'ICS',
    amount: -2904.713324,
    user: '82',
    date: '2024-04-28T09:15:23Z',
    status: 'completed',
  },
  {
    id: '12dbd4af-7d55-4212-bb87-cf1ba357fecb',
    currency: 'ICS',
    amount: 5893.375979,
    user: '23',
    date: '2024-04-01T08:22:22Z',
    status: 'blocked',
  },
  {
    id: 'd334bb1e-c7a4-4efe-b170-f077e1231ffc',
    currency: 'ICS',
    amount: 9350.532286,
    user: '2',
    date: '2024-12-10T15:22:13Z',
    status: 'blocked',
  },
  {
    id: '8cd51fe1-fa26-4427-9f1d-4ff3fcc79377',
    currency: 'GCS',
    amount: -6836.135982,
    user: '71',
    date: '2024-12-10T22:41:38Z',
    status: 'inProgress',
  },
  {
    id: '84567126-84bf-4f48-9fe1-965a4ac82170',
    currency: 'ICS',
    amount: 5065.443549,
    user: '2',
    date: '2024-03-13T08:19:49Z',
    status: 'blocked',
  },
  {
    id: 'cc9bfadb-8ac8-400f-9b48-911f8b034611',
    currency: 'ICS',
    amount: -2800.72526,
    user: '25',
    date: '2024-03-13T02:21:19Z',
    status: 'completed',
  },
  {
    id: '4906bccf-b8d7-4897-afe3-d2f313720497',
    currency: 'ICS',
    amount: 538.994115,
    user: '63',
    date: '2024-01-02T02:48:17Z',
    status: 'inProgress',
  },
  {
    id: '1b79a379-ac56-46b9-9672-ae352334e1ce',
    currency: 'ICS',
    amount: 2818.511719,
    user: '21',
    date: '2024-02-24T07:55:18Z',
    status: 'blocked',
  },
  {
    id: '274b9ca7-a2b3-4dcb-a9cc-9f3dadc3a1f6',
    currency: 'ICS',
    amount: 3577.82431,
    user: '39',
    date: '2024-11-22T05:25:02Z',
    status: 'inProgress',
  },
  {
    id: '415ca9e0-7258-4b91-9ca5-4a6d829d3c73',
    currency: 'ICS',
    amount: 265.702396,
    user: '56',
    date: '2024-11-16T11:05:51Z',
    status: 'completed',
  },
  {
    id: '9f4eb15d-de66-4908-a4dc-ff825107d2aa',
    currency: 'GCS',
    amount: -8497.79709,
    user: '32',
    date: '2024-04-13T05:56:42Z',
    status: 'blocked',
  },
  {
    id: '4811b1db-d4ca-4a01-ad79-923a7434f28b',
    currency: 'GCS',
    amount: 2029.26743,
    user: '30',
    date: '2024-10-10T17:30:05Z',
    status: 'blocked',
  },
  {
    id: '70d492f7-218f-4781-a9a7-38683b511b38',
    currency: 'GCS',
    amount: 9417.69885,
    user: '7',
    date: '2024-11-26T00:57:44Z',
    status: 'inProgress',
  },
  {
    id: '610a0fdb-fd54-45f2-891f-4f2b68f2c9d7',
    currency: 'GCS',
    amount: -7654.479407,
    user: '73',
    date: '2024-05-01T07:28:29Z',
    status: 'blocked',
  },
  {
    id: '7e013f1e-5735-41c0-812d-51a449111a2f',
    currency: 'ICS',
    amount: 8478.62538,
    user: '49',
    date: '2024-12-23T18:43:51Z',
    status: 'inProgress',
  },
  {
    id: '6cad37b8-1d32-48f1-b767-a613db571350',
    currency: 'ICS',
    amount: -4047.346251,
    user: '49',
    date: '2024-06-22T18:43:25Z',
    status: 'completed',
  },
  {
    id: '7ee56e59-0ad1-4ad1-8dc7-6f45aad86f8d',
    currency: 'ICS',
    amount: 5819.176103,
    user: '49',
    date: '2024-12-16T13:19:21Z',
    status: 'blocked',
  },
  {
    id: '1a9ecc25-90cc-4fcd-b369-ed759de53e00',
    currency: 'GCS',
    amount: 7993.278218,
    user: '13',
    date: '2024-02-05T10:15:39Z',
    status: 'completed',
  },
  {
    id: 'd10b9699-753a-4b58-afd1-c74bcab75077',
    currency: 'GCS',
    amount: -3808.0488,
    user: '54',
    date: '2024-09-21T14:43:26Z',
    status: 'inProgress',
  },
  {
    id: 'fc63a6aa-98b4-4679-840e-840d0292eaca',
    currency: 'GCS',
    amount: -5867.22767,
    user: '8',
    date: '2024-10-30T05:35:52Z',
    status: 'completed',
  },
  {
    id: '93aefe03-4291-42fd-8a16-88d3ff32bb4e',
    currency: 'GCS',
    amount: -8553.13372,
    user: '24',
    date: '2024-04-20T22:29:12Z',
    status: 'completed',
  },
  {
    id: 'ce9fcbae-b458-4135-8eaf-a5cd5363c755',
    currency: 'ICS',
    amount: -5505.877856,
    user: '8',
    date: '2024-02-03T10:47:13Z',
    status: 'completed',
  },
  {
    id: 'd50ee371-282b-461a-b52c-307c0990a74d',
    currency: 'ICS',
    amount: 657.31818,
    user: '20',
    date: '2024-01-30T22:08:18Z',
    status: 'completed',
  },
  {
    id: '24612f58-6575-40fb-b9f8-78162469b6f1',
    currency: 'ICS',
    amount: -1218.175816,
    user: '80',
    date: '2024-07-21T12:04:51Z',
    status: 'inProgress',
  },
  {
    id: '9a71f900-9968-44b5-a373-bc2825abae1b',
    currency: 'GCS',
    amount: -4817.88058,
    user: '25',
    date: '2024-10-02T03:04:17Z',
    status: 'blocked',
  },
  {
    id: '25de7a4d-b69f-44f9-ae98-24eaa7eaa2e0',
    currency: 'ICS',
    amount: -7420.719812,
    user: '81',
    date: '2024-03-19T10:35:49Z',
    status: 'blocked',
  },
  {
    id: '81e20097-6c8f-4566-a714-8dd6b7bbad65',
    currency: 'ICS',
    amount: 9898.822505,
    user: '46',
    date: '2024-11-15T02:15:58Z',
    status: 'completed',
  },
  {
    id: '7abffb02-7b05-4f0c-bed1-a45346d56f90',
    currency: 'GCS',
    amount: 2331.854213,
    user: '72',
    date: '2024-02-14T03:01:15Z',
    status: 'completed',
  },
  {
    id: 'a6c1c1d5-776d-40a0-9dbe-d96b94c76297',
    currency: 'ICS',
    amount: 4251.622521,
    user: '3',
    date: '2024-10-24T22:07:03Z',
    status: 'blocked',
  },
  {
    id: '7d06a51f-19d2-4a94-b2a0-dde5635ebd7f',
    currency: 'GCS',
    amount: -803.609845,
    user: '25',
    date: '2024-08-28T23:45:53Z',
    status: 'completed',
  },
  {
    id: 'c9570eaa-9218-4540-98ed-ab43c4b606f5',
    currency: 'ICS',
    amount: 7791.505549,
    user: '38',
    date: '2024-05-06T14:29:27Z',
    status: 'inProgress',
  },
  {
    id: 'c48cc4ca-8712-45c0-a769-3bddea32ca19',
    currency: 'ICS',
    amount: 5135.199718,
    user: '18',
    date: '2024-04-29T06:08:21Z',
    status: 'inProgress',
  },
  {
    id: '9aac46c9-7dd0-40d3-ba00-43b14e719504',
    currency: 'ICS',
    amount: -4667.070781,
    user: '5',
    date: '2024-10-25T08:18:49Z',
    status: 'completed',
  },
  {
    id: 'a87344d8-a20c-4861-ac46-d3a1e93af3a3',
    currency: 'GCS',
    amount: -4975.982608,
    user: '66',
    date: '2024-11-03T20:56:32Z',
    status: 'completed',
  },
  {
    id: '6b26341b-5247-44b6-b59d-190f07895357',
    currency: 'ICS',
    amount: 6815.573173,
    user: '27',
    date: '2024-12-07T18:53:26Z',
    status: 'inProgress',
  },
  {
    id: '132a5296-2711-45a1-b846-e8b5f6b2e4c7',
    currency: 'ICS',
    amount: 5255.796236,
    user: '76',
    date: '2024-04-09T12:38:48Z',
    status: 'inProgress',
  },
  {
    id: '3a8be89d-e185-4598-a156-526227823b66',
    currency: 'ICS',
    amount: 6423.227172,
    user: '71',
    date: '2024-12-05T03:59:56Z',
    status: 'blocked',
  },
  {
    id: 'b549d19c-2439-4cdc-96e2-2114fcc9bb3d',
    currency: 'GCS',
    amount: -4827.737627,
    user: '67',
    date: '2024-04-01T04:05:11Z',
    status: 'completed',
  },
  {
    id: '619e0eb2-c443-42a5-b72e-6be008014e68',
    currency: 'ICS',
    amount: 8904.243329,
    user: '10',
    date: '2024-04-27T14:33:17Z',
    status: 'inProgress',
  },
  {
    id: 'ccdb6071-96ea-471e-a569-4b72ef8bf262',
    currency: 'GCS',
    amount: 8446.54644,
    user: '57',
    date: '2024-11-29T06:41:05Z',
    status: 'completed',
  },
  {
    id: '879beb39-7f4c-4dc8-905d-23f123ae2109',
    currency: 'ICS',
    amount: -9974.185542,
    user: '75',
    date: '2024-09-22T04:39:13Z',
    status: 'blocked',
  },
  {
    id: '99e74034-fdbe-4240-bb44-5280f3f6a816',
    currency: 'GCS',
    amount: -3657.088553,
    user: '20',
    date: '2024-10-21T18:45:20Z',
    status: 'completed',
  },
  {
    id: '6a40763e-b05e-4938-8c99-925692a04e1e',
    currency: 'ICS',
    amount: 3429.25993,
    user: '40',
    date: '2024-03-05T06:59:46Z',
    status: 'blocked',
  },
  {
    id: '846b0723-5500-40fb-9a4f-1258a03a5817',
    currency: 'ICS',
    amount: 8413.924017,
    user: '27',
    date: '2024-08-12T08:21:31Z',
    status: 'inProgress',
  },
  {
    id: 'c0bfa80a-9995-478a-9e7b-689382e9c1b5',
    currency: 'ICS',
    amount: -8822.919866,
    user: '82',
    date: '2024-12-03T18:32:42Z',
    status: 'inProgress',
  },
  {
    id: '6b51efb5-ea3a-414a-befb-2058e21be5e0',
    currency: 'GCS',
    amount: 7359.762999,
    user: '78',
    date: '2024-03-03T16:00:31Z',
    status: 'blocked',
  },
  {
    id: '3c3a98ba-5c4c-46dc-9856-a925f911b21e',
    currency: 'GCS',
    amount: 5664.113302,
    user: '59',
    date: '2024-03-02T05:34:43Z',
    status: 'completed',
  },
  {
    id: 'c4938876-d896-49da-92ad-0bf90f5d0f02',
    currency: 'ICS',
    amount: 415.945734,
    user: '80',
    date: '2024-09-01T07:28:26Z',
    status: 'inProgress',
  },
  {
    id: 'e3fc4e71-60d2-4929-82ab-40d6ed9d7ebe',
    currency: 'ICS',
    amount: 9627.194545,
    user: '76',
    date: '2024-07-17T15:19:39Z',
    status: 'completed',
  },
  {
    id: 'f458b66e-2e21-4908-a176-61643be4b14a',
    currency: 'ICS',
    amount: -6039.286884,
    user: '9',
    date: '2024-02-03T14:51:29Z',
    status: 'blocked',
  },
  {
    id: '87a55e0b-9960-4981-bea5-fdd770bfb713',
    currency: 'ICS',
    amount: 8336.039026,
    user: '68',
    date: '2024-03-15T03:04:18Z',
    status: 'blocked',
  },
  {
    id: 'ac19a325-f876-415b-b0f9-1b0097af0522',
    currency: 'ICS',
    amount: 4167.644041,
    user: '28',
    date: '2024-12-01T16:18:01Z',
    status: 'blocked',
  },
  {
    id: '07959b8d-9eb5-4634-97dc-2365bc0181dd',
    currency: 'ICS',
    amount: -1892.72201,
    user: '68',
    date: '2024-10-27T10:17:48Z',
    status: 'completed',
  },
  {
    id: '15759d8e-5c14-4088-9cae-08fd0b3c0426',
    currency: 'GCS',
    amount: 9251.619161,
    user: '74',
    date: '2024-12-22T23:36:36Z',
    status: 'blocked',
  },
  {
    id: '9a06cb20-2b1f-4c0f-b525-b5744eb8f1f5',
    currency: 'GCS',
    amount: -8051.799654,
    user: '32',
    date: '2024-09-17T18:00:53Z',
    status: 'completed',
  },
  {
    id: 'df15a870-c0e1-418a-b8a1-423ab7e5c8e2',
    currency: 'ICS',
    amount: 5641.466915,
    user: '80',
    date: '2024-07-08T00:35:58Z',
    status: 'blocked',
  },
  {
    id: '3af8afff-a6c8-4635-a16e-f410c72995ea',
    currency: 'GCS',
    amount: 4548.502806,
    user: '8',
    date: '2024-08-06T15:31:06Z',
    status: 'inProgress',
  },
  {
    id: 'b2e37e97-4d63-401c-9ad9-9d17aeb19cd8',
    currency: 'GCS',
    amount: 2221.350852,
    user: '19',
    date: '2024-01-18T18:48:08Z',
    status: 'blocked',
  },
  {
    id: '685f4adb-a14b-4adf-9281-d46ad7bdccb8',
    currency: 'ICS',
    amount: -8168.153805,
    user: '69',
    date: '2024-11-22T14:28:25Z',
    status: 'blocked',
  },
  {
    id: '7533e7dc-43e4-484e-8ae0-0e1110874b34',
    currency: 'GCS',
    amount: 9764.192496,
    user: '56',
    date: '2024-04-02T15:51:36Z',
    status: 'blocked',
  },
  {
    id: '8647e0a9-e432-4b3a-9cfa-11672bcc4ac8',
    currency: 'GCS',
    amount: 8259.02343,
    user: '35',
    date: '2024-07-18T05:48:48Z',
    status: 'completed',
  },
  {
    id: 'e625d309-e8ba-44df-9529-e1882c540f7a',
    currency: 'GCS',
    amount: -9179.500202,
    user: '50',
    date: '2024-02-28T07:21:43Z',
    status: 'completed',
  },
  {
    id: '87b38d96-e809-4668-8ca5-4f9230db853d',
    currency: 'ICS',
    amount: -4157.432076,
    user: '50',
    date: '2024-11-05T10:46:42Z',
    status: 'blocked',
  },
  {
    id: 'f625079b-5b44-4451-91f9-1adab9cd8a31',
    currency: 'GCS',
    amount: 6289.945754,
    user: '24',
    date: '2024-11-03T09:19:58Z',
    status: 'inProgress',
  },
  {
    id: '2cd0190b-8ce9-4f6b-a532-f7a11a005335',
    currency: 'GCS',
    amount: -9964.639407,
    user: '42',
    date: '2024-08-09T08:44:52Z',
    status: 'inProgress',
  },
  {
    id: '13c5d124-5b66-4669-b5bf-3c30c3fcc672',
    currency: 'ICS',
    amount: -3733.00529,
    user: '19',
    date: '2024-10-10T04:39:44Z',
    status: 'inProgress',
  },
  {
    id: '93dd1a5b-fa66-479c-8988-3ae45352859a',
    currency: 'GCS',
    amount: -5416.663424,
    user: '22',
    date: '2024-04-04T12:09:47Z',
    status: 'inProgress',
  },
  {
    id: '6578f278-7341-479c-91d8-3acb9ff9ab24',
    currency: 'GCS',
    amount: -2327.512838,
    user: '7',
    date: '2024-06-05T15:34:35Z',
    status: 'inProgress',
  },
  {
    id: '6a3cf2c7-f1e4-4466-b18f-f79280686885',
    currency: 'ICS',
    amount: 279.867283,
    user: '6',
    date: '2024-01-26T19:34:57Z',
    status: 'blocked',
  },
  {
    id: 'fa2288a1-5a3e-4c7a-9d7f-23385709b7d5',
    currency: 'ICS',
    amount: 5731.605564,
    user: '79',
    date: '2024-01-03T07:39:11Z',
    status: 'completed',
  },
  {
    id: '1fbcb2c8-d2e2-421d-ba25-99617bf615e2',
    currency: 'GCS',
    amount: 38.735337,
    user: '68',
    date: '2024-10-11T06:01:20Z',
    status: 'completed',
  },
  {
    id: '8ef8afa8-c261-438c-9302-5ac6a5cb529b',
    currency: 'GCS',
    amount: 3412.008934,
    user: '37',
    date: '2024-01-12T08:45:04Z',
    status: 'completed',
  },
  {
    id: 'cccfc915-41df-4669-b009-8f3476a51cb5',
    currency: 'GCS',
    amount: -6339.301583,
    user: '79',
    date: '2024-09-21T17:10:08Z',
    status: 'blocked',
  },
  {
    id: 'c1a44ed1-fcbc-4047-88ce-d3f68aeaf571',
    currency: 'ICS',
    amount: 3111.549449,
    user: '14',
    date: '2024-10-21T21:45:58Z',
    status: 'inProgress',
  },
  {
    id: '0d38717b-138a-4ed5-bd62-6c422d70405d',
    currency: 'ICS',
    amount: 7300.37554,
    user: '2',
    date: '2024-12-09T06:23:29Z',
    status: 'blocked',
  },
  {
    id: '88b4bdcd-8f11-4473-89eb-d823cc546e35',
    currency: 'GCS',
    amount: 4020.561968,
    user: '70',
    date: '2024-06-01T04:54:23Z',
    status: 'completed',
  },
  {
    id: 'ca60d640-b3f2-4d8a-9ec7-b8ee18f67fe4',
    currency: 'GCS',
    amount: 2119.046173,
    user: '63',
    date: '2024-11-01T17:18:37Z',
    status: 'inProgress',
  },
  {
    id: '6a777aaf-411a-4ad3-a740-a93226fb5411',
    currency: 'GCS',
    amount: 5147.546591,
    user: '2',
    date: '2024-06-30T20:31:29Z',
    status: 'blocked',
  },
  {
    id: 'b7732952-4467-43d3-9f36-bc6af315272d',
    currency: 'GCS',
    amount: 4044.751197,
    user: '33',
    date: '2024-03-15T21:02:05Z',
    status: 'completed',
  },
  {
    id: '03e0422e-a89a-4d95-8c44-6c9cecf471cd',
    currency: 'GCS',
    amount: -1891.430331,
    user: '15',
    date: '2024-03-22T22:27:13Z',
    status: 'blocked',
  },
  {
    id: 'f0895177-a3eb-48c9-b68e-5ede4bc6ea7b',
    currency: 'ICS',
    amount: 2641.365675,
    user: '68',
    date: '2024-05-26T13:24:06Z',
    status: 'inProgress',
  },
  {
    id: '7a632e30-44b5-48af-a353-7a70ad82379e',
    currency: 'GCS',
    amount: 4291.081381,
    user: '83',
    date: '2024-05-19T19:41:08Z',
    status: 'completed',
  },
  {
    id: '81df69da-a845-46e7-954e-e045aef5f955',
    currency: 'GCS',
    amount: 4292.087463,
    user: '18',
    date: '2024-02-02T14:31:46Z',
    status: 'blocked',
  },
  {
    id: 'b4755673-c477-421b-8069-ef40df4c93a5',
    currency: 'ICS',
    amount: -5098.661293,
    user: '63',
    date: '2024-07-28T10:39:42Z',
    status: 'completed',
  },
  {
    id: '4d7258f3-71f1-46f8-a32d-de9932ba5f69',
    currency: 'GCS',
    amount: -5367.482383,
    user: '30',
    date: '2024-09-10T07:23:09Z',
    status: 'blocked',
  },
  {
    id: 'd9b8a1ae-cf8b-451b-bef0-973e5c9b568c',
    currency: 'GCS',
    amount: 4736.30716,
    user: '24',
    date: '2024-04-14T21:35:41Z',
    status: 'blocked',
  },
  {
    id: '1bd3991c-8012-4213-af23-9db9c2fd6bb6',
    currency: 'ICS',
    amount: -4913.216562,
    user: '36',
    date: '2024-10-25T10:44:30Z',
    status: 'completed',
  },
  {
    id: '2392c19c-a872-421f-aea1-f8a37bb8a4b7',
    currency: 'ICS',
    amount: 6249.751895,
    user: '76',
    date: '2024-01-18T01:10:02Z',
    status: 'blocked',
  },
  {
    id: '6eefef5b-f95e-420e-af5a-c2282bccef44',
    currency: 'GCS',
    amount: 8298.23643,
    user: '75',
    date: '2024-04-07T19:26:13Z',
    status: 'inProgress',
  },
  {
    id: 'e1625e0c-2d3d-43d7-a1b3-6a1307c3e697',
    currency: 'GCS',
    amount: -6142.45227,
    user: '73',
    date: '2024-07-17T08:46:52Z',
    status: 'blocked',
  },
  {
    id: '6e2a93c3-afa2-4243-ac7c-c860b2eedcbd',
    currency: 'ICS',
    amount: -8055.037583,
    user: '4',
    date: '2024-03-27T11:10:01Z',
    status: 'blocked',
  },
  {
    id: '89221cde-b954-4fda-92e2-0070232cb4bd',
    currency: 'ICS',
    amount: -6170.250797,
    user: '1',
    date: '2024-04-17T07:30:05Z',
    status: 'blocked',
  },
  {
    id: '53363bfe-cc6b-41f4-bb0f-da6560595eff',
    currency: 'ICS',
    amount: -5833.549617,
    user: '73',
    date: '2024-01-03T09:58:42Z',
    status: 'blocked',
  },
  {
    id: 'a7042ecf-b053-43c0-9468-f54d337b4268',
    currency: 'ICS',
    amount: 5762.227635,
    user: '68',
    date: '2024-01-16T01:32:05Z',
    status: 'blocked',
  },
  {
    id: 'f956d2a5-d15a-48c7-8dc2-b2f953cafe75',
    currency: 'ICS',
    amount: -6334.978659,
    user: '42',
    date: '2024-11-23T20:36:58Z',
    status: 'blocked',
  },
  {
    id: '3cde768d-9d8e-4cee-bb3a-898afa636812',
    currency: 'ICS',
    amount: 2829.112305,
    user: '11',
    date: '2024-10-10T04:21:48Z',
    status: 'completed',
  },
  {
    id: '1da90f65-096f-405d-a805-2347812cf06b',
    currency: 'GCS',
    amount: 727.978039,
    user: '47',
    date: '2024-11-15T23:34:34Z',
    status: 'inProgress',
  },
  {
    id: '64a59bfb-7636-47ea-8b97-e4d3338b6983',
    currency: 'GCS',
    amount: 4839.491102,
    user: '22',
    date: '2024-09-07T23:05:27Z',
    status: 'blocked',
  },
  {
    id: '21ee2a91-bb22-44fd-98ca-04120b22e015',
    currency: 'ICS',
    amount: 8956.377945,
    user: '71',
    date: '2024-08-09T04:07:35Z',
    status: 'blocked',
  },
  {
    id: '88e52701-8908-4cfe-a187-7a1a93b3c8c6',
    currency: 'GCS',
    amount: -5072.904811,
    user: '23',
    date: '2024-03-02T08:18:19Z',
    status: 'inProgress',
  },
  {
    id: '50e4cc23-c2cf-4a94-8b41-058583a09d41',
    currency: 'GCS',
    amount: 1346.27014,
    user: '26',
    date: '2024-10-06T06:02:08Z',
    status: 'inProgress',
  },
  {
    id: 'f73ac0df-2962-41ed-b67d-3d9804d1360d',
    currency: 'ICS',
    amount: -4227.23624,
    user: '1',
    date: '2024-07-22T12:20:33Z',
    status: 'inProgress',
  },
  {
    id: '4f691aaf-69f1-4c8a-bf5a-2518eb65856c',
    currency: 'ICS',
    amount: 4697.235334,
    user: '20',
    date: '2024-03-16T10:21:55Z',
    status: 'completed',
  },
  {
    id: 'fb517dff-b9dc-45aa-8924-1d8a9e19c1ce',
    currency: 'GCS',
    amount: 3704.995693,
    user: '49',
    date: '2024-04-03T00:43:54Z',
    status: 'completed',
  },
  {
    id: '27e635d1-96b4-47f0-8bae-0ae37ed294eb',
    currency: 'GCS',
    amount: 9927.379986,
    user: '64',
    date: '2024-01-19T00:30:55Z',
    status: 'inProgress',
  },
  {
    id: '6421da52-70b1-4a8f-a965-95f02ec42191',
    currency: 'GCS',
    amount: 9321.495186,
    user: '17',
    date: '2024-12-19T09:58:32Z',
    status: 'inProgress',
  },
  {
    id: '04750ffb-2b74-4de6-816b-bf21bf0dc4dc',
    currency: 'ICS',
    amount: -231.171145,
    user: '39',
    date: '2024-01-15T12:25:14Z',
    status: 'blocked',
  },
  {
    id: '0cdb0987-2e23-4215-8d92-1cb55d7d28d2',
    currency: 'GCS',
    amount: -6929.896089,
    user: '26',
    date: '2024-02-16T04:09:56Z',
    status: 'completed',
  },
  {
    id: '13e217f5-5970-4747-af84-e466439b531c',
    currency: 'ICS',
    amount: 9835.896527,
    user: '78',
    date: '2024-03-13T21:35:46Z',
    status: 'inProgress',
  },
  {
    id: '13f1873b-cd44-4617-8f3d-acf9789400fa',
    currency: 'GCS',
    amount: 4044.256286,
    user: '29',
    date: '2024-09-13T14:42:36Z',
    status: 'completed',
  },
  {
    id: '937ea676-61f3-41b7-907c-4ba71032bc86',
    currency: 'GCS',
    amount: 9277.592324,
    user: '33',
    date: '2024-05-16T07:06:22Z',
    status: 'completed',
  },
  {
    id: '5dd1f329-dbfa-4263-b0de-11e0abfa78b4',
    currency: 'GCS',
    amount: -7514.357283,
    user: '6',
    date: '2024-07-12T10:52:43Z',
    status: 'completed',
  },
  {
    id: 'eb40654e-3da1-4e48-aa75-232c72a15a57',
    currency: 'ICS',
    amount: 3870.607027,
    user: '55',
    date: '2024-01-08T18:47:50Z',
    status: 'blocked',
  },
  {
    id: '3d2b486f-4d00-4ee9-844b-d15500b9a1bb',
    currency: 'GCS',
    amount: 1783.864103,
    user: '49',
    date: '2024-05-12T12:52:55Z',
    status: 'blocked',
  },
  {
    id: '8e3f6bb9-52fa-46a1-a35a-6842fc3d6cbb',
    currency: 'ICS',
    amount: 3319.910839,
    user: '57',
    date: '2024-08-02T02:07:58Z',
    status: 'inProgress',
  },
  {
    id: '22703f3f-ccc5-4c8a-a3ec-9b2d09ac7c48',
    currency: 'GCS',
    amount: -9598.273021,
    user: '83',
    date: '2024-06-23T03:57:21Z',
    status: 'completed',
  },
  {
    id: '069b28c4-18b4-4213-a6a6-a492631d9131',
    currency: 'ICS',
    amount: -1770.4157,
    user: '59',
    date: '2024-10-29T15:37:16Z',
    status: 'blocked',
  },
  {
    id: '0cd6890a-e772-4344-b7e8-20c4735865d8',
    currency: 'ICS',
    amount: -267.587238,
    user: '17',
    date: '2024-07-11T19:06:14Z',
    status: 'inProgress',
  },
  {
    id: 'f0a94b1d-1e5c-4415-aacc-42f766adf2e5',
    currency: 'ICS',
    amount: -3105.552866,
    user: '27',
    date: '2024-06-18T19:52:19Z',
    status: 'inProgress',
  },
  {
    id: 'fba9d9d3-ef6c-4cb7-a640-fda0f1f03574',
    currency: 'GCS',
    amount: -3871.160398,
    user: '33',
    date: '2024-11-30T19:53:13Z',
    status: 'inProgress',
  },
  {
    id: 'ef6c0bff-d50b-466a-a91f-d0231511daaf',
    currency: 'GCS',
    amount: -8803.48121,
    user: '26',
    date: '2024-12-07T15:22:44Z',
    status: 'blocked',
  },
  {
    id: '26af1f8b-b15f-4e1a-91fc-c695835661bd',
    currency: 'ICS',
    amount: 896.839668,
    user: '55',
    date: '2024-05-18T17:57:11Z',
    status: 'inProgress',
  },
  {
    id: '5d39db89-97b8-45d6-8866-43b4843c51ac',
    currency: 'ICS',
    amount: -6527.238134,
    user: '71',
    date: '2024-06-17T15:18:20Z',
    status: 'inProgress',
  },
  {
    id: '065fe089-a05f-48c1-a644-12de1ecdc24b',
    currency: 'GCS',
    amount: -7054.772205,
    user: '40',
    date: '2024-05-02T17:43:02Z',
    status: 'blocked',
  },
  {
    id: '52bcad3d-7278-44f8-8b77-091b3acbed4c',
    currency: 'ICS',
    amount: 7429.005105,
    user: '80',
    date: '2024-03-01T03:48:40Z',
    status: 'blocked',
  },
  {
    id: 'ca3fe885-24c7-4c73-ae43-b6fa21920262',
    currency: 'GCS',
    amount: -5708.807496,
    user: '67',
    date: '2024-01-28T15:01:56Z',
    status: 'inProgress',
  },
  {
    id: 'e29829a1-5548-4002-9914-491d11e775f3',
    currency: 'ICS',
    amount: -5484.195773,
    user: '78',
    date: '2024-01-16T04:28:13Z',
    status: 'completed',
  },
  {
    id: 'f04f53b2-ec98-411e-a506-e72e2980cb3e',
    currency: 'GCS',
    amount: 5286.643158,
    user: '57',
    date: '2024-06-17T11:13:33Z',
    status: 'inProgress',
  },
  {
    id: '1acf4283-57b6-4565-b5cb-8cebfdf969ee',
    currency: 'ICS',
    amount: -6236.940821,
    user: '52',
    date: '2024-07-25T15:29:41Z',
    status: 'inProgress',
  },
  {
    id: '0528b0c3-6359-449c-af71-081d71953ead',
    currency: 'ICS',
    amount: 7470.529998,
    user: '59',
    date: '2024-03-26T14:38:52Z',
    status: 'blocked',
  },
  {
    id: '5cc7bead-0ee7-4141-aae6-490f6c8d9f10',
    currency: 'GCS',
    amount: -3131.147335,
    user: '28',
    date: '2024-04-11T18:47:48Z',
    status: 'completed',
  },
  {
    id: 'ce3f037a-474f-4e52-9b2c-cf31fa76f391',
    currency: 'GCS',
    amount: -3810.199243,
    user: '63',
    date: '2024-05-06T23:30:57Z',
    status: 'blocked',
  },
  {
    id: '421ef653-7713-476a-ae83-9f3fd7a3b06d',
    currency: 'GCS',
    amount: -9020.246377,
    user: '64',
    date: '2024-04-07T09:59:45Z',
    status: 'inProgress',
  },
  {
    id: '41790923-5ac2-4b47-9a66-a38b67cf4290',
    currency: 'ICS',
    amount: 5487.682527,
    user: '25',
    date: '2024-06-27T20:59:20Z',
    status: 'blocked',
  },
  {
    id: '09137d6a-f21e-4baf-b8ef-f3d388a27ebe',
    currency: 'ICS',
    amount: 4278.465493,
    user: '34',
    date: '2024-08-08T04:58:56Z',
    status: 'blocked',
  },
  {
    id: 'd832fc36-a53f-481d-86e1-c75c990a837f',
    currency: 'GCS',
    amount: 7050.786262,
    user: '43',
    date: '2024-03-09T05:57:15Z',
    status: 'completed',
  },
  {
    id: 'cfdc3581-32ea-40c6-8ffa-0c4654ab2bc6',
    currency: 'ICS',
    amount: 3284.118721,
    user: '23',
    date: '2024-01-14T16:38:17Z',
    status: 'blocked',
  },
  {
    id: '1a1507ac-4040-4d29-8c09-610d26c43065',
    currency: 'ICS',
    amount: -1483.879777,
    user: '22',
    date: '2024-10-11T17:09:33Z',
    status: 'completed',
  },
  {
    id: '39a56033-9684-4810-bbf8-0eac549d1817',
    currency: 'ICS',
    amount: 9037.345857,
    user: '83',
    date: '2024-07-18T07:56:58Z',
    status: 'blocked',
  },
  {
    id: '9e4907c5-0d55-49e8-93c7-ec09a3657be9',
    currency: 'GCS',
    amount: 3313.258151,
    user: '56',
    date: '2024-08-12T06:46:38Z',
    status: 'completed',
  },
  {
    id: 'a8ebdddc-ef94-41e1-89cd-e75adaa6115d',
    currency: 'GCS',
    amount: -3550.220071,
    user: '72',
    date: '2024-10-17T21:37:25Z',
    status: 'inProgress',
  },
  {
    id: '424ea555-c3fe-420b-bc49-d1b87188c294',
    currency: 'GCS',
    amount: 493.307507,
    user: '56',
    date: '2024-11-07T01:11:37Z',
    status: 'blocked',
  },
  {
    id: '16b5c431-5fd8-4d2c-ad62-6a49636d3c4b',
    currency: 'GCS',
    amount: -6075.997125,
    user: '23',
    date: '2024-05-31T03:12:33Z',
    status: 'blocked',
  },
  {
    id: '6f0dddb0-5a84-4314-b5dc-eef042a3975d',
    currency: 'GCS',
    amount: -2868.958164,
    user: '27',
    date: '2024-04-04T21:42:32Z',
    status: 'blocked',
  },
  {
    id: 'a3971816-ed41-4ff0-9e41-c71150de558c',
    currency: 'ICS',
    amount: 610.283189,
    user: '39',
    date: '2024-12-16T12:14:48Z',
    status: 'completed',
  },
  {
    id: 'fdd47ca9-8d76-493e-87ae-7771041531f1',
    currency: 'ICS',
    amount: 7622.834618,
    user: '15',
    date: '2024-08-21T18:51:26Z',
    status: 'completed',
  },
  {
    id: '430fd77c-eb33-44d3-8328-5c82f32876b5',
    currency: 'ICS',
    amount: 4779.111609,
    user: '83',
    date: '2024-11-08T17:44:24Z',
    status: 'completed',
  },
  {
    id: '0464c906-f399-419f-b83d-2523818eea4c',
    currency: 'GCS',
    amount: -2587.836665,
    user: '48',
    date: '2024-10-14T18:48:10Z',
    status: 'inProgress',
  },
  {
    id: '0fe3b558-ee82-4bac-a992-f9c0e3f80249',
    currency: 'GCS',
    amount: -833.857326,
    user: '55',
    date: '2024-06-13T09:26:27Z',
    status: 'blocked',
  },
  {
    id: '07f77724-b57f-44a3-948e-5f9dddfa65ce',
    currency: 'ICS',
    amount: -9272.717309,
    user: '47',
    date: '2024-01-24T04:43:39Z',
    status: 'blocked',
  },
  {
    id: '39eda076-9748-4e2d-8042-a4c143b025c9',
    currency: 'GCS',
    amount: 6019.803951,
    user: '29',
    date: '2024-04-09T17:38:21Z',
    status: 'blocked',
  },
  {
    id: 'd0f4886b-a072-4b53-8ae8-5eacd2767029',
    currency: 'ICS',
    amount: -1744.309311,
    user: '77',
    date: '2024-05-07T19:34:08Z',
    status: 'blocked',
  },
  {
    id: '43c9cd81-a369-46e1-a82c-a3380fa27ec9',
    currency: 'GCS',
    amount: 3392.279361,
    user: '65',
    date: '2024-05-29T01:01:02Z',
    status: 'inProgress',
  },
  {
    id: '42a2056d-a9dc-400a-b1b8-42c1e2fe0cd9',
    currency: 'GCS',
    amount: -1385.61827,
    user: '77',
    date: '2024-12-11T20:43:03Z',
    status: 'inProgress',
  },
  {
    id: 'cf7385d9-22d3-4abc-a771-430ab59959f5',
    currency: 'GCS',
    amount: 1333.158206,
    user: '63',
    date: '2024-12-28T20:07:01Z',
    status: 'completed',
  },
  {
    id: '7e821c0b-bd20-495c-a85b-5d7953e1d888',
    currency: 'ICS',
    amount: 7714.812922,
    user: '59',
    date: '2024-09-27T12:57:37Z',
    status: 'inProgress',
  },
  {
    id: 'b4d76feb-59b4-404e-acc6-e4fdab2332e7',
    currency: 'ICS',
    amount: -3019.980195,
    user: '45',
    date: '2024-11-27T19:02:04Z',
    status: 'blocked',
  },
  {
    id: '88132f03-94be-43b2-a28f-b1d1c811d40c',
    currency: 'GCS',
    amount: 7515.552356,
    user: '16',
    date: '2024-04-19T17:41:40Z',
    status: 'blocked',
  },
  {
    id: 'f4d7a8c3-ea78-4c74-9cee-a3218401adb3',
    currency: 'ICS',
    amount: -3647.970411,
    user: '31',
    date: '2024-07-30T06:12:40Z',
    status: 'inProgress',
  },
  {
    id: '2e3a03bd-223e-4768-9777-ee41c4c19cde',
    currency: 'GCS',
    amount: 8061.02178,
    user: '14',
    date: '2024-02-01T12:36:14Z',
    status: 'inProgress',
  },
  {
    id: '60644010-15ae-4c0c-a8b5-5a0df857b394',
    currency: 'GCS',
    amount: 4861.97735,
    user: '41',
    date: '2024-07-03T15:17:26Z',
    status: 'blocked',
  },
  {
    id: '67462dda-6be7-49f9-bb6f-e659969fe7c3',
    currency: 'GCS',
    amount: -1223.954349,
    user: '30',
    date: '2024-04-30T10:13:30Z',
    status: 'inProgress',
  },
  {
    id: 'bd8e65b2-00e8-4d7f-8259-bf858aa3036d',
    currency: 'GCS',
    amount: 5881.475033,
    user: '82',
    date: '2024-11-01T14:02:14Z',
    status: 'blocked',
  },
  {
    id: 'fd7b1332-9b6f-442b-87ab-37efeb2fccc6',
    currency: 'ICS',
    amount: -2926.018975,
    user: '1',
    date: '2024-08-12T16:16:06Z',
    status: 'inProgress',
  },
  {
    id: '06d58b40-bd91-4957-ace0-916b6f4c6e36',
    currency: 'GCS',
    amount: 9996.588137,
    user: '1',
    date: '2024-11-24T15:18:28Z',
    status: 'blocked',
  },
  {
    id: 'be33ecae-8884-4558-8092-168a8d80dcc5',
    currency: 'GCS',
    amount: 7976.71645,
    user: '24',
    date: '2024-02-23T06:45:15Z',
    status: 'inProgress',
  },
  {
    id: '075dda2e-2cb8-40e2-bf6b-a78eb0ca6fd9',
    currency: 'ICS',
    amount: 6365.924257,
    user: '55',
    date: '2024-11-08T16:45:37Z',
    status: 'blocked',
  },
  {
    id: '8b76a5ba-ffad-4df6-9503-2377e272fc6e',
    currency: 'GCS',
    amount: 1736.806571,
    user: '23',
    date: '2024-05-14T11:21:52Z',
    status: 'inProgress',
  },
  {
    id: '0e5eb662-5cd4-4f4f-bb44-9a24c6face7a',
    currency: 'ICS',
    amount: -4221.07164,
    user: '27',
    date: '2024-07-08T20:49:02Z',
    status: 'inProgress',
  },
  {
    id: 'c2840225-3943-466e-ae2d-903fab2f6b0a',
    currency: 'ICS',
    amount: -1295.359409,
    user: '12',
    date: '2024-04-21T05:40:41Z',
    status: 'inProgress',
  },
  {
    id: 'ccf1d973-f6ab-4232-bdc8-c0a738ffa0e1',
    currency: 'ICS',
    amount: 1649.555775,
    user: '32',
    date: '2024-01-29T01:19:30Z',
    status: 'completed',
  },
  {
    id: '1e00032e-b8a9-49ec-8790-cc1dfcfc8581',
    currency: 'ICS',
    amount: 4899.202756,
    user: '42',
    date: '2024-08-31T12:20:31Z',
    status: 'blocked',
  },
  {
    id: 'a44a8ab5-32db-4137-9157-c7fdffc0bf8f',
    currency: 'GCS',
    amount: -9322.322055,
    user: '16',
    date: '2024-04-12T08:21:46Z',
    status: 'blocked',
  },
  {
    id: 'af518bdc-617c-4ba4-815e-d13b990116ba',
    currency: 'GCS',
    amount: 2274.429908,
    user: '60',
    date: '2024-05-21T12:25:19Z',
    status: 'inProgress',
  },
  {
    id: '24a582fb-33a9-420f-a984-5590456be024',
    currency: 'ICS',
    amount: -39.754027,
    user: '59',
    date: '2024-12-13T05:56:31Z',
    status: 'blocked',
  },
  {
    id: 'db446cc8-7af2-4b3c-8601-496ee123c676',
    currency: 'ICS',
    amount: 4097.339812,
    user: '76',
    date: '2024-12-26T13:04:26Z',
    status: 'inProgress',
  },
  {
    id: 'fb0893fa-ff5e-4601-a9c4-91b5eab3ed74',
    currency: 'ICS',
    amount: -2297.758129,
    user: '78',
    date: '2024-09-06T23:52:15Z',
    status: 'blocked',
  },
  {
    id: 'ec7606e0-bca5-42c0-aa44-b1c4fbe81749',
    currency: 'ICS',
    amount: 5818.65212,
    user: '17',
    date: '2024-06-17T22:02:19Z',
    status: 'inProgress',
  },
  {
    id: '0888cb5d-de13-40b6-b503-1e2a61998d4a',
    currency: 'GCS',
    amount: 2504.606473,
    user: '75',
    date: '2024-10-14T21:18:00Z',
    status: 'blocked',
  },
  {
    id: 'bc49f149-dc07-4fbb-85f3-0407420fec9c',
    currency: 'GCS',
    amount: 9621.928764,
    user: '74',
    date: '2024-10-05T22:44:26Z',
    status: 'blocked',
  },
  {
    id: '7906101a-b7df-4aa6-99aa-429190a2a4c4',
    currency: 'GCS',
    amount: 9163.025107,
    user: '68',
    date: '2024-01-18T11:39:17Z',
    status: 'completed',
  },
  {
    id: 'fd5d8475-48a9-4372-abcb-4a4ba64d01ee',
    currency: 'ICS',
    amount: 3252.890891,
    user: '12',
    date: '2024-07-14T19:50:23Z',
    status: 'blocked',
  },
  {
    id: '0cfbf76e-38b4-441a-8c25-d4a63c72226a',
    currency: 'ICS',
    amount: -3699.872143,
    user: '18',
    date: '2024-05-24T09:15:51Z',
    status: 'completed',
  },
  {
    id: '3de473c4-e479-4200-a0b1-0af505d4f531',
    currency: 'ICS',
    amount: 7531.186397,
    user: '3',
    date: '2024-08-08T14:15:18Z',
    status: 'completed',
  },
  {
    id: 'acab81b8-e4ae-47bc-b420-d1413549ac4d',
    currency: 'ICS',
    amount: 3657.758299,
    user: '40',
    date: '2024-09-22T16:34:39Z',
    status: 'blocked',
  },
  {
    id: '21e149b0-ee97-4002-a8a4-4e48b669327d',
    currency: 'ICS',
    amount: 8119.94174,
    user: '72',
    date: '2024-08-22T17:47:04Z',
    status: 'blocked',
  },
  {
    id: '1758ea19-256a-455d-8806-0020c8b8ea9e',
    currency: 'GCS',
    amount: -5053.296151,
    user: '43',
    date: '2024-06-06T16:09:07Z',
    status: 'completed',
  },
  {
    id: 'b1f2d650-eb18-4500-b58d-cb9cdcc72dd4',
    currency: 'ICS',
    amount: -2288.168771,
    user: '30',
    date: '2024-11-24T16:46:58Z',
    status: 'completed',
  },
  {
    id: 'ebfd86c0-0efe-4f00-a9cd-15b5ece3f72b',
    currency: 'ICS',
    amount: 9300.303345,
    user: '8',
    date: '2024-02-22T12:19:37Z',
    status: 'completed',
  },
  {
    id: 'b3aa3614-eb03-4fff-8bef-5d4243a00bef',
    currency: 'GCS',
    amount: -4602.183562,
    user: '62',
    date: '2024-12-21T03:32:32Z',
    status: 'completed',
  },
  {
    id: '10009b68-e3cf-4a22-8af6-0769c5a6b41c',
    currency: 'ICS',
    amount: -3858.449862,
    user: '75',
    date: '2024-04-14T23:44:58Z',
    status: 'blocked',
  },
  {
    id: '6d1d0bcc-49c9-4191-95af-8354b87f2e0b',
    currency: 'ICS',
    amount: 6332.65332,
    user: '74',
    date: '2024-08-04T18:34:25Z',
    status: 'inProgress',
  },
  {
    id: 'ab5d5bc0-8654-4ffa-b5cd-43414b87ab22',
    currency: 'GCS',
    amount: 9882.014397,
    user: '80',
    date: '2024-04-16T14:59:33Z',
    status: 'inProgress',
  },
  {
    id: 'a5ff422f-6d32-49e3-a1e2-c354a7e1d05c',
    currency: 'GCS',
    amount: -7373.347744,
    user: '3',
    date: '2024-08-17T19:52:45Z',
    status: 'blocked',
  },
  {
    id: 'd4df1529-1ef2-4bb8-9400-501e5c0f5f35',
    currency: 'GCS',
    amount: 3267.232865,
    user: '38',
    date: '2024-07-16T12:46:20Z',
    status: 'completed',
  },
  {
    id: '3f495d7e-f01b-454f-a8e2-25117b1de33e',
    currency: 'ICS',
    amount: 8229.00655,
    user: '11',
    date: '2024-04-21T00:04:15Z',
    status: 'blocked',
  },
  {
    id: 'ecbb62c9-f4bc-4181-bef9-ac4eadfecb56',
    currency: 'ICS',
    amount: 7213.16378,
    user: '44',
    date: '2024-12-03T17:15:46Z',
    status: 'inProgress',
  },
  {
    id: '5a8e5014-6165-46cd-861d-170a60e19707',
    currency: 'ICS',
    amount: -3254.219957,
    user: '50',
    date: '2024-01-11T07:48:41Z',
    status: 'blocked',
  },
  {
    id: 'cda18052-ad7f-40a5-bae6-7c8e02252244',
    currency: 'ICS',
    amount: 5139.713706,
    user: '37',
    date: '2024-11-07T17:20:50Z',
    status: 'completed',
  },
  {
    id: 'e17542fa-ae13-4f0e-80af-e6e24a2048c5',
    currency: 'GCS',
    amount: 6564.611519,
    user: '72',
    date: '2024-10-01T00:02:49Z',
    status: 'completed',
  },
  {
    id: '31bce5be-e8b0-4f1b-9534-24ae566224e6',
    currency: 'GCS',
    amount: -4994.795159,
    user: '51',
    date: '2024-10-08T13:09:01Z',
    status: 'completed',
  },
  {
    id: '5cbe630a-9a84-408f-9d56-9f9a9605a177',
    currency: 'GCS',
    amount: -4251.342,
    user: '55',
    date: '2024-09-19T16:41:43Z',
    status: 'completed',
  },
  {
    id: '377e70d5-dbaa-4bcc-a10d-ccb02b5aae79',
    currency: 'GCS',
    amount: 6596.638613,
    user: '43',
    date: '2024-07-02T14:29:23Z',
    status: 'inProgress',
  },
  {
    id: '61fcf87e-ee1b-4e41-81b7-116bd69fe7cf',
    currency: 'GCS',
    amount: 7373.696071,
    user: '63',
    date: '2024-11-29T09:42:26Z',
    status: 'blocked',
  },
  {
    id: '2fd3cc0c-15a2-436a-aa86-4afbd37b9b8b',
    currency: 'ICS',
    amount: 9423.354216,
    user: '68',
    date: '2024-01-02T01:52:49Z',
    status: 'completed',
  },
  {
    id: 'e56a2766-308a-4854-b583-8d134ea2d6cd',
    currency: 'GCS',
    amount: -9139.034464,
    user: '4',
    date: '2024-02-02T00:45:49Z',
    status: 'blocked',
  },
  {
    id: 'cbc5b0fc-f358-4dc3-8f19-ed9da19dd235',
    currency: 'GCS',
    amount: 4060.777605,
    user: '26',
    date: '2024-07-10T00:55:36Z',
    status: 'blocked',
  },
  {
    id: 'ffcb38d0-120a-464c-aad1-d78af065bfe8',
    currency: 'GCS',
    amount: -5060.431133,
    user: '58',
    date: '2024-09-30T23:44:25Z',
    status: 'blocked',
  },
  {
    id: '398de8da-f803-4c64-b936-5dd3c08353d2',
    currency: 'GCS',
    amount: 2155.328196,
    user: '5',
    date: '2024-05-17T16:35:27Z',
    status: 'completed',
  },
  {
    id: '6673e841-eb42-4abf-aa91-1d75e7f32261',
    currency: 'GCS',
    amount: 4621.06155,
    user: '8',
    date: '2024-05-27T13:13:11Z',
    status: 'blocked',
  },
  {
    id: 'd5391c64-4c58-4bc2-9598-756de89fcaf3',
    currency: 'GCS',
    amount: -1713.276348,
    user: '21',
    date: '2024-06-09T19:55:45Z',
    status: 'inProgress',
  },
  {
    id: '08b7b4b2-e1a7-411d-952c-127a13cf1677',
    currency: 'ICS',
    amount: -2711.194216,
    user: '33',
    date: '2024-09-12T20:08:00Z',
    status: 'inProgress',
  },
  {
    id: '702beee3-911d-4dff-9625-dfffd4a3a0a3',
    currency: 'ICS',
    amount: -5639.548835,
    user: '32',
    date: '2024-11-07T15:14:37Z',
    status: 'blocked',
  },
  {
    id: 'ae3e7180-916a-426a-a262-d00a135fafed',
    currency: 'ICS',
    amount: 4623.548985,
    user: '21',
    date: '2024-10-14T14:15:24Z',
    status: 'completed',
  },
  {
    id: 'c5e7bb9a-334d-483a-a9b9-fe410ae2aaf8',
    currency: 'GCS',
    amount: -8844.574473,
    user: '28',
    date: '2024-01-29T04:29:17Z',
    status: 'completed',
  },
  {
    id: '8748275c-1fb7-4d97-baa8-9bcf44475442',
    currency: 'ICS',
    amount: -9516.555857,
    user: '41',
    date: '2024-11-03T23:19:14Z',
    status: 'blocked',
  },
  {
    id: '27cbab82-1b84-4f29-9bc4-35cb7ca32f76',
    currency: 'ICS',
    amount: 8738.725194,
    user: '24',
    date: '2024-09-07T10:57:10Z',
    status: 'completed',
  },
  {
    id: 'd17a5a7f-aac5-42e4-a2bf-9d13005d20f3',
    currency: 'ICS',
    amount: -739.746403,
    user: '34',
    date: '2024-01-01T05:57:49Z',
    status: 'blocked',
  },
  {
    id: '0437224c-df39-41a2-a84a-d0fa5d17620a',
    currency: 'ICS',
    amount: -3796.276051,
    user: '71',
    date: '2024-12-09T00:57:38Z',
    status: 'blocked',
  },
  {
    id: '95fc2498-a92f-4f65-969d-985e38698d93',
    currency: 'ICS',
    amount: -1118.451654,
    user: '40',
    date: '2024-12-26T05:26:45Z',
    status: 'completed',
  },
  {
    id: '61199441-4f64-47e7-9634-8c13f224ad25',
    currency: 'ICS',
    amount: -2231.489506,
    user: '14',
    date: '2024-03-31T00:14:24Z',
    status: 'blocked',
  },
  {
    id: '431ffa6f-c74a-4917-a9ae-5c12ee035fcb',
    currency: 'ICS',
    amount: -8742.06083,
    user: '8',
    date: '2024-04-29T23:55:52Z',
    status: 'completed',
  },
  {
    id: '09bb51c6-8a05-4428-8559-1aa6060d8fe8',
    currency: 'ICS',
    amount: 3711.363138,
    user: '6',
    date: '2024-07-08T16:05:36Z',
    status: 'inProgress',
  },
  {
    id: 'a33823a9-5352-494c-a8de-c81f54d44baa',
    currency: 'ICS',
    amount: 269.920498,
    user: '47',
    date: '2024-04-22T09:15:13Z',
    status: 'inProgress',
  },
  {
    id: 'd8e7dd1a-7c23-4089-9a37-c2b33be7732f',
    currency: 'ICS',
    amount: 4232.579838,
    user: '13',
    date: '2024-12-05T01:36:08Z',
    status: 'blocked',
  },
  {
    id: 'badb1674-88ea-4b1f-b47a-0623378dc970',
    currency: 'GCS',
    amount: 1636.100333,
    user: '9',
    date: '2024-08-20T07:58:23Z',
    status: 'blocked',
  },
  {
    id: '067382db-3519-4617-ae9e-07f9dbd6cced',
    currency: 'GCS',
    amount: 3811.84369,
    user: '3',
    date: '2024-05-05T11:33:21Z',
    status: 'completed',
  },
  {
    id: '22af381d-d12e-4f5b-b8cb-5d16597fb20f',
    currency: 'GCS',
    amount: -5721.221308,
    user: '41',
    date: '2024-09-21T14:06:05Z',
    status: 'completed',
  },
  {
    id: 'd12dd47e-f1e1-4bd2-984c-76bfc042798c',
    currency: 'ICS',
    amount: 7255.090555,
    user: '2',
    date: '2024-12-09T16:56:11Z',
    status: 'completed',
  },
  {
    id: '1b254405-317e-4bd7-bb58-e207e09b3f1f',
    currency: 'GCS',
    amount: 5341.5149,
    user: '65',
    date: '2024-07-05T00:57:56Z',
    status: 'completed',
  },
  {
    id: '7ed4dd26-3784-47a0-8eca-47a9ab43f5b1',
    currency: 'ICS',
    amount: -1688.505695,
    user: '4',
    date: '2024-07-22T05:49:40Z',
    status: 'inProgress',
  },
  {
    id: '3b069ffc-2d13-4517-b248-de5d29fb7733',
    currency: 'GCS',
    amount: 5170.827758,
    user: '33',
    date: '2024-06-30T15:44:56Z',
    status: 'inProgress',
  },
  {
    id: 'e8929478-d991-422d-b600-900221b5f71f',
    currency: 'GCS',
    amount: -4281.095989,
    user: '19',
    date: '2024-09-09T10:15:31Z',
    status: 'inProgress',
  },
  {
    id: '5f46f44b-4ce4-4529-b7c6-e27b24e544dc',
    currency: 'ICS',
    amount: 3104.583232,
    user: '10',
    date: '2024-12-17T06:27:26Z',
    status: 'completed',
  },
  {
    id: '7376788d-aabe-4e14-b267-df3ab3653bef',
    currency: 'ICS',
    amount: -5629.591625,
    user: '52',
    date: '2024-08-06T12:46:00Z',
    status: 'blocked',
  },
  {
    id: 'a83717cb-3131-4f9a-b586-af6ccaffa1fc',
    currency: 'ICS',
    amount: -7839.167619,
    user: '59',
    date: '2024-09-22T07:17:20Z',
    status: 'blocked',
  },
  {
    id: 'afa08adc-b79c-432d-80bb-4dc6e96c19d8',
    currency: 'ICS',
    amount: -4140.106284,
    user: '18',
    date: '2024-06-01T18:14:16Z',
    status: 'inProgress',
  },
  {
    id: 'ccdf8825-b1cb-4a6f-ae84-358dd268ac4b',
    currency: 'GCS',
    amount: -2980.281056,
    user: '66',
    date: '2024-03-18T21:42:16Z',
    status: 'inProgress',
  },
  {
    id: '3f7e03e7-c38c-4c23-a3cb-bd7bc192b6b3',
    currency: 'ICS',
    amount: 3886.41029,
    user: '33',
    date: '2024-08-01T12:47:55Z',
    status: 'completed',
  },
  {
    id: 'e85c4bd6-b52e-458e-8f4f-f3885c936394',
    currency: 'ICS',
    amount: -8656.709355,
    user: '57',
    date: '2024-09-15T12:51:11Z',
    status: 'blocked',
  },
  {
    id: 'd84d6968-bf54-48a0-ae13-c9432b64678e',
    currency: 'ICS',
    amount: -6432.86068,
    user: '25',
    date: '2024-06-06T14:33:18Z',
    status: 'completed',
  },
  {
    id: 'd57a8475-dba8-46de-85d7-6a631fa95563',
    currency: 'GCS',
    amount: 2547.633718,
    user: '39',
    date: '2024-07-01T19:03:22Z',
    status: 'blocked',
  },
  {
    id: '78512e7d-3e40-4e99-8307-b1bbaa6b3142',
    currency: 'GCS',
    amount: 7621.11203,
    user: '3',
    date: '2024-10-04T23:42:02Z',
    status: 'inProgress',
  },
  {
    id: '4545bc6b-575c-4149-92fe-5c8a98e0f059',
    currency: 'ICS',
    amount: -9931.999709,
    user: '32',
    date: '2024-11-02T07:22:16Z',
    status: 'completed',
  },
  {
    id: '1d9bbb3f-bb35-43b7-8966-8b883a1f7f28',
    currency: 'GCS',
    amount: 3421.13875,
    user: '33',
    date: '2024-05-17T13:33:05Z',
    status: 'completed',
  },
  {
    id: 'bc3c7d43-b18d-4add-a81c-1b24d1fdbd66',
    currency: 'ICS',
    amount: -1472.747037,
    user: '33',
    date: '2024-03-25T13:58:18Z',
    status: 'blocked',
  },
  {
    id: '83aa6cc6-d3e8-42c8-846f-c09eefdfc745',
    currency: 'GCS',
    amount: 3474.914853,
    user: '20',
    date: '2024-08-28T14:05:54Z',
    status: 'blocked',
  },
  {
    id: '8375680a-f18c-44b2-8534-529346565e4e',
    currency: 'ICS',
    amount: 5004.944712,
    user: '82',
    date: '2024-09-04T06:43:30Z',
    status: 'inProgress',
  },
  {
    id: '73bfd180-61f0-4176-b6e1-29dc8fb84d86',
    currency: 'GCS',
    amount: -5093.586757,
    user: '20',
    date: '2024-07-01T15:55:53Z',
    status: 'blocked',
  },
  {
    id: '1372fb4c-d0db-4ab0-b9c2-5870d28e8cec',
    currency: 'GCS',
    amount: 9453.20659,
    user: '5',
    date: '2024-08-05T04:22:32Z',
    status: 'blocked',
  },
  {
    id: 'ee1b28a7-6f86-4d18-8de2-30fdfaa784ae',
    currency: 'GCS',
    amount: 5597.09858,
    user: '50',
    date: '2024-12-29T00:21:29Z',
    status: 'inProgress',
  },
  {
    id: '7f4b00ed-5f02-4252-b73a-5ef08ad0cdf0',
    currency: 'GCS',
    amount: -5471.156363,
    user: '77',
    date: '2024-09-08T02:20:32Z',
    status: 'blocked',
  },
  {
    id: 'b0cf50b3-f673-486e-bba8-9b9501795f25',
    currency: 'ICS',
    amount: 9129.356919,
    user: '32',
    date: '2024-03-24T05:59:12Z',
    status: 'inProgress',
  },
  {
    id: '04785e77-7cdb-4902-b9c9-49c33b19e224',
    currency: 'ICS',
    amount: 9726.322147,
    user: '39',
    date: '2024-06-24T09:00:03Z',
    status: 'blocked',
  },
  {
    id: 'c5a558b5-e65b-4b13-9a28-7fe8e15032d9',
    currency: 'ICS',
    amount: 2903.913537,
    user: '21',
    date: '2024-05-19T05:43:49Z',
    status: 'blocked',
  },
  {
    id: 'ca832165-13e0-4c3d-9369-beb51840f72b',
    currency: 'GCS',
    amount: -4957.50772,
    user: '70',
    date: '2024-05-26T00:01:14Z',
    status: 'completed',
  },
  {
    id: 'a655135d-f620-4651-8e25-63befa505250',
    currency: 'GCS',
    amount: 7646.221262,
    user: '57',
    date: '2024-01-05T14:08:09Z',
    status: 'inProgress',
  },
  {
    id: 'da51fe94-b899-4b47-bef9-b31fa09f6b45',
    currency: 'GCS',
    amount: 5389.390341,
    user: '3',
    date: '2024-06-16T20:44:37Z',
    status: 'completed',
  },
  {
    id: '3443df8f-15b5-4895-b853-7d1c1d54c599',
    currency: 'GCS',
    amount: -209.908243,
    user: '37',
    date: '2024-02-16T12:09:44Z',
    status: 'blocked',
  },
  {
    id: '29fbd8df-9cb1-4300-87a3-cf144b36fa28',
    currency: 'ICS',
    amount: 8202.93027,
    user: '47',
    date: '2024-09-19T21:44:53Z',
    status: 'blocked',
  },
  {
    id: 'cf6c7a99-a19b-462d-97bc-4e9735033c77',
    currency: 'GCS',
    amount: 3511.321626,
    user: '77',
    date: '2024-05-25T03:19:21Z',
    status: 'completed',
  },
  {
    id: '79803386-6d51-4a02-b123-972d773f0b23',
    currency: 'GCS',
    amount: -2672.384223,
    user: '2',
    date: '2024-08-08T12:06:08Z',
    status: 'completed',
  },
  {
    id: 'a7edec2d-a745-4a1c-b8ca-f62273c5b2d2',
    currency: 'ICS',
    amount: -2895.211137,
    user: '8',
    date: '2024-11-15T18:05:00Z',
    status: 'blocked',
  },
  {
    id: '3c4b8e31-330d-469a-a7b0-a4abf777457d',
    currency: 'ICS',
    amount: 7543.883292,
    user: '13',
    date: '2024-07-15T16:03:31Z',
    status: 'inProgress',
  },
  {
    id: '825df41b-bf66-44c2-9b91-c0ccc43dc257',
    currency: 'GCS',
    amount: -4722.733063,
    user: '71',
    date: '2024-10-16T12:59:51Z',
    status: 'blocked',
  },
  {
    id: '17cbf2ba-ede2-4dbf-ae9d-8ec824619305',
    currency: 'ICS',
    amount: 9419.82079,
    user: '54',
    date: '2024-01-12T21:51:06Z',
    status: 'completed',
  },
  {
    id: '57c4cda0-3282-45eb-91ef-c238e5d7db13',
    currency: 'ICS',
    amount: 5905.352847,
    user: '66',
    date: '2024-06-22T03:22:09Z',
    status: 'inProgress',
  },
  {
    id: '88ea7453-5f96-4dba-8d42-c7f0b58a4f1f',
    currency: 'GCS',
    amount: 8720.868252,
    user: '20',
    date: '2024-05-23T02:56:57Z',
    status: 'inProgress',
  },
  {
    id: '53052fd4-e698-4cae-9b06-8cdc9ee3fbd7',
    currency: 'ICS',
    amount: -7860.438926,
    user: '82',
    date: '2024-07-08T13:10:28Z',
    status: 'completed',
  },
  {
    id: '75a4b8f5-231e-42cd-a34c-d032ef639716',
    currency: 'GCS',
    amount: -7151.731781,
    user: '61',
    date: '2024-09-22T22:41:11Z',
    status: 'completed',
  },
  {
    id: 'a582d8d5-a2ff-48b9-b7f3-c8d2270857e5',
    currency: 'GCS',
    amount: -9337.723245,
    user: '66',
    date: '2024-11-21T14:36:05Z',
    status: 'inProgress',
  },
  {
    id: '5ed001d9-868b-4328-9890-dca764f38c1f',
    currency: 'ICS',
    amount: 2009.405365,
    user: '53',
    date: '2024-06-17T13:38:40Z',
    status: 'completed',
  },
  {
    id: 'ff0e6fe3-2539-46b5-be09-a5cd4f344cbd',
    currency: 'GCS',
    amount: 9629.802482,
    user: '21',
    date: '2024-06-04T22:41:09Z',
    status: 'inProgress',
  },
  {
    id: 'b620554b-0268-4400-bb23-096ed2993c89',
    currency: 'ICS',
    amount: 8156.450048,
    user: '52',
    date: '2024-11-04T12:12:06Z',
    status: 'inProgress',
  },
  {
    id: 'a712dbc5-7ff5-4015-aa35-7a66ce1b3263',
    currency: 'ICS',
    amount: 2830.011834,
    user: '1',
    date: '2024-09-21T23:57:05Z',
    status: 'completed',
  },
  {
    id: 'cbc8a9b4-44a1-470d-97b6-79b1b2e119c5',
    currency: 'GCS',
    amount: 9597.629225,
    user: '17',
    date: '2024-03-20T16:30:32Z',
    status: 'inProgress',
  },
  {
    id: '896a3b59-bc7f-4586-9f9e-6fdf94110af3',
    currency: 'ICS',
    amount: 5638.320394,
    user: '60',
    date: '2024-08-02T12:41:41Z',
    status: 'completed',
  },
  {
    id: '41515983-9461-4ec7-aaa4-27c86f2a7fcf',
    currency: 'GCS',
    amount: -6009.215996,
    user: '18',
    date: '2024-02-01T06:13:49Z',
    status: 'inProgress',
  },
  {
    id: '7ae78eed-c37c-4299-b0eb-0b7de8f6feb6',
    currency: 'GCS',
    amount: -9658.872222,
    user: '24',
    date: '2024-09-02T15:52:43Z',
    status: 'inProgress',
  },
  {
    id: '2e5c10a8-6ebd-48e6-b1ba-4f7adf742e6e',
    currency: 'ICS',
    amount: 2835.43227,
    user: '80',
    date: '2024-05-27T19:54:52Z',
    status: 'inProgress',
  },
  {
    id: 'eb06d007-1359-440c-932f-aba1ae357316',
    currency: 'GCS',
    amount: 7509.583056,
    user: '7',
    date: '2024-04-24T16:27:42Z',
    status: 'inProgress',
  },
  {
    id: 'f6e6b0f4-3ef7-4e90-a8c3-065a9f89e778',
    currency: 'GCS',
    amount: -5702.78335,
    user: '74',
    date: '2024-04-17T23:16:45Z',
    status: 'inProgress',
  },
  {
    id: '7a3c8ca1-602e-4fd7-a191-6d1030814a50',
    currency: 'ICS',
    amount: 8834.110424,
    user: '74',
    date: '2024-09-07T01:04:55Z',
    status: 'blocked',
  },
  {
    id: '872212ca-241d-43b7-9e4d-92c6aecd041f',
    currency: 'ICS',
    amount: -8946.589757,
    user: '67',
    date: '2024-10-06T18:40:37Z',
    status: 'completed',
  },
  {
    id: '7930d5e6-545a-4cb0-987e-3bec1237343c',
    currency: 'ICS',
    amount: 809.022511,
    user: '49',
    date: '2024-05-26T23:38:35Z',
    status: 'completed',
  },
  {
    id: '538a1e59-6737-4032-8c7d-386101652068',
    currency: 'ICS',
    amount: 2660.132546,
    user: '29',
    date: '2024-06-13T04:03:30Z',
    status: 'inProgress',
  },
  {
    id: '16a3dfb3-d13a-4e6c-b52a-b3bef6555636',
    currency: 'ICS',
    amount: 2162.953255,
    user: '57',
    date: '2024-09-21T03:32:58Z',
    status: 'inProgress',
  },
  {
    id: '5cfd7156-66e2-4095-bf72-e9ce984ca56e',
    currency: 'GCS',
    amount: 8224.87053,
    user: '79',
    date: '2024-08-01T09:37:15Z',
    status: 'completed',
  },
  {
    id: '24e97638-1e83-4cc9-9e78-4cb60454d3aa',
    currency: 'ICS',
    amount: 3626.702118,
    user: '2',
    date: '2024-12-12T03:26:40Z',
    status: 'blocked',
  },
  {
    id: 'ed84b811-919a-4757-92df-013bf204708c',
    currency: 'ICS',
    amount: -6964.299169,
    user: '10',
    date: '2024-12-22T08:35:49Z',
    status: 'completed',
  },
  {
    id: '0c25b2e1-643e-4a8d-957c-22a24216e40e',
    currency: 'GCS',
    amount: -7775.274759,
    user: '62',
    date: '2024-09-26T08:55:36Z',
    status: 'blocked',
  },
  {
    id: '3da622d0-916b-497f-88c8-881e330e7b15',
    currency: 'GCS',
    amount: 5394.361607,
    user: '25',
    date: '2024-02-16T18:48:44Z',
    status: 'inProgress',
  },
  {
    id: 'ebd8e496-8953-48e2-ae4c-98834bcd98c2',
    currency: 'ICS',
    amount: -9096.206431,
    user: '15',
    date: '2024-12-28T06:57:17Z',
    status: 'completed',
  },
  {
    id: '90b20ead-d4b4-4ce9-adb5-995cf2f6caad',
    currency: 'ICS',
    amount: 162.35352,
    user: '20',
    date: '2024-04-27T16:32:14Z',
    status: 'completed',
  },
  {
    id: '0507658a-69e5-4fba-bd3e-24a5545bb031',
    currency: 'GCS',
    amount: 9494.205088,
    user: '21',
    date: '2024-10-16T15:08:55Z',
    status: 'inProgress',
  },
  {
    id: 'e8b42bf4-fc87-47bc-a833-24d5ee5083c4',
    currency: 'ICS',
    amount: 3616.491006,
    user: '23',
    date: '2024-03-03T22:57:48Z',
    status: 'inProgress',
  },
  {
    id: '5b5bc4fa-482e-4556-84ea-c73686e16103',
    currency: 'ICS',
    amount: 3268.164568,
    user: '54',
    date: '2024-04-21T01:29:05Z',
    status: 'inProgress',
  },
  {
    id: '3de11001-7830-48bf-a92e-85b08e12fdc4',
    currency: 'GCS',
    amount: 4398.788987,
    user: '28',
    date: '2024-04-04T04:49:10Z',
    status: 'completed',
  },
  {
    id: 'c491bab8-45a0-488f-a41c-3b5242b3bc68',
    currency: 'ICS',
    amount: -8163.425294,
    user: '32',
    date: '2024-06-19T20:18:50Z',
    status: 'blocked',
  },
  {
    id: 'dd90b1a6-db30-44e1-b8f4-c395271478ec',
    currency: 'ICS',
    amount: 8014.295222,
    user: '28',
    date: '2024-02-17T16:04:06Z',
    status: 'inProgress',
  },
  {
    id: 'eb456458-1639-4fb7-bd73-08096d150fe6',
    currency: 'GCS',
    amount: 5164.136416,
    user: '5',
    date: '2024-01-06T20:51:13Z',
    status: 'completed',
  },
  {
    id: '57204c67-bf86-496b-a998-567d29ba8333',
    currency: 'ICS',
    amount: -8354.337633,
    user: '37',
    date: '2024-04-09T00:39:40Z',
    status: 'completed',
  },
  {
    id: '7f932f56-478c-4d39-ae1b-ff2239c55bdf',
    currency: 'ICS',
    amount: -315.605821,
    user: '60',
    date: '2024-10-02T07:33:03Z',
    status: 'completed',
  },
  {
    id: '8cff70ea-bf22-4637-bbbe-7af4f6b9fd0f',
    currency: 'GCS',
    amount: 1956.353268,
    user: '64',
    date: '2024-04-29T23:21:01Z',
    status: 'completed',
  },
  {
    id: 'bf4dbec7-52b9-4d8c-b067-4af049cedb31',
    currency: 'GCS',
    amount: 5471.333171,
    user: '71',
    date: '2024-01-31T06:19:25Z',
    status: 'completed',
  },
  {
    id: 'f171a5d3-ad02-4cb4-b2d5-8784de912119',
    currency: 'GCS',
    amount: 7599.393348,
    user: '76',
    date: '2024-10-30T23:54:38Z',
    status: 'completed',
  },
  {
    id: '6fd9a32f-da90-4fba-9d50-a7fd97ff577a',
    currency: 'ICS',
    amount: -2147.159431,
    user: '17',
    date: '2024-08-05T08:15:43Z',
    status: 'inProgress',
  },
  {
    id: '9096bb78-3fd6-4178-8cff-8ce51e78b42b',
    currency: 'ICS',
    amount: -1065.995134,
    user: '14',
    date: '2024-06-04T02:59:44Z',
    status: 'inProgress',
  },
  {
    id: '0faf41ea-3eec-4cd3-9856-a06d9909ef82',
    currency: 'ICS',
    amount: -2500.23219,
    user: '51',
    date: '2024-01-05T16:23:14Z',
    status: 'blocked',
  },
  {
    id: '3162a78e-4bcd-40b1-bc92-3167f1bdbfad',
    currency: 'ICS',
    amount: -2351.426322,
    user: '72',
    date: '2024-07-19T08:01:56Z',
    status: 'inProgress',
  },
  {
    id: 'ec321ca7-9a0d-4b97-8073-9663d8a26595',
    currency: 'GCS',
    amount: 5777.27806,
    user: '35',
    date: '2024-02-23T07:40:00Z',
    status: 'completed',
  },
  {
    id: 'd1b97b31-529e-4c32-a87b-6d4136c8a3f3',
    currency: 'ICS',
    amount: -7271.982805,
    user: '2',
    date: '2024-09-24T16:38:21Z',
    status: 'blocked',
  },
  {
    id: '02cef3c4-3638-47b9-9ff8-2990c48d3620',
    currency: 'ICS',
    amount: 2216.008272,
    user: '30',
    date: '2024-04-28T05:51:35Z',
    status: 'inProgress',
  },
  {
    id: '3aefa8d0-4513-4593-ab62-23b4f74f2222',
    currency: 'ICS',
    amount: 5055.009836,
    user: '65',
    date: '2024-08-23T18:59:09Z',
    status: 'blocked',
  },
  {
    id: '2dae9a13-7924-4c83-88eb-38bbc26b041d',
    currency: 'ICS',
    amount: 9139.487229,
    user: '5',
    date: '2024-12-05T22:18:00Z',
    status: 'inProgress',
  },
  {
    id: '987fc0e1-0aa6-48ba-83c6-e937416b3a16',
    currency: 'GCS',
    amount: -8256.816394,
    user: '59',
    date: '2024-12-17T15:24:31Z',
    status: 'inProgress',
  },
  {
    id: '38bd8935-0c8d-4821-a2ac-545e99b3821d',
    currency: 'ICS',
    amount: 1986.609916,
    user: '60',
    date: '2024-01-29T18:43:10Z',
    status: 'completed',
  },
  {
    id: '2f3a9a0b-6577-4bb4-b463-b8db0be3438f',
    currency: 'ICS',
    amount: -9987.370546,
    user: '13',
    date: '2024-02-08T23:39:33Z',
    status: 'inProgress',
  },
  {
    id: 'fc721a35-e56d-4393-984c-8e311316f13e',
    currency: 'ICS',
    amount: -5418.346933,
    user: '6',
    date: '2024-10-17T06:34:13Z',
    status: 'inProgress',
  },
  {
    id: 'b03c8bab-ca44-451e-a0b6-66457189dc60',
    currency: 'ICS',
    amount: 9190.825188,
    user: '7',
    date: '2024-02-13T16:24:43Z',
    status: 'completed',
  },
  {
    id: '8b44f586-0dbe-46cf-ad46-e368511d1496',
    currency: 'GCS',
    amount: -5410.323849,
    user: '1',
    date: '2024-08-18T04:15:45Z',
    status: 'blocked',
  },
  {
    id: '37ca8384-72f9-49e5-a996-78053ec05f16',
    currency: 'ICS',
    amount: -3713.322453,
    user: '30',
    date: '2024-03-13T16:46:52Z',
    status: 'inProgress',
  },
  {
    id: '2cafaee0-e60c-4bb0-a608-29643597c686',
    currency: 'GCS',
    amount: 7473.339788,
    user: '49',
    date: '2024-04-04T22:16:22Z',
    status: 'completed',
  },
  {
    id: '6d6b3289-5e2e-4126-8504-d40fc3a32332',
    currency: 'GCS',
    amount: 7856.885293,
    user: '5',
    date: '2024-04-16T09:38:41Z',
    status: 'completed',
  },
  {
    id: 'cda4dcaf-eb9d-4432-bebb-a12b104ce087',
    currency: 'ICS',
    amount: 6091.575865,
    user: '20',
    date: '2024-02-26T05:48:25Z',
    status: 'inProgress',
  },
  {
    id: 'ca2e48bc-c5ed-4a83-af68-1c620a9f49f8',
    currency: 'ICS',
    amount: 4415.012667,
    user: '75',
    date: '2024-07-10T12:17:09Z',
    status: 'blocked',
  },
  {
    id: 'c1a5803f-25e8-4c6b-a868-df1b41130169',
    currency: 'ICS',
    amount: 9807.648086,
    user: '9',
    date: '2024-11-27T09:49:38Z',
    status: 'inProgress',
  },
  {
    id: 'cd04d615-1608-45d6-8850-13e7857499cc',
    currency: 'GCS',
    amount: -821.890679,
    user: '37',
    date: '2024-04-03T02:19:56Z',
    status: 'completed',
  },
  {
    id: 'deab7323-e190-451d-9e2c-7c52605ba401',
    currency: 'ICS',
    amount: -9078.902174,
    user: '33',
    date: '2024-03-09T07:09:20Z',
    status: 'completed',
  },
  {
    id: 'f49d1316-238a-409d-b519-5e8be58372e4',
    currency: 'GCS',
    amount: 6320.585646,
    user: '12',
    date: '2024-11-15T21:27:13Z',
    status: 'inProgress',
  },
  {
    id: 'd33feddc-751c-4cfd-8e51-ab0468eb548b',
    currency: 'GCS',
    amount: 3676.836817,
    user: '74',
    date: '2024-01-22T21:16:42Z',
    status: 'completed',
  },
  {
    id: 'fdbe648d-d33a-43bf-8e58-af7a9ef94e1c',
    currency: 'GCS',
    amount: 4060.591344,
    user: '5',
    date: '2024-04-25T14:34:25Z',
    status: 'completed',
  },
  {
    id: 'e8d45d18-86ae-4d27-894f-9098db3e7c34',
    currency: 'ICS',
    amount: 6093.257079,
    user: '8',
    date: '2024-03-30T02:09:00Z',
    status: 'blocked',
  },
  {
    id: '64ac2100-0a4a-4528-9704-d6d991e42010',
    currency: 'ICS',
    amount: 8114.821722,
    user: '11',
    date: '2024-06-12T22:50:37Z',
    status: 'blocked',
  },
  {
    id: '38793035-bd50-4947-b0ec-336217ef2064',
    currency: 'ICS',
    amount: -6735.507091,
    user: '57',
    date: '2024-02-16T19:09:47Z',
    status: 'blocked',
  },
  {
    id: '09719733-aa27-4e6c-8714-40dd08e2ac37',
    currency: 'ICS',
    amount: 381.096895,
    user: '69',
    date: '2024-10-17T07:51:49Z',
    status: 'inProgress',
  },
  {
    id: '3ea9fd53-8671-4b78-9c33-8d55a94c8de1',
    currency: 'ICS',
    amount: 1293.179141,
    user: '49',
    date: '2024-05-25T13:34:21Z',
    status: 'blocked',
  },
  {
    id: 'c38da3b9-e006-44f5-982a-dd1cb242d0f4',
    currency: 'ICS',
    amount: -8253.64076,
    user: '47',
    date: '2024-10-11T17:11:28Z',
    status: 'inProgress',
  },
  {
    id: '9e62adfc-9a66-468a-bb83-1558b881bf18',
    currency: 'ICS',
    amount: 957.480991,
    user: '78',
    date: '2024-10-07T12:56:46Z',
    status: 'inProgress',
  },
  {
    id: '9d998d33-65c4-422a-8df2-e033cf7fd395',
    currency: 'GCS',
    amount: -7052.856799,
    user: '1',
    date: '2024-10-26T17:53:02Z',
    status: 'completed',
  },
  {
    id: '6a729da1-e75a-46ea-83bf-d65db23de4ef',
    currency: 'GCS',
    amount: -2339.35007,
    user: '78',
    date: '2024-12-20T13:19:42Z',
    status: 'inProgress',
  },
  {
    id: '4727a240-b2dd-4b8d-9ed8-5f3b164a2241',
    currency: 'ICS',
    amount: -8464.690321,
    user: '64',
    date: '2024-07-16T03:01:45Z',
    status: 'blocked',
  },
  {
    id: '9acd179b-58ce-43ef-b52f-0d1a5d30706b',
    currency: 'ICS',
    amount: -2428.819239,
    user: '6',
    date: '2024-06-03T20:10:46Z',
    status: 'completed',
  },
  {
    id: '5c089c84-44d3-45aa-8c79-94e135188971',
    currency: 'ICS',
    amount: -8822.583688,
    user: '52',
    date: '2024-11-20T01:44:30Z',
    status: 'inProgress',
  },
  {
    id: '90d55628-a82c-40f2-82ef-6963b8aecd95',
    currency: 'ICS',
    amount: -8151.154328,
    user: '82',
    date: '2024-04-13T11:18:10Z',
    status: 'completed',
  },
  {
    id: 'b1a86d05-a550-4a32-a8c6-596589195ca3',
    currency: 'GCS',
    amount: -1118.257782,
    user: '44',
    date: '2024-01-01T13:41:48Z',
    status: 'completed',
  },
  {
    id: '685bc186-d3ba-433b-bc34-54eeb47fcaf2',
    currency: 'GCS',
    amount: -8365.323113,
    user: '45',
    date: '2024-10-31T16:01:38Z',
    status: 'blocked',
  },
  {
    id: 'c8682d72-e1f5-4fa4-99e6-dbe0d5974734',
    currency: 'ICS',
    amount: 9592.286001,
    user: '11',
    date: '2024-10-24T12:21:37Z',
    status: 'inProgress',
  },
  {
    id: '007b6864-dd20-4d61-aae7-05198b8eba4c',
    currency: 'ICS',
    amount: -4050.729846,
    user: '12',
    date: '2024-02-23T17:02:57Z',
    status: 'blocked',
  },
  {
    id: 'd5f788ca-1a70-421b-9bbb-0cee7f4ba43f',
    currency: 'ICS',
    amount: 5422.151508,
    user: '78',
    date: '2024-08-28T09:41:23Z',
    status: 'blocked',
  },
  {
    id: 'fb6a2a72-b977-47c8-b155-efa5dc14fd65',
    currency: 'ICS',
    amount: -1385.322231,
    user: '2',
    date: '2024-04-07T23:32:58Z',
    status: 'inProgress',
  },
  {
    id: '3aeb5daf-760e-49e5-9878-14c90ab52e39',
    currency: 'ICS',
    amount: -8853.205201,
    user: '21',
    date: '2024-04-15T00:06:04Z',
    status: 'completed',
  },
  {
    id: '80bb4baf-e037-4eaf-8787-a4306da95ea7',
    currency: 'GCS',
    amount: -448.095187,
    user: '17',
    date: '2024-02-16T11:03:59Z',
    status: 'completed',
  },
  {
    id: '2860c65f-a28b-43f5-a3d1-f758f91052a4',
    currency: 'GCS',
    amount: -8370.616628,
    user: '75',
    date: '2024-09-27T13:33:09Z',
    status: 'completed',
  },
  {
    id: '26136982-95b2-44e0-9133-add437503399',
    currency: 'GCS',
    amount: -6565.962438,
    user: '22',
    date: '2024-10-15T16:55:53Z',
    status: 'inProgress',
  },
  {
    id: 'ddeb06b0-994c-4076-b9c5-fb8d1cbf4fd6',
    currency: 'ICS',
    amount: 9997.791092,
    user: '20',
    date: '2024-03-09T10:24:13Z',
    status: 'inProgress',
  },
  {
    id: '7f6242e2-fb42-4201-9025-6b5783e0cbab',
    currency: 'ICS',
    amount: -2565.660412,
    user: '17',
    date: '2024-03-20T09:35:55Z',
    status: 'blocked',
  },
  {
    id: '161c47a0-a50f-499f-8ed5-3973e0a76de5',
    currency: 'ICS',
    amount: 9845.793382,
    user: '61',
    date: '2024-11-08T16:09:50Z',
    status: 'completed',
  },
  {
    id: 'aa20d008-47f3-423f-b4cd-88c327ea5563',
    currency: 'ICS',
    amount: -778.397805,
    user: '54',
    date: '2024-04-13T01:55:01Z',
    status: 'blocked',
  },
  {
    id: 'd3f6b14c-9867-41a2-b495-4008600c38c4',
    currency: 'GCS',
    amount: 2868.598913,
    user: '38',
    date: '2024-03-11T08:48:35Z',
    status: 'blocked',
  },
  {
    id: 'c3cac934-124b-43ec-9a85-7250958e8d1b',
    currency: 'ICS',
    amount: 977.563743,
    user: '72',
    date: '2024-10-16T20:50:12Z',
    status: 'inProgress',
  },
  {
    id: 'b8d58200-adbc-40fb-b7d7-e006fc0eef82',
    currency: 'GCS',
    amount: -9532.629565,
    user: '31',
    date: '2024-11-06T10:52:59Z',
    status: 'inProgress',
  },
  {
    id: '73b6c7b5-ca61-4e15-b273-9a1580d7b3f8',
    currency: 'GCS',
    amount: -6718.313134,
    user: '56',
    date: '2024-11-11T17:13:59Z',
    status: 'completed',
  },
  {
    id: '10334b5a-46ed-4997-bfaa-1222979a237a',
    currency: 'ICS',
    amount: -1925.242908,
    user: '11',
    date: '2024-08-09T04:07:26Z',
    status: 'blocked',
  },
  {
    id: 'dae54a79-5354-4e90-98ef-6adccef6cdbc',
    currency: 'GCS',
    amount: 9254.532724,
    user: '70',
    date: '2024-10-21T12:41:48Z',
    status: 'blocked',
  },
  {
    id: 'bb533232-7c83-412f-a0d8-7ac99f709c46',
    currency: 'ICS',
    amount: 8478.488378,
    user: '25',
    date: '2024-02-15T19:23:45Z',
    status: 'inProgress',
  },
  {
    id: '8fd5bc01-b935-47cc-bc4f-baa2d60253c9',
    currency: 'GCS',
    amount: 3816.428656,
    user: '59',
    date: '2024-08-02T15:49:53Z',
    status: 'completed',
  },
  {
    id: 'dea7dd83-d15a-4a10-93d8-d6224df57a14',
    currency: 'ICS',
    amount: 8799.846929,
    user: '15',
    date: '2024-04-20T08:44:45Z',
    status: 'blocked',
  },
  {
    id: '2a735154-2114-417e-99b6-972705b10b65',
    currency: 'GCS',
    amount: 4342.634644,
    user: '23',
    date: '2024-02-11T05:49:30Z',
    status: 'completed',
  },
  {
    id: 'ce74535e-1c35-4037-845b-3e0ba1f5e273',
    currency: 'GCS',
    amount: -905.31,
    user: '74',
    date: '2024-11-09T10:50:37Z',
    status: 'inProgress',
  },
  {
    id: '11177efe-5fa5-486f-a0cf-699538a0885d',
    currency: 'ICS',
    amount: 480.39547,
    user: '50',
    date: '2024-08-25T22:07:08Z',
    status: 'blocked',
  },
  {
    id: '579da038-2aec-4beb-8cc1-a9ffabc5ac66',
    currency: 'GCS',
    amount: -8212.217436,
    user: '10',
    date: '2024-01-03T06:20:07Z',
    status: 'blocked',
  },
  {
    id: '61bf0b0a-b358-4e2d-a894-95e401d6f487',
    currency: 'GCS',
    amount: 5110.676452,
    user: '79',
    date: '2024-12-30T13:19:20Z',
    status: 'blocked',
  },
  {
    id: '029ecbee-1d26-4e73-8ab1-d755dfb080b5',
    currency: 'GCS',
    amount: 3931.473339,
    user: '72',
    date: '2024-02-05T10:58:49Z',
    status: 'inProgress',
  },
  {
    id: '3f2d275f-3885-453f-a76e-08fb7f8490de',
    currency: 'GCS',
    amount: 2096.95677,
    user: '73',
    date: '2024-09-17T22:08:48Z',
    status: 'completed',
  },
  {
    id: 'cce373b9-d85a-4b57-85a8-d8350a9171db',
    currency: 'ICS',
    amount: -5468.343621,
    user: '1',
    date: '2024-02-18T18:23:59Z',
    status: 'blocked',
  },
  {
    id: '93d65d7b-e958-4c14-bf2f-07b4d787dbfd',
    currency: 'ICS',
    amount: 1767.130613,
    user: '44',
    date: '2024-09-20T18:31:53Z',
    status: 'completed',
  },
  {
    id: '14536809-d1b0-46e0-8289-0b4cdeca1961',
    currency: 'GCS',
    amount: -9884.866934,
    user: '57',
    date: '2024-03-10T14:16:25Z',
    status: 'completed',
  },
  {
    id: '294807fe-dce0-4eda-ac84-228efe58d87c',
    currency: 'ICS',
    amount: 3972.413923,
    user: '54',
    date: '2024-05-08T15:31:40Z',
    status: 'inProgress',
  },
  {
    id: '219c740f-80a4-4fbb-9bbe-b80161ee2507',
    currency: 'GCS',
    amount: 5001.011884,
    user: '46',
    date: '2024-09-13T15:56:06Z',
    status: 'completed',
  },
  {
    id: '1a9d9b2a-d508-4ca6-ae43-edbeab19e44d',
    currency: 'ICS',
    amount: -3827.72486,
    user: '45',
    date: '2024-04-14T03:00:59Z',
    status: 'blocked',
  },
  {
    id: 'b8b56ce9-1eea-4ec2-b396-6e495c8b84eb',
    currency: 'GCS',
    amount: 7286.483436,
    user: '28',
    date: '2024-06-28T07:50:52Z',
    status: 'completed',
  },
  {
    id: '91bb7181-90c0-428a-8716-b8b108e93505',
    currency: 'ICS',
    amount: -8736.142871,
    user: '26',
    date: '2024-04-12T12:20:49Z',
    status: 'inProgress',
  },
  {
    id: '15806e8b-cc34-49ca-b9b4-4a96fbb9bde2',
    currency: 'ICS',
    amount: 8117.55675,
    user: '66',
    date: '2024-09-19T06:19:43Z',
    status: 'blocked',
  },
  {
    id: '10e345e7-7075-43f4-b76e-c976960132cc',
    currency: 'ICS',
    amount: -4322.998029,
    user: '56',
    date: '2024-12-08T11:27:24Z',
    status: 'completed',
  },
  {
    id: '00e3ce98-b090-49ea-99dd-2633c3fe2831',
    currency: 'ICS',
    amount: -2919.082616,
    user: '5',
    date: '2024-02-28T06:25:21Z',
    status: 'inProgress',
  },
  {
    id: '6ec962f6-1d05-475d-86bc-f1cf096f7782',
    currency: 'ICS',
    amount: 636.804367,
    user: '64',
    date: '2024-06-18T18:08:50Z',
    status: 'blocked',
  },
  {
    id: '2dd1da3d-9f56-4b36-807c-3a3f3200722d',
    currency: 'ICS',
    amount: 7247.25609,
    user: '50',
    date: '2024-07-21T07:51:03Z',
    status: 'completed',
  },
  {
    id: 'c99ee985-c649-4b7b-a616-3528fa4356b2',
    currency: 'ICS',
    amount: -9674.23205,
    user: '82',
    date: '2024-12-14T23:35:26Z',
    status: 'completed',
  },
  {
    id: '43ea2b68-52f1-4e68-90a3-6b2eb377ca67',
    currency: 'ICS',
    amount: 7889.183032,
    user: '26',
    date: '2024-09-10T23:35:35Z',
    status: 'completed',
  },
  {
    id: 'b7dbfe4f-db62-43d4-af87-47237780bd66',
    currency: 'GCS',
    amount: 8591.554453,
    user: '52',
    date: '2024-04-29T11:13:51Z',
    status: 'completed',
  },
  {
    id: '949dcb57-6eba-4715-b730-ef28294d2039',
    currency: 'ICS',
    amount: 1221.099731,
    user: '63',
    date: '2024-08-27T04:46:28Z',
    status: 'inProgress',
  },
  {
    id: '79f42704-bec5-489a-bff9-e8c061943455',
    currency: 'ICS',
    amount: 5107.614647,
    user: '15',
    date: '2024-10-14T03:44:30Z',
    status: 'blocked',
  },
  {
    id: '036d6664-b3ca-4026-a8bf-b783fa95a06b',
    currency: 'GCS',
    amount: 1796.89469,
    user: '60',
    date: '2024-12-17T15:22:29Z',
    status: 'blocked',
  },
  {
    id: '4ee39439-6ea3-44fd-84a8-7f04a3819af6',
    currency: 'GCS',
    amount: -9956.945252,
    user: '28',
    date: '2024-12-18T00:51:24Z',
    status: 'blocked',
  },
  {
    id: '1d042d79-e342-4ab5-ab1e-f1fe8a9aa7e3',
    currency: 'ICS',
    amount: -9003.439768,
    user: '30',
    date: '2024-05-04T11:23:41Z',
    status: 'blocked',
  },
  {
    id: 'eb11e6de-3452-42b7-94cc-6c72bcd75072',
    currency: 'GCS',
    amount: -7554.489807,
    user: '82',
    date: '2024-02-11T05:11:32Z',
    status: 'inProgress',
  },
  {
    id: 'a8fc8571-f1e3-468d-9bde-357ac1706169',
    currency: 'GCS',
    amount: -1769.822329,
    user: '28',
    date: '2024-02-16T15:53:49Z',
    status: 'completed',
  },
  {
    id: '3ca259e2-5cdf-4ad3-9d20-9605a193ca1a',
    currency: 'GCS',
    amount: -7362.214821,
    user: '57',
    date: '2024-02-05T14:50:53Z',
    status: 'inProgress',
  },
  {
    id: '836055c8-c796-48c6-83ca-fda491457a12',
    currency: 'ICS',
    amount: 6431.359058,
    user: '19',
    date: '2024-01-15T05:18:52Z',
    status: 'inProgress',
  },
  {
    id: 'c6b10329-4d9c-413d-b430-bd05992da52c',
    currency: 'ICS',
    amount: 5680.407005,
    user: '2',
    date: '2024-04-30T00:31:32Z',
    status: 'completed',
  },
  {
    id: '96069cf0-4b7e-482e-9405-cf4baf417db3',
    currency: 'ICS',
    amount: -1955.14355,
    user: '62',
    date: '2024-01-30T23:25:48Z',
    status: 'blocked',
  },
  {
    id: 'e71b88e2-5c1c-41f9-9231-6d88d9875c2c',
    currency: 'ICS',
    amount: 8597.98907,
    user: '14',
    date: '2024-10-13T06:17:34Z',
    status: 'blocked',
  },
  {
    id: '8cca32a8-2580-46d7-bfa2-e7215aa6d3c2',
    currency: 'ICS',
    amount: 4542.246279,
    user: '7',
    date: '2024-04-06T17:38:33Z',
    status: 'completed',
  },
  {
    id: 'b571ffa0-a95b-4065-928d-2e0e4257d1a8',
    currency: 'GCS',
    amount: 8326.168598,
    user: '49',
    date: '2024-03-14T10:26:34Z',
    status: 'inProgress',
  },
  {
    id: '9374c86e-0d19-45cf-98fd-c87cd9ce8a92',
    currency: 'ICS',
    amount: -1735.323206,
    user: '22',
    date: '2024-07-27T06:31:25Z',
    status: 'blocked',
  },
  {
    id: '25edea5e-3f18-490f-8b39-f3e8fa5f3686',
    currency: 'GCS',
    amount: 6231.513887,
    user: '12',
    date: '2024-01-13T23:12:10Z',
    status: 'blocked',
  },
  {
    id: '207207a3-e936-4c67-b59a-ed4fda7543f1',
    currency: 'GCS',
    amount: -3901.039183,
    user: '57',
    date: '2024-05-31T08:27:25Z',
    status: 'completed',
  },
  {
    id: '755d7ab5-85ff-4075-96ae-fb5625049194',
    currency: 'ICS',
    amount: -1913.379274,
    user: '32',
    date: '2024-01-16T07:37:45Z',
    status: 'blocked',
  },
  {
    id: '8c4de1ff-3141-4076-9fdc-a651896e7100',
    currency: 'ICS',
    amount: -1839.767984,
    user: '59',
    date: '2024-03-30T13:28:32Z',
    status: 'completed',
  },
  {
    id: '9f2db3e2-b5e1-4f34-bf80-108a91e171ce',
    currency: 'GCS',
    amount: -5371.441978,
    user: '62',
    date: '2024-09-30T04:38:41Z',
    status: 'inProgress',
  },
  {
    id: '86b79deb-4666-47ec-86af-a5bd0dcc91ba',
    currency: 'ICS',
    amount: 6780.988487,
    user: '32',
    date: '2024-06-25T15:28:35Z',
    status: 'completed',
  },
  {
    id: 'f696ed8d-03da-4f86-a8fe-1a738d7f9a0d',
    currency: 'ICS',
    amount: -5429.226315,
    user: '74',
    date: '2024-12-28T23:15:01Z',
    status: 'blocked',
  },
  {
    id: '5b07dfad-092f-4366-900f-fbb298da5604',
    currency: 'ICS',
    amount: 7071.073228,
    user: '11',
    date: '2024-07-22T16:03:56Z',
    status: 'inProgress',
  },
  {
    id: '55847511-bcda-4ba1-8337-081e5f44a57c',
    currency: 'GCS',
    amount: -3351.569058,
    user: '23',
    date: '2024-02-24T15:47:25Z',
    status: 'blocked',
  },
  {
    id: '4a4ad2c9-f768-4a46-9393-bb05f497bead',
    currency: 'GCS',
    amount: -1198.351167,
    user: '47',
    date: '2024-04-02T13:48:26Z',
    status: 'blocked',
  },
  {
    id: 'f6d0e83b-d02e-4d53-b880-4bc4de17cb4d',
    currency: 'GCS',
    amount: -2734.679321,
    user: '18',
    date: '2024-03-15T05:49:51Z',
    status: 'completed',
  },
  {
    id: '22047591-9feb-43ce-aed2-039254cbc3c3',
    currency: 'ICS',
    amount: -2729.738587,
    user: '76',
    date: '2024-04-28T08:37:59Z',
    status: 'inProgress',
  },
  {
    id: '1236718e-9ecc-425f-b72e-9c4ea10266a6',
    currency: 'ICS',
    amount: -4473.532558,
    user: '16',
    date: '2024-10-12T19:59:56Z',
    status: 'completed',
  },
  {
    id: '03e4bdfd-f20a-433c-a97a-a2eeaebbb450',
    currency: 'GCS',
    amount: -2752.033538,
    user: '82',
    date: '2024-04-11T16:00:41Z',
    status: 'inProgress',
  },
  {
    id: 'f0a4c3d5-5ae9-4196-bf73-60a1592119ee',
    currency: 'ICS',
    amount: -1485.101208,
    user: '43',
    date: '2024-11-30T10:23:37Z',
    status: 'inProgress',
  },
  {
    id: '6631367e-9074-4175-9de8-4bd510acf3ea',
    currency: 'GCS',
    amount: -5452.259554,
    user: '43',
    date: '2024-12-16T12:59:20Z',
    status: 'completed',
  },
  {
    id: 'ae8b87da-56f2-428b-b50e-a628ccbf0d3c',
    currency: 'ICS',
    amount: 7121.945607,
    user: '33',
    date: '2024-06-09T23:24:05Z',
    status: 'inProgress',
  },
  {
    id: '41f35376-eedd-476c-8fab-a300b82f9ceb',
    currency: 'GCS',
    amount: -6749.836575,
    user: '29',
    date: '2024-02-21T03:15:12Z',
    status: 'completed',
  },
  {
    id: '7914b311-d052-4f3c-8526-ded2c10ee47a',
    currency: 'GCS',
    amount: 6598.078145,
    user: '21',
    date: '2024-09-04T04:14:42Z',
    status: 'completed',
  },
  {
    id: '80423c51-8ed5-43cc-b39f-de7b1a87f43a',
    currency: 'GCS',
    amount: 7407.853869,
    user: '51',
    date: '2024-12-22T23:00:47Z',
    status: 'inProgress',
  },
  {
    id: 'b2f04bdb-9c1d-48ae-91bb-89e60f0b5071',
    currency: 'GCS',
    amount: 3490.189409,
    user: '16',
    date: '2024-07-30T02:03:51Z',
    status: 'inProgress',
  },
  {
    id: '900a6bc5-b345-44fa-be49-f021b357cf9c',
    currency: 'GCS',
    amount: 7102.631314,
    user: '12',
    date: '2024-12-19T15:59:07Z',
    status: 'completed',
  },
  {
    id: 'e20e943b-5bd8-4eb8-b80f-a882cb9e6b76',
    currency: 'GCS',
    amount: -4863.126594,
    user: '46',
    date: '2024-02-17T01:54:09Z',
    status: 'completed',
  },
  {
    id: '33389098-8fea-4076-b470-9f4f9d7713ae',
    currency: 'ICS',
    amount: 6135.83232,
    user: '76',
    date: '2024-09-27T11:13:07Z',
    status: 'completed',
  },
  {
    id: 'fbea7f3c-09c6-4a86-93aa-84e2202f4cbf',
    currency: 'GCS',
    amount: -7059.488779,
    user: '64',
    date: '2024-02-08T16:59:52Z',
    status: 'blocked',
  },
  {
    id: '920043c5-e96c-4413-a0b4-a6f7d2f55d6c',
    currency: 'ICS',
    amount: -218.512854,
    user: '73',
    date: '2024-09-21T07:11:56Z',
    status: 'completed',
  },
  {
    id: '7768fda0-7b69-4569-9ad3-da03e267e9a4',
    currency: 'GCS',
    amount: -4695.413786,
    user: '11',
    date: '2024-12-05T14:00:08Z',
    status: 'inProgress',
  },
  {
    id: '845cea47-cfb3-498e-927e-13144615718e',
    currency: 'GCS',
    amount: 372.035568,
    user: '51',
    date: '2024-01-20T15:14:15Z',
    status: 'completed',
  },
  {
    id: '1d91ad00-3602-4b4c-b2ae-14b2e58e75c9',
    currency: 'GCS',
    amount: 1144.876809,
    user: '55',
    date: '2024-12-06T06:13:36Z',
    status: 'inProgress',
  },
  {
    id: 'f6c841a5-7659-4b01-8d37-e694f6ecdf87',
    currency: 'GCS',
    amount: 9276.536077,
    user: '69',
    date: '2024-12-05T02:58:19Z',
    status: 'completed',
  },
  {
    id: '84c1afb2-ee5d-49a1-b100-0085f8e948c9',
    currency: 'GCS',
    amount: 7340.57272,
    user: '22',
    date: '2024-06-27T22:39:16Z',
    status: 'completed',
  },
  {
    id: 'a0220900-6298-4281-bd2a-51b396128082',
    currency: 'ICS',
    amount: -993.87239,
    user: '40',
    date: '2024-04-17T02:59:30Z',
    status: 'inProgress',
  },
  {
    id: '75624a61-97f1-4df1-b2a3-852d3ee0b347',
    currency: 'GCS',
    amount: 3338.369344,
    user: '73',
    date: '2024-01-19T12:47:51Z',
    status: 'inProgress',
  },
  {
    id: '4895807f-a365-4d8c-976b-d7797154bab3',
    currency: 'ICS',
    amount: 5170.939876,
    user: '30',
    date: '2024-11-25T00:06:25Z',
    status: 'blocked',
  },
  {
    id: '2d9f6972-2512-425a-8d5b-31d5d0096377',
    currency: 'GCS',
    amount: 244.851729,
    user: '9',
    date: '2024-02-27T06:13:44Z',
    status: 'completed',
  },
  {
    id: '8b35f237-9620-415e-988b-ac58c7f59553',
    currency: 'ICS',
    amount: -3531.807422,
    user: '29',
    date: '2024-07-15T23:31:42Z',
    status: 'blocked',
  },
  {
    id: '53374277-106a-452e-bca0-664aa26afa10',
    currency: 'ICS',
    amount: 4289.206985,
    user: '58',
    date: '2024-01-05T02:24:11Z',
    status: 'inProgress',
  },
  {
    id: '4f747bcc-b2a6-4abb-84e5-ec43c9d58602',
    currency: 'ICS',
    amount: -5412.512583,
    user: '3',
    date: '2024-07-27T21:28:18Z',
    status: 'blocked',
  },
  {
    id: 'f4bbd5f2-28d5-4420-9e83-83c7d428e42f',
    currency: 'GCS',
    amount: -9064.246474,
    user: '24',
    date: '2024-06-10T11:27:28Z',
    status: 'blocked',
  },
  {
    id: '9c6c404d-4512-4c56-8174-68e21f2ec283',
    currency: 'GCS',
    amount: 5861.537577,
    user: '67',
    date: '2024-02-05T13:27:10Z',
    status: 'inProgress',
  },
  {
    id: 'bf126692-9fce-4747-a0cd-668c2c18052c',
    currency: 'GCS',
    amount: -5969.848374,
    user: '67',
    date: '2024-09-24T11:20:19Z',
    status: 'inProgress',
  },
  {
    id: 'e242dc33-c51e-4911-8eef-6a3ddf342cbd',
    currency: 'GCS',
    amount: 219.336549,
    user: '57',
    date: '2024-12-17T05:54:59Z',
    status: 'blocked',
  },
  {
    id: '8ef46819-1f2e-44dd-aabc-589df1ff2429',
    currency: 'GCS',
    amount: -1843.746211,
    user: '79',
    date: '2024-09-03T13:35:14Z',
    status: 'completed',
  },
  {
    id: 'a9136eba-0306-42b7-8d5b-01dc83737521',
    currency: 'ICS',
    amount: 71.989971,
    user: '63',
    date: '2024-12-12T14:54:46Z',
    status: 'blocked',
  },
  {
    id: '5b52b7b5-d7fe-4a93-9fae-07911158a2c2',
    currency: 'ICS',
    amount: 3302.346567,
    user: '57',
    date: '2024-10-24T04:37:14Z',
    status: 'blocked',
  },
  {
    id: 'e4398d52-51ce-48a8-8766-fb4ff97bd8c9',
    currency: 'GCS',
    amount: -7677.257622,
    user: '67',
    date: '2024-01-09T13:08:18Z',
    status: 'inProgress',
  },
  {
    id: 'ac204dea-de14-453c-b57e-5e4605df77d6',
    currency: 'ICS',
    amount: -3491.438476,
    user: '83',
    date: '2024-06-14T05:34:40Z',
    status: 'inProgress',
  },
  {
    id: '6e3e27e0-9be9-4a19-9671-18f83d89aa6c',
    currency: 'GCS',
    amount: -4685.079177,
    user: '76',
    date: '2024-10-03T00:05:10Z',
    status: 'completed',
  },
  {
    id: '220b0795-0fcd-4cd3-bbac-91df7f5304a5',
    currency: 'ICS',
    amount: -7466.388802,
    user: '49',
    date: '2024-01-09T09:46:59Z',
    status: 'completed',
  },
  {
    id: 'efa58118-721a-4e5e-99ab-c651c9641137',
    currency: 'ICS',
    amount: -1518.406466,
    user: '23',
    date: '2024-10-17T19:43:45Z',
    status: 'completed',
  },
  {
    id: '9cf70e53-4359-4f45-be69-42421624a9e9',
    currency: 'GCS',
    amount: 7074.279007,
    user: '14',
    date: '2024-08-16T21:11:02Z',
    status: 'blocked',
  },
  {
    id: 'e2394c36-c319-4c8e-a43f-40fa99a1b7c9',
    currency: 'ICS',
    amount: 6896.155529,
    user: '64',
    date: '2024-03-08T05:24:04Z',
    status: 'completed',
  },
  {
    id: 'b5b889c1-f47d-43cf-80db-b83301694182',
    currency: 'GCS',
    amount: -5455.74779,
    user: '24',
    date: '2024-08-10T02:25:39Z',
    status: 'blocked',
  },
  {
    id: '476f9168-2751-4b75-94f5-ae2d110810b9',
    currency: 'ICS',
    amount: -6311.13015,
    user: '45',
    date: '2024-05-12T09:04:58Z',
    status: 'completed',
  },
  {
    id: 'd1e945d1-9c44-4e27-b266-e6b0102389c5',
    currency: 'ICS',
    amount: 4833.011045,
    user: '65',
    date: '2024-01-24T22:13:03Z',
    status: 'inProgress',
  },
  {
    id: 'ccfb0a01-1b52-43a4-a7e8-1aaf392dc124',
    currency: 'ICS',
    amount: 563.633352,
    user: '18',
    date: '2024-09-26T09:21:49Z',
    status: 'inProgress',
  },
  {
    id: '5e96cb7b-fb23-4f67-9048-cc02000940f1',
    currency: 'ICS',
    amount: -6250.152382,
    user: '16',
    date: '2024-04-03T16:55:21Z',
    status: 'inProgress',
  },
  {
    id: '7fcb8c90-fae0-4fd7-a96f-aa41da5471a7',
    currency: 'ICS',
    amount: -3318.56646,
    user: '58',
    date: '2024-04-13T17:54:15Z',
    status: 'inProgress',
  },
  {
    id: '074f4993-9a28-4775-a0fe-b9b52c7e0197',
    currency: 'ICS',
    amount: 669.75988,
    user: '69',
    date: '2024-09-14T08:25:39Z',
    status: 'inProgress',
  },
  {
    id: 'cfdcc761-87f2-40e7-aa7a-dbb34bb4b582',
    currency: 'GCS',
    amount: 3159.955349,
    user: '44',
    date: '2024-03-03T01:22:24Z',
    status: 'inProgress',
  },
  {
    id: '6b4bf902-7e24-4182-bebb-4be8a48c512c',
    currency: 'ICS',
    amount: 295.754478,
    user: '19',
    date: '2024-01-24T00:57:55Z',
    status: 'completed',
  },
  {
    id: '7799d83b-a2d0-434a-a101-0dd49458dfc9',
    currency: 'ICS',
    amount: -7091.237893,
    user: '76',
    date: '2024-09-20T05:22:52Z',
    status: 'completed',
  },
  {
    id: '51cba290-fac8-42c4-90d3-06c8a40baab5',
    currency: 'GCS',
    amount: 8150.384451,
    user: '1',
    date: '2024-10-12T03:54:48Z',
    status: 'completed',
  },
  {
    id: '66d03cd3-f351-4984-988e-cdb2f71ca84f',
    currency: 'GCS',
    amount: -8482.505065,
    user: '15',
    date: '2024-02-16T11:51:09Z',
    status: 'inProgress',
  },
  {
    id: '9cc68d4d-7564-4e91-9618-e31ddbcfbc91',
    currency: 'GCS',
    amount: 4449.196403,
    user: '40',
    date: '2024-02-26T04:22:46Z',
    status: 'blocked',
  },
  {
    id: 'a9e55883-87ac-4a29-8e58-d1d3314e0dc5',
    currency: 'ICS',
    amount: 4879.942321,
    user: '62',
    date: '2024-06-29T00:41:08Z',
    status: 'blocked',
  },
  {
    id: 'ebaf52e5-8c46-4e6d-9c96-55e210fba982',
    currency: 'ICS',
    amount: 1626.621247,
    user: '79',
    date: '2024-10-03T09:09:56Z',
    status: 'completed',
  },
  {
    id: 'b33f0663-068f-43d9-afe0-cec8e595628a',
    currency: 'ICS',
    amount: -4103.824908,
    user: '20',
    date: '2024-12-08T06:15:24Z',
    status: 'inProgress',
  },
  {
    id: 'beeebb68-5d52-42b6-a7ba-6cfb196f67a5',
    currency: 'GCS',
    amount: 8021.412029,
    user: '19',
    date: '2024-08-07T13:06:16Z',
    status: 'blocked',
  },
  {
    id: '6086c15b-2a8f-4480-8eb7-ad2db5d2d37c',
    currency: 'ICS',
    amount: 8042.451396,
    user: '41',
    date: '2024-03-25T12:06:44Z',
    status: 'blocked',
  },
  {
    id: 'f29b3d3e-587b-439d-84b0-d3a0a23c9221',
    currency: 'ICS',
    amount: 340.677661,
    user: '54',
    date: '2024-03-13T14:55:14Z',
    status: 'completed',
  },
  {
    id: '891a8718-175f-499b-b078-8ce2d4ceebd1',
    currency: 'GCS',
    amount: -2181.246104,
    user: '71',
    date: '2024-08-30T03:21:41Z',
    status: 'inProgress',
  },
  {
    id: '7a676f30-2151-42d9-9974-4a5a7abc5b79',
    currency: 'GCS',
    amount: -3316.78346,
    user: '39',
    date: '2024-05-09T09:10:15Z',
    status: 'completed',
  },
  {
    id: 'b1a5cc1f-6f38-4921-ab00-c5b067e6e165',
    currency: 'GCS',
    amount: -3916.094946,
    user: '68',
    date: '2024-07-17T11:15:33Z',
    status: 'inProgress',
  },
  {
    id: 'e981dcec-1a59-45ac-8a41-eb91b870dacb',
    currency: 'GCS',
    amount: 7791.194156,
    user: '24',
    date: '2024-06-07T01:33:34Z',
    status: 'inProgress',
  },
  {
    id: '408c2636-d367-480a-a838-d06980f60c69',
    currency: 'ICS',
    amount: 538.735845,
    user: '83',
    date: '2024-07-03T04:20:11Z',
    status: 'completed',
  },
  {
    id: 'c5c5d146-5464-49c7-9f48-907db9c0f807',
    currency: 'GCS',
    amount: 8469.626931,
    user: '24',
    date: '2024-07-15T17:40:52Z',
    status: 'blocked',
  },
  {
    id: 'cc77bf22-e64b-4f15-a8d7-ab111582c87a',
    currency: 'ICS',
    amount: -695.783427,
    user: '4',
    date: '2024-09-21T08:08:27Z',
    status: 'inProgress',
  },
  {
    id: '078c4f88-32c6-40c6-9d42-e1c867b5f8ea',
    currency: 'GCS',
    amount: -1089.33775,
    user: '1',
    date: '2024-02-29T09:37:46Z',
    status: 'completed',
  },
  {
    id: '69949552-5dea-4b8b-adb3-885a229db75d',
    currency: 'ICS',
    amount: -6706.710024,
    user: '50',
    date: '2024-04-28T02:34:40Z',
    status: 'inProgress',
  },
  {
    id: 'fe46706c-cc10-46bc-a2fb-09332cb16fca',
    currency: 'GCS',
    amount: 7294.497892,
    user: '52',
    date: '2024-12-30T23:24:41Z',
    status: 'inProgress',
  },
  {
    id: 'd5bafb95-6812-40c3-9c54-22e1f6af2146',
    currency: 'ICS',
    amount: -5085.410074,
    user: '55',
    date: '2024-02-29T14:47:24Z',
    status: 'completed',
  },
  {
    id: 'b5eb3efc-2861-41ed-8c46-d0969252a0b6',
    currency: 'ICS',
    amount: -6834.900191,
    user: '58',
    date: '2024-12-09T15:57:21Z',
    status: 'blocked',
  },
  {
    id: '236922d9-d6cc-4f9c-8b4e-284aa7bbc05d',
    currency: 'ICS',
    amount: 8083.287815,
    user: '56',
    date: '2024-07-17T08:52:04Z',
    status: 'blocked',
  },
  {
    id: '91b6aa09-fabc-4320-9acc-e2343e180e4b',
    currency: 'ICS',
    amount: -6530.838028,
    user: '17',
    date: '2024-05-13T01:53:19Z',
    status: 'inProgress',
  },
  {
    id: 'b0c71152-fe48-443a-b2b4-af41ce8d854b',
    currency: 'ICS',
    amount: 3006.229192,
    user: '13',
    date: '2024-04-24T21:18:23Z',
    status: 'completed',
  },
  {
    id: '59dc0b80-cbd8-4543-b272-2646d1beeaea',
    currency: 'GCS',
    amount: 5802.798258,
    user: '37',
    date: '2024-07-13T14:35:12Z',
    status: 'blocked',
  },
  {
    id: '7675a151-ba00-4265-aa3b-7c7bfb7e0cf2',
    currency: 'GCS',
    amount: 9719.869224,
    user: '38',
    date: '2024-11-24T00:13:25Z',
    status: 'blocked',
  },
  {
    id: '70e6fa9a-2c26-4226-877a-4ad9b4fd9677',
    currency: 'ICS',
    amount: -412.901111,
    user: '5',
    date: '2024-08-21T13:27:38Z',
    status: 'inProgress',
  },
  {
    id: '60631745-ada6-4dc1-876a-65d165727815',
    currency: 'GCS',
    amount: -2719.934193,
    user: '63',
    date: '2024-05-27T05:59:47Z',
    status: 'completed',
  },
  {
    id: '8b6cf2a1-2f63-4be9-8b5f-ea78a1030c95',
    currency: 'GCS',
    amount: -537.869961,
    user: '46',
    date: '2024-02-19T00:03:12Z',
    status: 'completed',
  },
  {
    id: 'b3a715e9-77d8-4635-a918-57cdca32f655',
    currency: 'GCS',
    amount: -893.488174,
    user: '53',
    date: '2024-08-31T05:07:56Z',
    status: 'blocked',
  },
  {
    id: 'e6956980-08a1-42fb-add6-3adcd2ddcc26',
    currency: 'GCS',
    amount: -2445.521778,
    user: '25',
    date: '2024-06-02T16:55:47Z',
    status: 'inProgress',
  },
  {
    id: '81fff035-94a3-42b2-8334-f5cbc0882761',
    currency: 'GCS',
    amount: 1927.540629,
    user: '31',
    date: '2024-11-22T22:45:32Z',
    status: 'completed',
  },
  {
    id: '0bc85d95-42a9-443c-a2fe-47785c6dd648',
    currency: 'ICS',
    amount: 2569.101161,
    user: '25',
    date: '2024-05-11T12:30:18Z',
    status: 'blocked',
  },
  {
    id: '893eac3c-da14-4beb-995f-68534054f2db',
    currency: 'GCS',
    amount: 9687.973056,
    user: '81',
    date: '2024-07-03T02:42:36Z',
    status: 'inProgress',
  },
  {
    id: '5df74071-9a56-4126-b2b2-2324e7104b2b',
    currency: 'ICS',
    amount: 9500.07508,
    user: '79',
    date: '2024-08-18T17:08:10Z',
    status: 'completed',
  },
  {
    id: '98db3fa6-0472-4e97-a920-d59d9a2d1336',
    currency: 'GCS',
    amount: -1380.102871,
    user: '65',
    date: '2024-06-02T05:57:42Z',
    status: 'inProgress',
  },
  {
    id: '9c7ea49f-6e51-4bdf-89d7-78c1fdd70613',
    currency: 'ICS',
    amount: 1113.055895,
    user: '20',
    date: '2024-11-20T03:27:18Z',
    status: 'inProgress',
  },
  {
    id: '06087688-5605-4e07-80d2-60e3f5fd080d',
    currency: 'ICS',
    amount: 950.75194,
    user: '25',
    date: '2024-04-10T09:15:20Z',
    status: 'inProgress',
  },
  {
    id: 'eba59cbc-741f-43c7-a8c8-a82ef66533ca',
    currency: 'GCS',
    amount: -8999.402027,
    user: '29',
    date: '2024-12-07T21:19:19Z',
    status: 'completed',
  },
  {
    id: '115bb722-0c40-4e0d-920a-3e0996eb5938',
    currency: 'ICS',
    amount: -7985.759273,
    user: '72',
    date: '2024-08-02T20:46:28Z',
    status: 'completed',
  },
  {
    id: '4b812a8e-672d-440f-9653-8b3c61edd17a',
    currency: 'GCS',
    amount: 6699.736239,
    user: '63',
    date: '2024-12-17T20:46:20Z',
    status: 'completed',
  },
  {
    id: '843919c9-795b-4312-8399-91982ba7a201',
    currency: 'ICS',
    amount: 9691.176898,
    user: '2',
    date: '2024-12-04T21:43:11Z',
    status: 'inProgress',
  },
  {
    id: '4028a60b-2220-4246-9ef8-b7b31d2055b1',
    currency: 'GCS',
    amount: 3318.698784,
    user: '70',
    date: '2024-12-23T19:42:45Z',
    status: 'blocked',
  },
  {
    id: '231fcfd3-acb9-41f7-8b59-73a8b0804826',
    currency: 'ICS',
    amount: -6231.4314,
    user: '15',
    date: '2024-05-17T23:06:46Z',
    status: 'blocked',
  },
  {
    id: 'cedb0349-5f6e-4f88-a42e-329d3004c0ab',
    currency: 'GCS',
    amount: -5960.435365,
    user: '63',
    date: '2024-12-20T06:57:03Z',
    status: 'inProgress',
  },
  {
    id: 'cc4e1661-6fa9-4307-9999-bfee5c3d0135',
    currency: 'ICS',
    amount: -9421.752537,
    user: '77',
    date: '2024-01-22T11:25:27Z',
    status: 'blocked',
  },
  {
    id: '1d154f08-b1cd-4c03-8592-32f0e6250a64',
    currency: 'ICS',
    amount: 154.223987,
    user: '32',
    date: '2024-09-06T15:15:30Z',
    status: 'completed',
  },
  {
    id: 'e002b0c1-730b-49a8-85f3-5029cc490c7f',
    currency: 'GCS',
    amount: -8096.610738,
    user: '21',
    date: '2024-04-03T08:12:31Z',
    status: 'inProgress',
  },
];

export default transactions;
